import React, { SVGProps } from 'react'

interface IconProps extends SVGProps<SVGSVGElement> {
  id?: string
  size?: number
  color?: string
  isActive?: boolean
  isEnabled?: boolean
  onClick?: () => void
  className?: string
  hoverColor?: string
  cursor?: string
  width?: number
  height?: number
}

interface ChatTheme {
  color: string
  bubbleColor: string
}

export const Send: React.FC<IconProps> = ({ id, color, size = 40, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 45 45"
    fill="none"
    data-testid="send"
    id={id}
    className={className}
    {...rest}>
    <rect width="45" height="45" rx="22.5" fill={color || 'currentColor'} />
    <path
      d="M20.9794 24.0162L29.3394 15.6562M20.9794 24.0162L23.6394 29.3362C23.6727 29.409 23.7263 29.4707 23.7936 29.5139C23.861 29.5571 23.9393 29.5801 24.0194 29.5801C24.0994 29.5801 24.1778 29.5571 24.2451 29.5139C24.3125 29.4707 24.366 29.409 24.3994 29.3362L29.3394 15.6562M20.9794 24.0162L15.6594 21.3562C15.5866 21.3229 15.525 21.2694 15.4817 21.202C15.4385 21.1346 15.4155 21.0563 15.4155 20.9762C15.4155 20.8962 15.4385 20.8179 15.4817 20.7505C15.525 20.6831 15.5866 20.6296 15.6594 20.5962L29.3394 15.6562"
      stroke="white"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Source: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    //stroke={color}
    viewBox="0 0 24 24"
    fill={color}
    data-testid="source"
    id={id}
    className={className}
    {...rest}>
    <path d="M18.5 6V7.5H3V6H18.5ZM3 14.5H12V13H3V14.5ZM3 11H18.5V9.5H3V11Z" fill={color} />
  </svg>
)

export const Eraser: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    data-testid="eraser"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M19.9608 0.608875C19.5755 0.686465 18.989 0.938631 18.6728 1.15847C18.4083 1.33951 17.4365 2.41931 7.26477 13.7992C1.65277 20.0775 1.69811 19.6619 0.566038 20.9349C0.278538 21.5492 0 22.1854 0 22.916C0 23.6466 0.218251 24.2998 0.500001 24.9141C0.684001 25.3085 0.971501 25.6641 2.8 27.7397C3.95575 29.0458 5.09425 30.5665 5.65477 30.463C5.82152 30.5535 6.73002 30.5664 14.0038 30.5664C20.461 30.5664 22.186 30.547 22.301 30.4824C22.6 30.3142 22.5425 29.4594 22.301 29.1879C22.1918 29.065 22.094 29.0585 18.8338 29.0585H15.4873L22.4793 21.2155C29.04 13.8638 29.4885 13.353 29.6553 12.9522C29.9428 12.2538 30.0233 11.8012 29.9945 10.9865C29.96 10.1848 29.8163 9.65458 29.4655 9.05972C29.1608 8.54246 22.8703 1.53349 22.416 1.20373C21.7433 0.712328 20.7083 0.460161 19.9608 0.608875ZM16.988 25.8127L14.1073 29.0585H10.0535L5.99977 29.0521L3.99302 26.8149C2.09552 24.6941 1.97477 24.5519 1.77927 24.0863C1.58377 23.6208 1.57227 23.5626 1.57227 22.916C1.57227 22.166 1.66427 21.8427 2.02652 21.2801C2.12427 21.125 4.03902 18.9524 6.27577 16.4566L10.3468 11.9112L15.1078 17.2325L19.8688 22.5604L16.988 25.8127Z"
      fill={color || 'var(--icon-muted)'}
    />
  </svg>
)

export const Broom: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26 28"
    fill="none"
    data-testid="broom"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M22.7485 0.407097C22.4268 0.375649 22.6648 0.0643041 17.4089 7.37388L12.509 14.1883L11.0078 13.1295C9.52504 12.084 9.49725 12.064 9.21505 12.0265C8.77786 11.9603 8.43413 11.9888 8.10815 12.1196C7.59807 12.3111 7.36366 12.5492 6.55682 13.6713C5.56378 15.0523 4.71871 15.954 3.62957 16.8042C2.83613 17.419 1.6486 18.1227 0.813372 18.4732C0.367846 18.6628 0.161223 18.9208 0.211202 19.2324L0.25133 19.4405L5.65204 23.3238C10.9694 27.1472 11.062 27.2138 11.22 27.1896C11.4629 27.1644 12.4713 26.6904 13.1777 26.2748C14.3285 25.5929 15.373 24.7658 16.3544 23.7623C16.6956 23.4149 17.031 22.9876 17.8 21.9279L18.7963 20.5423L18.8623 20.128C18.9373 19.6719 18.8521 19.2041 18.6302 18.7895C18.489 18.5364 18.4459 18.4985 17.006 17.4425L15.5197 16.3531L17.5744 13.4956C19.041 11.4558 19.638 10.5963 19.6597 10.4879C19.6967 10.2801 19.5222 9.9755 19.3062 9.87529C19.2098 9.83352 19.0436 9.81053 18.9377 9.83083L18.7416 9.86901L17.5386 11.5126L16.3357 13.1563L15.8077 12.7766L15.275 12.3936L19.0806 7.10109L22.8861 1.80858L23.4188 2.19159L23.9514 2.57459L22.7069 4.30545C21.6518 5.77281 18.5498 10.0619 18.5186 10.2324C18.455 10.614 18.8109 10.9595 19.2025 10.9034L19.4316 10.8682L23.8625 4.75045L25.388 2.6289L25.3484 2.40057L25.3088 2.17224L24.086 1.29299C23.3449 0.760115 22.8191 0.416476 22.7485 0.407097ZM15.0991 14.8859L14.5437 15.6582L14.0111 15.2752L13.4784 14.8922L14.0337 14.1199L14.5891 13.3476L15.1217 13.7306L15.6544 14.1136L15.0991 14.8859ZM17.6022 19.4081C17.7792 19.7972 17.7452 19.9519 17.3606 20.5161L17.023 21.0246L12.3171 17.6409L7.61116 14.2571L7.91169 13.8391C8.34287 13.2395 8.72985 13.0629 9.20141 13.2572C9.29322 13.2957 11.1988 14.6521 13.4406 16.264C17.4221 19.1407 17.5147 19.2073 17.6022 19.4081ZM16.269 22.0538C16.122 22.2582 15.2127 23.2101 14.8386 23.5545C13.9567 24.3608 12.9135 25.0786 11.818 25.6348L11.2105 25.9422L10.0386 25.0996L8.86212 24.2537L9.42091 23.9456C10.417 23.4007 11.5715 22.5768 11.6755 22.3345C11.7794 22.0923 11.6894 21.807 11.4671 21.6471C11.1475 21.4173 10.9923 21.4573 10.3107 21.9459C9.60494 22.4584 8.74636 22.9782 8.16032 23.246L7.74122 23.4477L6.58326 22.6151C5.9487 22.1588 5.4332 21.7812 5.43974 21.7722C5.443 21.7676 5.7371 21.5931 6.09164 21.3932C6.77051 21.0061 7.81694 20.2837 8.06906 20.0308C8.23867 19.8633 8.308 19.5617 8.21995 19.3812C8.18533 19.3219 8.08123 19.2126 7.97933 19.1393C7.70606 18.9428 7.4928 18.9755 7.09935 19.2784C6.48752 19.7482 5.93229 20.1002 5.11208 20.5373L4.3044 20.9765L3.13255 20.1339L1.9607 19.2912L2.38224 19.0568C3.57523 18.3846 4.56174 17.6674 5.45586 16.8148C5.92088 16.3635 6.68673 15.5427 6.86639 15.2929C6.92192 15.2157 7.10583 15.341 11.6265 18.5916C16.0777 21.7922 16.3245 21.9765 16.269 22.0538Z"
      fill={color || 'var(--icon-muted)'}
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="0.25"
    />
  </svg>
)

export const Video: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    data-testid="video"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M0.785469 0.28767C-0.0320997 0.794516 0.000172785 0.397257 0.000172785 9.99994C0.000172785 19.6163 -0.0320997 19.2054 0.796227 19.7259C1.24804 19.9999 1.4094 19.9999 9.98312 19.9999C19.4497 19.9999 19.127 20.0273 19.6864 19.2465L19.9553 18.8766L19.9876 10.1917C20.0199 0.356161 20.0521 0.794516 19.213 0.273971C18.7612 3.2835e-08 18.5999 3.2835e-08 9.99388 3.2835e-08C1.36637 3.2835e-08 1.22653 3.2835e-08 0.785469 0.28767ZM3.66847 2.32875C3.84059 2.45204 3.87287 2.63012 3.87287 3.35614C3.87287 4.38354 3.76529 4.52052 2.96924 4.52052C2.32379 4.52052 2.15167 4.27395 2.15167 3.35614C2.15167 2.8767 2.20546 2.54793 2.32379 2.41094C2.51742 2.16437 3.34575 2.10958 3.66847 2.32875ZM7.20769 2.46574C7.35829 2.65752 7.42284 2.91779 7.42284 3.35614C7.42284 4.19176 7.16466 4.52052 6.50845 4.52052C5.85224 4.52052 5.59406 4.19176 5.59406 3.35614C5.59406 2.52053 5.85224 2.19177 6.50845 2.19177C6.85269 2.19177 7.05708 2.27396 7.20769 2.46574ZM10.6608 2.32875C10.833 2.45204 10.8652 2.63012 10.8652 3.35614C10.8652 4.36984 10.7577 4.52052 10.0046 4.52052C9.25161 4.52052 9.14403 4.36984 9.14403 3.35614C9.14403 2.67122 9.18706 2.45204 9.33767 2.34245C9.57433 2.15067 10.3919 2.15067 10.6608 2.32875ZM14.2001 2.46574C14.3507 2.65752 14.4152 2.91779 14.4152 3.35614C14.4152 4.17806 14.1463 4.52052 13.5223 4.52052C12.8123 4.52052 12.5864 4.24655 12.5864 3.35614C12.5864 2.75341 12.6295 2.57533 12.8231 2.41094C13.1781 2.09588 13.9311 2.12328 14.2001 2.46574ZM17.6855 2.41094C17.8038 2.54793 17.8576 2.8767 17.8576 3.35614C17.8576 4.27395 17.6855 4.52052 17.04 4.52052C16.244 4.52052 16.1364 4.38354 16.1364 3.35614C16.1364 2.67122 16.1794 2.45204 16.33 2.34245C16.6205 2.12328 17.4918 2.16437 17.6855 2.41094ZM11.0266 7.78078C14.4152 9.98624 14.4152 10.0273 10.9943 12.2191C9.7357 13.041 8.60616 13.6985 8.48783 13.6985C8.3695 13.6985 8.15435 13.5479 8.0145 13.3561L7.74556 13.0273V9.99994V6.97256L8.0145 6.6438C8.15435 6.45202 8.38025 6.30133 8.5201 6.30133C8.65995 6.31503 9.77873 6.97256 11.0266 7.78078ZM3.66847 15.6163C3.84059 15.7396 3.87287 15.9177 3.87287 16.6437C3.87287 17.6711 3.76529 17.8081 2.96924 17.8081C2.31303 17.8081 2.15167 17.5752 2.15167 16.5752C2.15167 15.9451 2.1947 15.7396 2.3453 15.63C2.58197 15.4383 3.39954 15.4383 3.66847 15.6163ZM7.2292 15.7122C7.36905 15.8629 7.42284 16.1232 7.42284 16.6026C7.42284 17.4793 7.17541 17.8081 6.50845 17.8081C5.863 17.8081 5.59406 17.4657 5.59406 16.6711C5.59406 15.7807 5.81997 15.4794 6.47618 15.4794C6.84193 15.4794 7.10011 15.5616 7.2292 15.7122ZM10.6608 15.6163C10.8222 15.7396 10.8652 15.9177 10.8652 16.5752C10.8652 17.5752 10.7039 17.8081 10.0477 17.8081C9.25161 17.8081 9.14403 17.6711 9.14403 16.6437C9.14403 15.9588 9.18706 15.7396 9.33767 15.63C9.57433 15.4383 10.3919 15.4383 10.6608 15.6163ZM14.2431 15.7807C14.3399 15.9451 14.4152 16.3561 14.4152 16.6711C14.4152 17.4657 14.1463 17.8081 13.5008 17.8081C12.8446 17.8081 12.5864 17.4793 12.5864 16.6163C12.5864 15.7259 12.7908 15.4794 13.5116 15.4794C13.9741 15.4794 14.114 15.5342 14.2431 15.7807ZM17.6855 15.6985C17.8038 15.8355 17.8576 16.1643 17.8576 16.6437C17.8576 17.5615 17.6855 17.8081 17.04 17.8081C16.244 17.8081 16.1364 17.6711 16.1364 16.6437C16.1364 15.9588 16.1794 15.7396 16.33 15.63C16.6205 15.4109 17.4918 15.452 17.6855 15.6985Z"
      fill={color || 'white'}
    />
  </svg>
)
export const LineGraph: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 33 31"
    fill="none"
    data-testid="line-graph"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M28.2838 10.333C26.3569 10.333 25.2805 12.193 25.719 13.5751L21.0015 18.1734C20.6028 18.0572 20.0181 18.0572 19.6194 18.1734L16.2307 14.8797C16.6825 13.4976 15.6061 11.6247 13.6659 11.6247C11.739 11.6247 10.6493 13.4847 11.1012 14.8797L5.04138 20.7568C3.61946 20.3305 1.70585 21.3768 1.70585 23.2497C1.70585 24.6705 2.90186 25.833 4.36365 25.833C6.29055 25.833 7.36696 23.973 6.92842 22.5909L12.9749 16.7009C13.3736 16.8172 13.9583 16.8172 14.357 16.7009L17.7457 19.9947C17.2938 21.3768 18.3702 23.2497 20.3104 23.2497C22.2373 23.2497 23.327 21.3897 22.8752 19.9947L27.6061 15.4093C29.028 15.8355 30.9416 14.7893 30.9416 12.9163C30.9416 11.4955 29.7456 10.333 28.2838 10.333Z"
      fill={color}
    />
    <path
      d="M20.3104 11.625L21.5596 8.95125L24.2971 7.75L21.5596 6.54875L20.3104 3.875L19.0878 6.54875L16.3237 7.75L19.0878 8.95125L20.3104 11.625ZM5.0281 14.2083L5.69254 11.625L8.35034 10.9792L5.69254 10.3333L5.0281 7.75L4.36365 10.3333L1.70585 10.9792L4.36365 11.625L5.0281 14.2083Z"
      fill={color}
    />
  </svg>
)

export const SmartData: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 54 52"
    fill="none"
    data-testid="smart-data"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M46.9946 51.2235H9.15094C5.9842 51.2235 3.41705 48.6564 3.41705 45.4896V36.2999C3.41705 33.1332 5.9842 30.566 9.15094 30.566H26.3526C29.5193 30.566 32.0865 27.9989 32.0865 24.8322V7.64599C32.0865 4.47926 34.6536 1.91211 37.8204 1.91211H46.9946C50.1613 1.91211 52.7285 4.47926 52.7285 7.646V45.4896C52.7285 48.6564 50.1613 51.2235 46.9946 51.2235Z"
      stroke={color}
      strokeWidth="1.14678"
    />
    <path
      d="M26.3526 19.1141V6.49951C26.3526 3.33277 23.7854 0.765625 20.6187 0.765625H6.85736C3.69062 0.765625 1.12347 3.33277 1.12347 6.49951V19.1141C1.12347 22.2808 3.69062 24.8479 6.85735 24.8479H20.6187C23.7854 24.8479 26.3526 22.2808 26.3526 19.1141Z"
      fill={color}
      fillOpacity="0.1"
      stroke={color}
      strokeWidth="1.14678"
    />
  </svg>
)

export const DragDropIcon: React.FC<IconProps> = (props) => (
  <svg
    width="22"
    height="15"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="4" height="4" fill="#D9D9D9" />
    <rect x="6" width="4" height="4" fill="#D9D9D9" />
    <rect x="6" y="6" width="4" height="4" fill="#D9D9D9" />
    <rect y="6" width="4" height="4" fill="#D9D9D9" />
    <rect y="12" width="4" height="4" fill="#D9D9D9" />
    <rect x="6" y="12" width="4" height="4" fill="#D9D9D9" />
  </svg>
)

export const Csv: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 44 58"
    fill="none"
    data-testid="csv"
    id={id}
    className={className}
    {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.0586 0.876953H3.50976C2.02138 0.876953 0.814819 2.04679 0.814819 3.48986V54.4416C0.814819 55.8846 2.02138 57.0545 3.50976 57.0545H40.5651C42.0535 57.0545 43.2601 55.8846 43.2601 54.4416V18.8407H26.6716C25.2285 18.8407 24.0586 17.6709 24.0586 16.2278V0.876953Z"
      fill="white"
    />
    <path
      d="M24.0586 0.876953V16.2278C24.0586 17.6709 25.2285 18.8407 26.6716 18.8407H43.2601L24.0586 0.876953Z"
      fill="#DBE2EA"
    />
    <path
      d="M24.0586 0.876953V16.2278C24.0586 17.6709 25.2285 18.8407 26.6716 18.8407H43.2601M24.0586 0.876953L43.2601 18.8407M24.0586 0.876953H3.50976M43.2601 18.8407V54.4416M3.50976 0.876953C2.02138 0.876953 0.814819 2.04679 0.814819 3.48986M3.50976 0.876953H3.42773C1.98466 0.876953 0.814819 2.04679 0.814819 3.48986V3.48986M43.2601 54.4416C43.2601 55.8846 42.0535 57.0545 40.5651 57.0545M43.2601 54.4416V54.4416C43.2601 55.8846 42.0902 57.0545 40.6472 57.0545H40.5651M40.5651 57.0545H3.50976M3.50976 57.0545C2.02138 57.0545 0.814819 55.8846 0.814819 54.4416M3.50976 57.0545H3.42773C1.98466 57.0545 0.814819 55.8846 0.814819 54.4416V54.4416M0.814819 54.4416V3.48986"
      stroke={color}
      strokeWidth="1.24839"
    />
  </svg>
)

export const Sort: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 22 22"
    data-testid="sort"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M9.66045 13.1049H2.62341M7.90119 9.58637H2.62341M6.14193 6.06785H2.62341M11.4197 16.6234H2.62341M17.5771 18.3827V4.30859M17.5771 18.3827L20.216 15.7438M17.5771 18.3827L14.9382 15.7438M17.5771 4.30859L20.216 6.94748M17.5771 4.30859L14.9382 6.94748"
      stroke={color}
      strokeWidth="1.17284"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Filter: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    data-testid="filter"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M10.6204 8.93218V14.7084C10.6497 14.9283 10.5764 15.1629 10.4078 15.3168C10.34 15.3848 10.2594 15.4387 10.1707 15.4755C10.0821 15.5123 9.98701 15.5312 9.89101 15.5312C9.795 15.5312 9.69994 15.5123 9.61126 15.4755C9.52259 15.4387 9.44204 15.3848 9.37422 15.3168L7.90084 13.8435C7.8209 13.7653 7.76011 13.6697 7.72323 13.5642C7.68635 13.4586 7.67439 13.346 7.68827 13.235V8.93218H7.66628L3.44405 3.52246C3.32502 3.36965 3.2713 3.17593 3.29465 2.98364C3.318 2.79134 3.41652 2.61611 3.56867 2.49623C3.70794 2.3936 3.86188 2.33496 4.02314 2.33496H14.2855C14.4468 2.33496 14.6007 2.3936 14.74 2.49623C14.8921 2.61611 14.9906 2.79134 15.014 2.98364C15.0373 3.17593 14.9836 3.36965 14.8646 3.52246L10.6424 8.93218H10.6204Z"
      fill={color}
    />
  </svg>
)

export const SortAZ: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 9 13"
    data-testid="sort-az"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <g clipPath="url(#clip0_18755_53470)">
      <path
        d="M1.29028 1.47424V10.3208"
        className="svg-stroke"
        stroke={color}
        strokeWidth="0.55291"
      />
      <path d="M1.29019 11.4272L0.172911 9.21561H2.40747L1.29019 11.4272Z" />
      <path
        d="M7.68183 10.8795L7.27772 9.80722H5.61547L5.21136 10.8795H4.69141L6.18123 7H6.71735L8.20987 10.8795H7.68183ZM5.77981 9.36809H7.11068L6.44525 7.60347L5.77981 9.36809Z"
        className="svg-fill"
        fill={color}
        strokeWidth="0.234568"
      />
      <path
        d="M4.69141 5.67927V5.26169L6.92479 2.24702H4.74259V1.7998H7.54712V2.22008L5.31104 5.23205H7.601V5.67927H4.69141Z"
        className="svg-fill"
        fill={color}
        strokeWidth="0.234568"
      />
    </g>
    <defs>
      <clipPath id="clip0_18755_53470">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const SortZA: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 9 13"
    data-testid="sort-za"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <g clipPath="url(#clip0_18755_53465)">
      <path
        d="M1.5249 1.67151V10.5181"
        className="svg-stroke"
        stroke={color}
        strokeWidth="0.55291"
      />
      <path
        d="M1.52481 11.6245L0.40753 9.41287H2.64209L1.52481 11.6245Z"
        className="svg-fill"
        fill={color}
      />
      <path
        d="M7.91645 5.8365L7.51234 4.76426H5.85009L5.44598 5.8365H4.92603L6.41585 1.95703H6.95197L8.44448 5.8365H7.91645ZM6.01443 4.32512H7.3453L6.67987 2.5605L6.01443 4.32512Z"
        fill={color}
        className="svg-fill"
        strokeWidth="0.234568"
      />
      <path
        d="M4.92603 11.1138V10.6963L7.15941 7.68159H4.97721V7.23438H7.78174V7.65465L5.54566 10.6666H7.83562V11.1138H4.92603Z"
        fill={color}
        className="svg-fill"
        strokeWidth="0.234568"
      />
    </g>
    <defs>
      <clipPath id="clip0_18755_53465">
        <rect
          width="8.20988"
          height="12.9012"
          fill="white"
          transform="translate(0.234619 0.197266)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const CsvIcon: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width="14"
    height={size}
    viewBox="0 0 14 18"
    fill="none"
    data-testid="csv-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M7.875 4.78125V0H0.84375C0.376172 0 0 0.376172 0 0.84375V17.1562C0 17.6238 0.376172 18 0.84375 18H12.6562C13.1238 18 13.5 17.6238 13.5 17.1562V5.625H8.71875C8.25469 5.625 7.875 5.24531 7.875 4.78125ZM4.5 9.84375C4.5 9.99914 4.37414 10.125 4.21875 10.125H3.9375C3.62672 10.125 3.375 10.3767 3.375 10.6875V11.8125C3.375 12.1233 3.62672 12.375 3.9375 12.375H4.21875C4.37414 12.375 4.5 12.5009 4.5 12.6562V13.2188C4.5 13.3741 4.37414 13.5 4.21875 13.5H3.9375C3.00551 13.5 2.25 12.7445 2.25 11.8125V10.6875C2.25 9.75551 3.00551 9 3.9375 9H4.21875C4.37414 9 4.5 9.12586 4.5 9.28125V9.84375ZM6.05637 13.5H5.625C5.46961 13.5 5.34375 13.3741 5.34375 13.2188V12.6562C5.34375 12.5009 5.46961 12.375 5.625 12.375H6.05637C6.26555 12.375 6.42234 12.252 6.42234 12.1423C6.42234 12.0966 6.39598 12.0488 6.34781 12.0073L5.57824 11.3474C5.28047 11.0936 5.10961 10.7329 5.10961 10.3581C5.10961 9.60926 5.77828 9.00035 6.60059 9.00035H7.03125C7.18664 9.00035 7.3125 9.12621 7.3125 9.2816V9.8441C7.3125 9.99949 7.18664 10.1254 7.03125 10.1254H6.59988C6.3907 10.1254 6.23391 10.2484 6.23391 10.3581C6.23391 10.4038 6.26027 10.4516 6.30844 10.4931L7.07801 11.153C7.37578 11.4068 7.54664 11.7675 7.54664 12.1423C7.54699 12.8907 6.87867 13.5 6.05637 13.5ZM9 9.28125V10.0125C9 10.7251 9.20039 11.4247 9.5625 12.0122C9.92461 11.4251 10.125 10.7251 10.125 10.0125V9.28125C10.125 9.12586 10.2509 9 10.4062 9H10.9687C11.1241 9 11.25 9.12586 11.25 9.28125V10.0125C11.25 11.2598 10.7972 12.4344 9.97453 13.3204C9.86836 13.4346 9.71894 13.5 9.5625 13.5C9.40605 13.5 9.25664 13.4346 9.15047 13.3204C8.32781 12.4344 7.875 11.2598 7.875 10.0125V9.28125C7.875 9.12586 8.00086 9 8.15625 9H8.71875C8.87414 9 9 9.12586 9 9.28125ZM13.2539 3.69141L9.81211 0.246094C9.65391 0.0878906 9.43945 0 9.21445 0H9V4.5H13.5V4.28555C13.5 4.06406 13.4121 3.84961 13.2539 3.69141Z"
      fill={color || 'var(--icon-muted)'}
    />
  </svg>
)

export const ExcelIcon: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width="14"
    height={size}
    viewBox="0 0 14 18"
    fill="none"
    data-testid="excel-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M7.875 4.78125V0H0.84375C0.376172 0 0 0.376172 0 0.84375V17.1562C0 17.6238 0.376172 18 0.84375 18H12.6562C13.1238 18 13.5 17.6238 13.5 17.1562V5.625H8.71875C8.25469 5.625 7.875 5.24531 7.875 4.78125ZM9.98789 8.52539L7.875 11.8125L9.98789 15.0996C10.1672 15.3809 9.9668 15.75 9.63281 15.75H8.40586C8.25117 15.75 8.10703 15.6656 8.0332 15.5285C7.34414 14.2559 6.75 13.1133 6.75 13.1133C6.525 13.6336 6.39844 13.8164 5.46328 15.532C5.38945 15.6691 5.24883 15.7535 5.09414 15.7535H3.86719C3.5332 15.7535 3.33281 15.3844 3.51211 15.1031L5.63203 11.816L3.51211 8.52891C3.3293 8.24766 3.5332 7.87852 3.86719 7.87852H5.09062C5.24531 7.87852 5.38945 7.96289 5.46328 8.1C6.38086 9.81562 6.16641 9.28125 6.75 10.5082C6.75 10.5082 6.96445 10.0969 8.03672 8.1C8.11055 7.96289 8.25469 7.87852 8.40937 7.87852H9.63281C9.9668 7.875 10.1672 8.24414 9.98789 8.52539ZM13.5 4.28555V4.5H9V0H9.21445C9.43945 0 9.65391 0.0878906 9.81211 0.246094L13.2539 3.69141C13.4121 3.84961 13.5 4.06406 13.5 4.28555Z"
      fill={color || 'var(--icon-muted)'}
    />
  </svg>
)

export const Download: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 18"
    fill="none"
    data-testid="download"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M1 12.4054V15.9577C1 16.3583 1.32475 16.6831 1.72535 16.6831H15.507C15.9076 16.6831 16.2324 16.3583 16.2324 15.9577V12.4054M8.82204 0V13.2609M8.82204 13.2609L14.174 7.69989M8.82204 13.2609L3.47012 7.69989"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.4507"
    />
  </svg>
)

export const Code: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    data-testid="code"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M4.86001 6.61994L2.00392 9.00002L4.86001 11.3801C4.91841 11.4268 4.96689 11.4848 5.00262 11.5505C5.03836 11.6162 5.06063 11.6883 5.06814 11.7628C5.07565 11.8372 5.06824 11.9124 5.04635 11.9839C5.02445 12.0554 4.98851 12.1218 4.94064 12.1793C4.89276 12.2368 4.8339 12.2841 4.7675 12.3185C4.70111 12.353 4.62851 12.3738 4.55396 12.3799C4.47941 12.3859 4.4044 12.377 4.33332 12.3538C4.26225 12.3305 4.19653 12.2932 4.14001 12.2442L0.765014 9.43174C0.701686 9.37895 0.650735 9.31288 0.615771 9.23822C0.580807 9.16355 0.562683 9.08211 0.562683 8.99967C0.562683 8.91722 0.580807 8.83578 0.615771 8.76112C0.650735 8.68645 0.701686 8.62039 0.765014 8.5676L4.14001 5.7551C4.2547 5.65962 4.40262 5.61361 4.55122 5.62719C4.69983 5.64077 4.83696 5.71283 4.93244 5.82752C5.02791 5.9422 5.07392 6.09012 5.06034 6.23873C5.04676 6.38734 4.9747 6.52446 4.86001 6.61994ZM17.235 8.5676L13.86 5.7551C13.8032 5.70782 13.7377 5.67219 13.6671 5.65025C13.5966 5.6283 13.5224 5.62047 13.4488 5.62719C13.3752 5.63392 13.3037 5.65507 13.2383 5.68944C13.1729 5.72381 13.1149 5.77073 13.0676 5.82752C12.9721 5.9422 12.9261 6.09012 12.9397 6.23873C12.9533 6.38734 13.0253 6.52446 13.14 6.61994L15.9961 9.00002L13.14 11.3801C13.0816 11.4268 13.0331 11.4848 12.9974 11.5505C12.9617 11.6162 12.9394 11.6883 12.9319 11.7628C12.9244 11.8372 12.9318 11.9124 12.9537 11.9839C12.9756 12.0554 13.0115 12.1218 13.0594 12.1793C13.1073 12.2368 13.1661 12.2841 13.2325 12.3185C13.2989 12.353 13.3715 12.3738 13.4461 12.3799C13.5206 12.3859 13.5956 12.377 13.6667 12.3538C13.7378 12.3305 13.8035 12.2932 13.86 12.2442L17.235 9.43174C17.2983 9.37895 17.3493 9.31288 17.3843 9.23822C17.4192 9.16355 17.4373 9.08211 17.4373 8.99967C17.4373 8.91722 17.4192 8.83578 17.3843 8.76112C17.3493 8.68645 17.2983 8.62039 17.235 8.5676ZM11.442 2.28377C11.3725 2.25856 11.2988 2.24727 11.225 2.25056C11.1512 2.25384 11.0788 2.27162 11.0119 2.3029C10.9449 2.33417 10.8848 2.37832 10.835 2.43283C10.7851 2.48734 10.7465 2.55113 10.7213 2.62057L6.22126 14.9956C6.19595 15.065 6.18458 15.1388 6.18781 15.2127C6.19104 15.2866 6.2088 15.3591 6.24008 15.4261C6.27136 15.4931 6.31555 15.5533 6.37011 15.6032C6.42467 15.6531 6.48854 15.6918 6.55806 15.717C6.61969 15.7389 6.68461 15.7501 6.75001 15.75C6.86553 15.75 6.97825 15.7145 7.07285 15.6482C7.16745 15.5819 7.23934 15.4881 7.27876 15.3795L11.7788 3.00447C11.804 2.93504 11.8153 2.86131 11.812 2.78752C11.8087 2.71372 11.7909 2.64129 11.7596 2.57436C11.7284 2.50744 11.6842 2.44733 11.6297 2.39747C11.5752 2.34761 11.5114 2.30897 11.442 2.28377Z"
      fill={color || 'currentColor'}
    />
  </svg>
)
export const Expand: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    data-testid="expand"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M10.8966 10.0265L10.896 10.0258H10.8972L10.8966 10.0265ZM10.8966 10.0265L10.0258 10.8972L13.8991 14.7692H11.0769V16H16V11.0769H14.7692V13.8991L10.8966 10.0265ZM0 0H4.92308V1.23077H2.10092L5.97415 5.10277L5.10277 5.97415L1.23077 2.10092V4.92308H0V0ZM13.8991 1.23077H11.0769V0H16V4.92308H14.7692V2.10092L10.8972 5.97415L10.0258 5.10277L13.8991 1.23077ZM5.97292 10.8972L2.10215 14.7692H4.92308V16H0V11.0769H1.23077V13.8991L5.10277 10.0258L5.97292 10.8972Z"
      fill={color}
    />
    <path
      d="M10.8966 10.0265L10.896 10.0258H10.8972L10.8966 10.0265ZM10.8966 10.0265L10.0258 10.8972L13.8991 14.7692H11.0769V16H16V11.0769H14.7692V13.8991L10.8966 10.0265ZM0 0H4.92308V1.23077H2.10092L5.97415 5.10277L5.10277 5.97415L1.23077 2.10092V4.92308H0V0ZM13.8991 1.23077H11.0769V0H16V4.92308H14.7692V2.10092L10.8972 5.97415L10.0258 5.10277L13.8991 1.23077ZM5.97292 10.8972L2.10215 14.7692H4.92308V16H0V11.0769H1.23077V13.8991L5.10277 10.0258L5.97292 10.8972Z"
      stroke={color}
    />
  </svg>
)

export const SortJanDec: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 13"
    fill="none"
    data-testid="sort-jandec"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <g clipPath="url(#clip0_18755_53475)">
      <path
        className="svg-fill"
        d="M5.24823 11.1726C4.71058 11.1726 4.37821 10.974 4.16626 10.5368L4.67711 10.2356C4.79315 10.4832 4.96046 10.6104 5.20138 10.6104C5.49361 10.6104 5.652 10.4074 5.652 10.0616V7.8999H6.28556V10.1285C6.28556 10.7733 5.90188 11.1726 5.24823 11.1726ZM9.01591 11.1123L8.76382 10.4118H7.49224L7.24014 11.1123H6.57087L7.78225 7.8999H8.48497L9.69853 11.1123H9.01591ZM7.68409 9.87868H8.57196L8.12801 8.63832L7.68409 9.87868ZM12.1579 7.8999H12.7915V11.1123H12.0508L10.7502 8.8614V11.1123H10.1189V7.8999H10.8484L12.1579 10.1575V7.8999Z"
        fill={color}
      />
      <path
        className="svg-fill"
        d="M5.60753 1.86896C6.56904 1.86896 7.16688 2.48914 7.16688 3.47741C7.16688 4.46568 6.56904 5.0814 5.60753 5.0814H4.38501V1.86896H5.60753ZM5.5473 4.51699C6.15185 4.51699 6.51773 4.1266 6.51773 3.47741C6.51773 2.82822 6.15185 2.43337 5.5473 2.43337H5.01636V4.51699H5.5473ZM7.69208 5.0814V1.86896H10.001V2.43337H8.32342V3.18293H9.84039V3.72729H8.32342V4.51699H10.0233V5.0814H7.69208ZM11.9165 5.15055C10.9907 5.15055 10.3817 4.47906 10.3817 3.4752C10.3817 2.4713 10.984 1.7998 11.9076 1.7998C12.4787 1.7998 12.9762 2.08758 13.226 2.594L12.7084 2.87286C12.5032 2.52261 12.2578 2.3776 11.9165 2.3776C11.3811 2.3776 11.0308 2.80817 11.0308 3.4752C11.0308 4.14223 11.3878 4.57276 11.9232 4.57276C12.2801 4.57276 12.5144 4.4077 12.7084 4.03065L13.2327 4.30508C12.9494 4.85832 12.4898 5.15055 11.9165 5.15055Z"
        fill={color}
      />
      <path
        d="M1.29028 1.47375V10.3203"
        className="svg-stroke"
        stroke={color}
        strokeWidth="0.55291"
      />
      <path
        d="M1.29019 11.4268L0.172911 9.21512H2.40747L1.29019 11.4268Z"
        className="svg-fill"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_18755_53475">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const SortDecJan: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    data-testid="sort-decjan"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <g clipPath="url(#clip0_18755_53460)">
      <path
        className="svg-fill"
        d="M5.48285 5.59298C4.9452 5.59298 4.61283 5.39445 4.40088 4.95717L4.91173 4.65602C5.02777 4.90365 5.19508 5.03082 5.436 5.03082C5.72823 5.03082 5.88662 4.82779 5.88662 4.482V2.32031H6.52018V4.54894C6.52018 5.19367 6.1365 5.59298 5.48285 5.59298ZM9.25053 5.53275L8.99844 4.83225H7.72685L7.47476 5.53275H6.80548L8.01687 2.32031H8.71959L9.93315 5.53275H9.25053ZM7.91871 4.29909H8.80658L8.36263 3.05873L7.91871 4.29909ZM12.3925 2.32031H13.0261V5.53275H12.2854L10.9849 3.28181V5.53275H10.3535V2.32031H11.083L12.3925 4.57795V2.32031Z"
        fill={color}
      />
      <path
        className="svg-fill"
        d="M5.84215 8.95587C6.80366 8.95587 7.4015 9.57605 7.4015 10.5643C7.4015 11.5526 6.80366 12.1683 5.84215 12.1683H4.61963V8.95587H5.84215ZM5.78192 11.6039C6.38647 11.6039 6.75235 11.2135 6.75235 10.5643C6.75235 9.91513 6.38647 9.52028 5.78192 9.52028H5.25098V11.6039H5.78192ZM7.92669 12.1683V8.95587H10.2356V9.52028H8.55804V10.2698H10.075V10.8142H8.55804V11.6039H10.2579V12.1683H7.92669ZM12.1511 12.2375C11.2253 12.2375 10.6163 11.566 10.6163 10.5621C10.6163 9.55821 11.2186 8.88672 12.1422 8.88672C12.7133 8.88672 13.2108 9.17449 13.4606 9.68092L12.9431 9.95977C12.7378 9.60952 12.4924 9.46451 12.1511 9.46451C11.6157 9.46451 11.2655 9.89508 11.2655 10.5621C11.2655 11.2291 11.6224 11.6597 12.1578 11.6597C12.5147 11.6597 12.749 11.4946 12.9431 11.1176L13.4673 11.392C13.184 11.9452 12.7244 12.2375 12.1511 12.2375Z"
        fill={color}
      />
      <path
        d="M1.5249 2.21496V11.0615"
        stroke={color}
        className="svg-stroke"
        strokeWidth="0.55291"
      />
      <path
        d="M1.52481 12.168L0.40753 9.95633H2.64209L1.52481 12.168Z"
        className="svg-fill"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_18755_53460">
        <rect width={size} height={size} fill="white" transform="translate(0.234619 0.741211)" />
      </clipPath>
    </defs>
  </svg>
)

export const Web: React.FC<IconProps> = ({ color, size, cursor, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
    className={`${cursor === 'pointer' ? 'cursor-pointer' : ''} ${className || ''}`}
    {...rest}>
    <circle
      cx="13"
      cy="13.0003"
      r="10.0833"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M3.25 9.75H22.75M3.25 16.25H22.75M13 3.25C18.4167 8.66667 18.4167 17.3333 13 22.75C7.58333 17.3333 7.58333 8.66667 13 3.25Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      fill="none"
    />
  </svg>
)

export const ArrowDown: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 24"
    fill="none"
    className={`${className || ''}`}
    {...rest}>
    <path
      d="M0 16C0.742 16 1.85 16.733 2.78 17.475C3.98 18.429 5.027 19.569 5.826 20.876C6.425 21.856 7 23.044 7 24M7 24C7 23.044 7.575 21.855 8.174 20.876C8.974 19.569 10.021 18.429 11.219 17.475C12.15 16.733 13.26 16 14 16M7 24V0"
      stroke={color}
      strokeWidth="1.6"
    />
  </svg>
)

export const HelpCircle: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`${className || ''}`}
    {...rest}>
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
)

export const PlusFilled: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={`${className || ''}`}
    {...rest}>
    <svg width={size} height={size} viewBox="0 0 20 19" fill="none">
      <path
        d="M15.6099 2.42322H4.10685C3.80177 2.42322 3.50918 2.54441 3.29346 2.76013C3.07774 2.97586 2.95654 3.26844 2.95654 3.57352V15.0766C2.95654 15.3817 3.07774 15.6743 3.29346 15.89C3.50918 16.1057 3.80177 16.2269 4.10685 16.2269H15.6099C15.915 16.2269 16.2076 16.1057 16.4233 15.89C16.639 15.6743 16.7602 15.3817 16.7602 15.0766V3.57352C16.7602 3.26844 16.639 2.97586 16.4233 2.76013C16.2076 2.54441 15.915 2.42322 15.6099 2.42322ZM13.8845 9.90021H10.4335V13.3511C10.4335 13.5037 10.3729 13.65 10.2651 13.7578C10.1572 13.8657 10.0109 13.9263 9.85838 13.9263C9.70584 13.9263 9.55955 13.8657 9.45169 13.7578C9.34383 13.65 9.28323 13.5037 9.28323 13.3511V9.90021H5.83231C5.67977 9.90021 5.53348 9.83962 5.42561 9.73175C5.31775 9.62389 5.25716 9.4776 5.25716 9.32506C5.25716 9.17252 5.31775 9.02623 5.42561 8.91836C5.53348 8.8105 5.67977 8.7499 5.83231 8.7499H9.28323V5.29898C9.28323 5.14644 9.34383 5.00015 9.45169 4.89229C9.55955 4.78443 9.70584 4.72383 9.85838 4.72383C10.0109 4.72383 10.1572 4.78443 10.2651 4.89229C10.3729 5.00015 10.4335 5.14644 10.4335 5.29898V8.7499H13.8845C14.037 8.7499 14.1833 8.8105 14.2912 8.91836C14.399 9.02623 14.4596 9.17252 14.4596 9.32506C14.4596 9.4776 14.399 9.62389 14.2912 9.73175C14.1833 9.83962 14.037 9.90021 13.8845 9.90021Z"
        fill={color}
      />
    </svg>
  </svg>
)

export const Sidebar: React.FC<IconProps> = ({ color, size = 32, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    data-testid="sidebar"
    id={id}
    className={`${className || ''}`}
    {...rest}>
    <rect
      x="1.07112"
      y="1.07112"
      width="17.2808"
      height="17.2808"
      rx="2.03657"
      fill={color}
      fillOpacity="0.24"
      stroke={color}
      strokeWidth="2.14225"
    />
    <line
      x1="13.8905"
      y1="1.55385"
      x2="13.8905"
      y2="17.8692"
      stroke={color}
      strokeWidth="2.14225"
    />
  </svg>
)

export const SmartFlow: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 26"
    fill="none"
    className={`${className || ''}`}
    {...rest}>
    <path
      d="M3.29072 1.96971C3.39439 1.60813 3.60796 1.29096 3.89958 1.06548C4.1912 0.840002 4.54528 0.718282 4.90904 0.71846H12.3442C12.617 0.71846 12.8857 0.787048 13.1273 0.918347C13.369 1.04965 13.5763 1.23974 13.7316 1.47234C13.8869 1.70495 13.9855 1.97312 14.0189 2.25389C14.0524 2.53467 14.0197 2.81966 13.9237 3.08446L12.248 7.71846H15.6736C15.9119 7.71848 16.1453 7.78827 16.3471 7.9198C16.5488 8.05132 16.7107 8.23924 16.814 8.46193C16.9173 8.68462 16.9579 8.93303 16.9311 9.17858C16.9043 9.42414 16.8112 9.65685 16.6625 9.84996L14.5278 12.6307L14.1397 11.8257C14.0853 11.7139 14.0233 11.6063 13.954 11.5037C13.6295 11.0003 13.2105 10.5699 12.7219 10.2382C12.2334 9.90657 11.6853 9.68048 11.1106 9.57346L11.0802 9.56821C10.5878 8.85901 9.90194 8.31898 9.11091 8.01771C8.31988 7.71644 7.45997 7.66775 6.64202 7.87791C5.82406 8.08806 5.08553 8.54744 4.52162 9.19683C3.9577 9.84622 3.59424 10.6559 3.47807 11.5214C3.36191 12.387 3.49836 13.2688 3.86984 14.0532C4.24133 14.8376 4.83083 15.4886 5.56236 15.9224C6.29389 16.3562 7.13393 16.5529 7.97423 16.4871C8.81452 16.4213 9.61656 16.096 10.277 15.5532L10.4542 15.9242L10.4693 15.9522L11.0515 17.1597L5.51316 24.375C4.07204 26.251 1.18979 24.7022 1.83779 22.3992L3.99779 14.7185H1.32816C1.13092 14.7188 0.93633 14.6713 0.759928 14.5798C0.583526 14.4883 0.430191 14.3553 0.312159 14.1914C0.194128 14.0275 0.114666 13.8373 0.0801152 13.6359C0.0455644 13.4345 0.0568807 13.2275 0.113161 13.0315L3.29072 1.96971ZM10.0373 11.2325C9.83437 10.6501 9.43941 10.1609 8.92228 9.85136C8.40514 9.54179 7.79912 9.43178 7.21133 9.54076C6.62355 9.64974 6.09183 9.97071 5.71017 10.4469C5.32851 10.9231 5.12147 11.5239 5.12565 12.1432C5.12983 12.7624 5.34496 13.3601 5.73301 13.8307C6.12106 14.3014 6.65706 14.6146 7.24626 14.715C7.83546 14.8155 8.43993 14.6967 8.95284 14.3796C9.46575 14.0626 9.85407 13.5677 10.0492 12.9825C10.2078 12.979 10.3478 12.9842 10.5014 13.014C10.6328 13.0362 10.7583 13.0866 10.8698 13.1619C10.9814 13.2373 11.0766 13.3359 11.1494 13.4515L12.8082 16.8885C13.0029 17.2305 13.2665 17.5248 13.5811 17.7514C13.8956 17.9779 14.2537 18.1313 14.6307 18.201C14.8805 18.25 15.1522 18.264 15.4002 18.264C15.6032 18.8463 15.9982 19.3355 16.5153 19.6451C17.0324 19.9546 17.6385 20.0646 18.2262 19.9557C18.814 19.8467 19.3457 19.5257 19.7274 19.0495C20.1091 18.5733 20.3161 17.9725 20.3119 17.3533C20.3077 16.7341 20.0926 16.1363 19.7046 15.6657C19.3165 15.1951 18.7805 14.8818 18.1913 14.7814C17.6021 14.681 16.9976 14.7998 16.4847 15.1168C15.9718 15.4338 15.5835 15.9287 15.3884 16.514C15.237 16.5188 15.0854 16.5077 14.9362 16.4807C14.8049 16.4587 14.6795 16.4085 14.568 16.3335C14.4564 16.2585 14.3611 16.1602 14.2882 16.045L12.6293 12.6062C12.4347 12.2642 12.1711 11.9698 11.8565 11.7433C11.5419 11.5168 11.1839 11.3634 10.8068 11.2937C10.5526 11.2499 10.2951 11.2294 10.0373 11.2325ZM7.65629 11.25C7.88006 11.25 8.09467 11.3421 8.25291 11.5062C8.41114 11.6703 8.50004 11.8929 8.50004 12.125C8.50004 12.357 8.41114 12.5796 8.25291 12.7437C8.09467 12.9078 7.88006 13 7.65629 13C7.43251 13 7.2179 12.9078 7.05967 12.7437C6.90143 12.5796 6.81254 12.357 6.81254 12.125C6.81254 11.8929 6.90143 11.6703 7.05967 11.5062C7.2179 11.3421 7.43251 11.25 7.65629 11.25ZM17.7813 16.5C18.0051 16.5 18.2197 16.5921 18.3779 16.7562C18.5361 16.9203 18.625 17.1429 18.625 17.375C18.625 17.607 18.5361 17.8296 18.3779 17.9937C18.2197 18.1578 18.0051 18.25 17.7813 18.25C17.5575 18.25 17.3429 18.1578 17.1847 17.9937C17.0264 17.8296 16.9375 17.607 16.9375 17.375C16.9375 17.1429 17.0264 16.9203 17.1847 16.7562C17.3429 16.5921 17.5575 16.5 17.7813 16.5Z"
      fill={color}
    />
  </svg>
)

export const Ranking: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 150 225"
    fill="none"
    className={`${className || ''}`}
    {...rest}>
    <path
      d="M72.275 0.166574C65.875 1.06657 61.875 2.76657 56.775 6.96657C50.375 12.1666 48.675 12.8666 41.275 13.7666C32.375 14.9666 26.675 17.1666 22.375 21.3666C16.975 26.6666 15.175 30.4666 14.175 39.0666C13.275 46.9666 11.575 51.0666 6.975 56.2666C-2.325 67.0666 -2.325 82.6666 6.975 93.4666C11.575 98.6666 13.075 102.367 14.075 110.567C15.375 120.567 18.775 126.467 26.075 131.567L28.375 133.067L23.775 144.967C19.375 156.267 17.975 159.767 11.975 175.367C10.675 178.967 7.575 186.667 5.275 192.567C1.175 203.067 0.875 205.367 3.875 205.367C4.675 205.367 12.075 201.967 20.375 197.767C28.675 193.667 35.975 190.467 36.575 190.667C37.275 190.867 40.475 198.367 43.875 207.467C51.375 227.467 52.475 228.367 56.775 217.167C58.275 213.167 61.975 203.567 64.875 195.867C67.875 188.167 71.275 179.267 72.475 176.167C73.775 172.967 74.975 170.367 75.275 170.367C75.875 170.367 77.375 173.967 93.275 215.567C98.475 229.267 99.375 228.567 108.375 203.467C110.775 196.667 113.275 190.867 113.875 190.667C114.575 190.467 122.275 193.867 131.075 198.267C151.375 208.467 151.475 208.367 144.975 191.567C142.375 185.167 137.875 173.367 134.775 165.367C126.275 143.267 124.675 139.867 122.875 139.567C119.675 138.867 120.275 142.267 125.775 156.467C128.875 164.367 132.475 173.667 133.875 177.167C135.175 180.567 137.375 186.367 138.875 189.967C140.275 193.567 141.175 196.767 140.975 196.967C140.675 197.267 133.875 194.167 125.875 190.167C113.775 184.167 111.075 183.167 110.275 184.367C109.775 185.167 107.275 191.467 104.775 198.367C98.075 216.567 98.675 215.367 97.475 212.367C96.875 210.967 94.675 205.567 92.775 200.367C90.775 195.167 88.075 188.167 86.775 184.867C85.475 181.567 81.975 172.467 78.975 164.667L73.475 150.467L77.175 149.767C83.875 148.467 88.475 146.367 93.275 142.367C98.875 137.667 100.975 136.767 108.875 135.867C120.475 134.467 128.475 129.167 132.875 119.867C134.175 117.067 135.275 113.067 135.275 110.867C135.275 104.767 136.975 99.8666 140.775 95.1666C147.175 87.2666 149.275 82.1666 149.275 74.8666C149.275 67.4666 147.475 63.1666 141.175 55.1666C136.975 49.8666 135.275 45.1666 135.275 38.8666C135.275 36.6666 134.175 32.5666 132.875 29.7666C128.475 20.3666 121.875 15.9666 108.775 13.8666C99.275 12.3666 99.475 12.4666 93.175 7.26657C86.875 2.06657 78.775 -0.733426 72.275 0.166574ZM83.575 6.96657C85.375 7.86657 88.375 9.96657 90.175 11.6666C94.975 15.8666 100.675 18.0666 108.275 18.9666C122.175 20.4666 128.775 27.0666 130.375 40.9666C131.175 48.7666 133.575 54.3666 138.175 59.5666C142.675 64.7666 144.275 68.7666 144.275 74.8666C144.275 80.9666 142.675 84.9666 138.175 90.1666C133.575 95.4666 131.175 100.967 130.375 108.867C128.775 122.967 122.275 129.067 107.275 130.867C100.475 131.667 94.775 134.067 90.075 138.267C85.375 142.367 80.375 144.367 74.775 144.367C68.975 144.367 64.775 142.567 58.375 137.567C52.575 132.967 49.475 131.767 40.175 130.467C36.475 129.967 32.175 128.867 30.475 127.967C26.275 125.767 20.375 118.667 19.875 114.967C19.575 113.267 19.075 109.567 18.675 106.867C17.875 100.067 16.275 96.6666 10.675 89.3666L5.775 83.1666V74.8666V66.5666L10.775 60.2666C16.275 53.1666 19.175 46.0666 19.275 39.6666C19.275 34.1666 20.775 30.5666 24.575 26.5666C28.975 21.8666 33.675 19.7666 41.275 18.9666C49.275 18.0666 53.375 16.3666 59.175 11.5666C61.675 9.56657 64.775 7.36657 66.175 6.66657C70.075 4.96657 79.875 5.06657 83.575 6.96657ZM45.875 136.667C49.075 137.467 52.875 139.567 55.875 142.067C58.575 144.367 62.375 146.867 64.275 147.667C67.275 148.867 68.075 149.967 70.075 155.567L72.375 162.067L63.275 185.967C58.275 199.167 53.675 210.967 53.075 212.367L51.975 214.867L50.775 211.867C50.075 210.167 47.675 203.667 45.375 197.367C43.075 191.067 40.775 185.167 40.275 184.367C39.475 183.067 36.975 184.067 24.675 190.167C16.675 194.167 9.875 197.267 9.575 197.067C9.375 196.767 11.375 190.767 14.175 183.767C25.075 155.567 30.075 142.667 31.375 139.067C32.575 135.567 32.975 135.367 36.775 135.367C38.975 135.367 43.075 135.967 45.875 136.667Z"
      fill={color}
    />
    <path
      d="M62.275 23.8666C38.575 30.4666 22.275 51.0666 22.275 74.4666C22.375 105.267 48.375 129.467 78.575 127.067C90.375 126.067 104.275 120.367 105.075 116.067C105.575 113.467 102.675 112.967 99.575 115.167C95.075 118.267 85.275 121.467 78.275 122.067C55.775 123.867 34.475 108.767 28.875 86.7666C20.875 55.6666 45.975 25.1666 77.775 27.6666C94.875 28.9666 109.875 39.0666 116.975 54.0666C123.475 67.6666 123.575 81.5666 117.375 95.0666C114.175 101.867 114.175 103.367 117.275 103.367C119.875 103.367 124.075 94.4666 125.975 84.3666C130.875 59.7666 116.675 34.7666 92.775 25.7666C83.975 22.4666 70.475 21.5666 62.275 23.8666Z"
      fill={color}
    />
    <path
      d="M67.875 52.7666C64.475 60.0666 62.775 62.4666 61.075 62.7666C59.775 63.0666 55.675 63.7666 51.775 64.3666C42.775 65.7666 41.275 66.2666 41.275 67.6666C41.275 68.2666 44.475 72.0666 48.475 76.0666C56.575 84.1666 56.475 83.7666 53.875 97.1666C51.875 107.467 52.775 107.867 64.675 101.767L74.075 96.9666L83.575 101.867C95.775 108.267 96.075 108.067 93.775 94.3666L92.075 84.2666L99.775 76.2666C109.075 66.7666 108.875 66.0666 96.475 64.2666C91.675 63.6666 87.075 62.7666 86.275 62.2666C85.475 61.8666 82.775 57.5666 80.275 52.6666C77.775 47.8666 74.975 43.7666 74.075 43.5666C72.875 43.3666 71.175 45.8666 67.875 52.7666ZM78.275 59.6666L81.775 66.8666L88.375 67.9666C99.275 69.7666 99.275 69.5666 92.275 76.2666C87.875 80.4666 86.275 82.7666 86.575 84.0666C87.875 88.4666 89.375 97.5666 88.975 97.9666C88.675 98.2666 85.175 96.8666 81.275 94.8666L73.975 91.1666L67.075 94.8666C63.175 96.8666 59.875 98.2666 59.575 97.9666C59.275 97.6666 59.575 93.9666 60.275 89.7666L61.475 82.0666L55.875 76.4666C52.775 73.3666 50.275 70.5666 50.275 70.1666C50.275 69.8666 53.875 69.0666 58.375 68.3666L66.375 67.0666L70.075 59.7666C72.075 55.6666 73.975 52.3666 74.275 52.4666C74.575 52.4666 76.375 55.6666 78.275 59.6666Z"
      fill={color}
    />
    <path
      d="M109.575 106.067C107.875 106.667 107.975 110.067 109.675 110.667C111.175 111.267 113.275 109.567 113.275 107.767C113.275 106.367 111.275 105.467 109.575 106.067Z"
      fill={color}
    />
  </svg>
)

export const WorkspaceIcon: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 42 42"
    fill="none"
    className={`${className || ''}`}
    {...rest}>
    <rect x="1.5" y="1.5" width="14" height="14" rx="1.5" stroke={color} strokeWidth="3" />
    <rect x="20.5" y="1.5" width="20" height="14" rx="1.5" stroke={color} strokeWidth="3" />
    <rect x="29.5" y="20.5" width="11" height="20" rx="1.5" stroke={color} strokeWidth="3" />
    <rect x="1.5" y="20.5" width="23" height="20" rx="1.5" stroke={color} strokeWidth="3" />
  </svg>
)

export const Reposition: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 34 34"
    className={`${className || ''}`}
    {...rest}>
    <circle cx="15" cy="15" r="15" fill={color} fillOpacity="0.1" />
    <path
      d="M12.9161 22.2802C12.8282 22.1922 12.7788 22.0729 12.7788 21.9486C12.7788 21.8242 12.8282 21.7049 12.9161 21.6169L15.5754 18.9576C15.6634 18.8697 15.7827 18.8203 15.9071 18.8203C16.0314 18.8203 16.1507 18.8697 16.2387 18.9576L18.8981 21.6169C18.9809 21.706 19.0261 21.8236 19.024 21.9452C19.0219 22.0668 18.9727 22.1828 18.8868 22.269C18.8007 22.3548 18.6847 22.404 18.5631 22.4061C18.4415 22.4082 18.3238 22.3631 18.2348 22.2802L16.3764 20.4218L16.3764 26.0303C16.3764 26.1548 16.3269 26.2741 16.2389 26.3621C16.1509 26.4502 16.0315 26.4996 15.9071 26.4996C15.7826 26.4996 15.6632 26.4502 15.5752 26.3621C15.4872 26.2741 15.4378 26.1548 15.4378 26.0303L15.4378 20.4218L13.5793 22.2802C13.4913 22.3681 13.3721 22.4175 13.2477 22.4175C13.1233 22.4175 13.0041 22.3681 12.9161 22.2802Z"
      fill={color}
    />
    <path
      d="M12.9161 8.05572C12.8282 8.14372 12.7788 8.263 12.7788 8.38736C12.7788 8.51173 12.8282 8.63101 12.9161 8.719L15.5754 11.3784C15.6634 11.4663 15.7827 11.5156 15.9071 11.5156C16.0314 11.5156 16.1507 11.4663 16.2387 11.3784L18.8981 8.719C18.9809 8.62998 19.0261 8.51231 19.024 8.39072C19.0219 8.26913 18.9727 8.15309 18.8868 8.06699C18.8007 7.98111 18.6847 7.93195 18.5631 7.92985C18.4415 7.92775 18.3238 7.97287 18.2348 8.05572L16.3764 9.91416L16.3764 4.4693C16.3764 4.34484 16.3269 4.22547 16.2389 4.13746C16.1509 4.04944 16.0315 4 15.9071 4C15.7826 4 15.6632 4.04944 15.5752 4.13746C15.4872 4.22547 15.4378 4.34484 15.4378 4.4693L15.4378 9.91416L13.5793 8.05572C13.4913 7.96784 13.3721 7.91847 13.2477 7.91847C13.1233 7.91847 13.0041 7.96784 12.9161 8.05572Z"
      fill={color}
    />
    <path
      d="M22.9448 12.251C22.8568 12.1631 22.7375 12.1138 22.6131 12.1138C22.4888 12.1138 22.3695 12.1631 22.2815 12.251L19.6221 14.9104C19.5342 14.9984 19.4849 15.1177 19.4849 15.242C19.4849 15.3664 19.5342 15.4857 19.6221 15.5737L22.2815 18.233C22.3705 18.3159 22.4882 18.361 22.6098 18.3589C22.7314 18.3568 22.8474 18.3077 22.9335 18.2218C23.0194 18.1357 23.0685 18.0196 23.0706 17.898C23.0727 17.7765 23.0276 17.6588 22.9448 17.5698L21.0863 15.7113L26.5307 15.7113C26.6551 15.7113 26.7745 15.6619 26.8625 15.5739C26.9505 15.4859 27 15.3665 27 15.242C27 15.1176 26.9505 14.9982 26.8625 14.9102C26.7745 14.8222 26.6551 14.7727 26.5307 14.7727L21.0863 14.7727L22.9448 12.9143C23.0327 12.8263 23.082 12.707 23.082 12.5827C23.082 12.4583 23.0327 12.339 22.9448 12.251Z"
      fill={color}
    />
    <path
      d="M8.55523 12.251C8.64323 12.1631 8.76251 12.1138 8.88687 12.1138C9.01124 12.1138 9.13052 12.1631 9.21851 12.251L11.8779 14.9104C11.9658 14.9984 12.0151 15.1177 12.0151 15.242C12.0151 15.3664 11.9658 15.4857 11.8779 15.5737L9.21851 18.233C9.12949 18.3159 9.01182 18.361 8.89023 18.3589C8.76864 18.3568 8.6526 18.3077 8.5665 18.2218C8.48062 18.1357 8.43146 18.0196 8.42936 17.898C8.42726 17.7765 8.47238 17.6588 8.55523 17.5698L10.4137 15.7113L4.96934 15.7113C4.84488 15.7113 4.72551 15.6619 4.6375 15.5739C4.54949 15.4859 4.50004 15.3665 4.50004 15.242C4.50004 15.1176 4.54949 14.9982 4.6375 14.9102C4.72551 14.8222 4.84488 14.7727 4.96934 14.7727L10.4137 14.7727L8.55523 12.9143C8.46735 12.8263 8.41798 12.707 8.41798 12.5827C8.41798 12.4583 8.46735 12.339 8.55523 12.251Z"
      fill={color}
    />
  </svg>
)

export const Plugins: React.FC<IconProps> = ({ color, size, className, ...rest }) => (
  <svg
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill="none"
    className={`${className || ''}`}
    {...rest}>
    <rect width="9.14062" height="9.14062" rx="1.79688" fill={color} />
    <rect x="10.8594" width="9.14062" height="9.14062" rx="1.79688" fill={color} />
    <rect y="10.8594" width="9.14062" height="9.14062" rx="1.79688" fill={color} />
    <rect
      x="16.3672"
      y="18.2031"
      width="1.83594"
      height="5.50781"
      rx="0.46875"
      transform="rotate(180 16.3672 18.2031)"
      fill={color}
    />
    <rect
      x="16.3672"
      y="18.2031"
      width="1.83594"
      height="5.50781"
      rx="0.46875"
      transform="rotate(180 16.3672 18.2031)"
      fill={color}
    />
    <rect
      x="12.6953"
      y="16.3672"
      width="1.83594"
      height="5.50781"
      rx="0.46875"
      transform="rotate(-90 12.6953 16.3672)"
      fill={color}
    />
    <rect
      x="12.6953"
      y="16.3672"
      width="1.83594"
      height="5.50781"
      rx="0.46875"
      transform="rotate(-90 12.6953 16.3672)"
      fill={color}
    />
  </svg>
)

export const RearrangeTasks: React.FC<IconProps> = ({
  color,
  size = 32,
  width,
  height,
  id,
  className,
  ...rest
}) => (
  <svg
    width={width ?? size}
    height={height ?? size}
    viewBox="0 0 20 16"
    fill="none"
    data-testid="rearrange-tasks"
    id={id}
    className={`${className || ''}`}
    {...rest}>
    <rect width="4" height="4" fill={color} />
    <rect x="6" width="4" height="4" fill={color} />
    <rect x="6" y="6" width="4" height="4" fill={color} />
    <rect y="6" width="4" height="4" fill={color} />
    <rect y="12" width="4" height="4" fill={color} />
    <rect x="6" y="12" width="4" height="4" fill={color} />
  </svg>
)

export const CreateSmartFlow: React.FC<IconProps> = ({
  color,
  size = 32,
  width,
  height,
  id,
  className,
  ...rest
}) => (
  <svg
    width={width ?? size}
    height={height ?? size}
    viewBox="0 0 42 27"
    fill="none"
    data-testid="create-smart-flow"
    id={id}
    className={`${className || ''}`}
    {...rest}>
    <circle cx="6.15254" cy="20.5583" r="5.15254" fill={color} stroke="#C4C4C4" strokeWidth="2" />
    <path
      d="M11.7456 20.6993H19.7627C20.9983 20.6993 22 19.6976 22 18.462V11.1908C22 9.95522 23.0017 8.95355 24.2373 8.95355H40.5M40.5 8.95355L32.6695 1.12305M40.5 8.95355L32.6695 16.7841"
      stroke="#C4C4C4"
      strokeWidth="2"
    />
  </svg>
)

export const Favourite: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="favourite"
    className={className}
    id={id}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}>
    <path
      d="M19.513 12.5834L12.013 20.0114L4.513 12.5834C4.0183 12.102 3.62864 11.5234 3.36854 10.884C3.10845 10.2447 2.98356 9.55836 3.00173 8.86834C3.01991 8.17832 3.18076 7.49954 3.47415 6.87474C3.76755 6.24994 4.18713 5.69266 4.70648 5.23799C5.22583 4.78331 5.8337 4.4411 6.49181 4.23289C7.14991 4.02468 7.844 3.95499 8.53036 4.02821C9.21673 4.10143 9.8805 4.31596 10.4799 4.65831C11.0792 5.00066 11.6012 5.46341 12.013 6.01741C12.4265 5.46743 12.9491 5.00873 13.5481 4.67001C14.1471 4.3313 14.8095 4.11986 15.4939 4.04893C16.1784 3.978 16.8701 4.04911 17.5258 4.2578C18.1815 4.46649 18.787 4.80828 19.3045 5.26177C19.8221 5.71526 20.2404 6.27069 20.5334 6.8933C20.8264 7.51591 20.9877 8.19229 21.0073 8.88012C21.0269 9.56794 20.9043 10.2524 20.6471 10.8907C20.39 11.5289 20.0039 12.1072 19.513 12.5894"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UsersGroup: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="users-group"
    className={className}
    id={id}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}>
    <path
      d="M10 13C10 13.5304 10.2107 14.0391 10.5858 14.4142C10.9609 14.7893 11.4696 15 12 15C12.5304 15 13.0391 14.7893 13.4142 14.4142C13.7893 14.0391 14 13.5304 14 13C14 12.4696 13.7893 11.9609 13.4142 11.5858C13.0391 11.2107 12.5304 11 12 11C11.4696 11 10.9609 11.2107 10.5858 11.5858C10.2107 11.9609 10 12.4696 10 13Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 21V20C8 19.4696 8.21071 18.9609 8.58579 18.5858C8.96086 18.2107 9.46957 18 10 18H14C14.5304 18 15.0391 18.2107 15.4142 18.5858C15.7893 18.9609 16 19.4696 16 20V21"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 5C15 5.53043 15.2107 6.03914 15.5858 6.41421C15.9609 6.78929 16.4696 7 17 7C17.5304 7 18.0391 6.78929 18.4142 6.41421C18.7893 6.03914 19 5.53043 19 5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3C16.4696 3 15.9609 3.21071 15.5858 3.58579C15.2107 3.96086 15 4.46957 15 5Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 10H19C19.5304 10 20.0391 10.2107 20.4142 10.5858C20.7893 10.9609 21 11.4696 21 12V13"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5C5 5.53043 5.21071 6.03914 5.58579 6.41421C5.96086 6.78929 6.46957 7 7 7C7.53043 7 8.03914 6.78929 8.41421 6.41421C8.78929 6.03914 9 5.53043 9 5C9 4.46957 8.78929 3.96086 8.41421 3.58579C8.03914 3.21071 7.53043 3 7 3C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 13V12C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10H7"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TeamsTabIcon: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="teams-tab"
    id={id}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}>
    <path
      d="M5 7C5 8.06087 5.42143 9.07828 6.17157 9.82843C6.92172 10.5786 7.93913 11 9 11C10.0609 11 11.0783 10.5786 11.8284 9.82843C12.5786 9.07828 13 8.06087 13 7C13 5.93913 12.5786 4.92172 11.8284 4.17157C11.0783 3.42143 10.0609 3 9 3C7.93913 3 6.92172 3.42143 6.17157 4.17157C5.42143 4.92172 5 5.93913 5 7Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 21V19C3 17.9391 3.42143 16.9217 4.17157 16.1716C4.92172 15.4214 5.93913 15 7 15H11C12.0609 15 13.0783 15.4214 13.8284 16.1716C14.5786 16.9217 15 17.9391 15 19V21"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 21.0004V19.0004C20.9949 18.1175 20.6979 17.2612 20.1553 16.5648C19.6126 15.8684 18.8548 15.3711 18 15.1504"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PersonalTabIcon: React.FC<IconProps> = ({ color, width, height, ...rest }) => (
  <svg
    width={rest.size ?? 24}
    height={rest.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="personal-tab-icon"
    {...rest}
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BrowseAssistant: React.FC<IconProps> = ({
  color,
  width,
  height,
  className,
  ...rest
}) => (
  <svg
    width={rest.size ?? 50}
    height={rest.size ?? 50}
    viewBox="0 0 50 50"
    fill="none"
    className={`${className || ''}`}
    data-testid="browse-assistant"
    {...rest}>
    <path
      d="M34 34L28 28M16 23C16 23.9193 16.1811 24.8295 16.5328 25.6788C16.8846 26.5281 17.4002 27.2997 18.0503 27.9497C18.7003 28.5998 19.4719 29.1154 20.3212 29.4672C21.1705 29.8189 22.0807 30 23 30C23.9193 30 24.8295 29.8189 25.6788 29.4672C26.5281 29.1154 27.2997 28.5998 27.9497 27.9497C28.5998 27.2997 29.1154 26.5281 29.4672 25.6788C29.8189 24.8295 30 23.9193 30 23C30 22.0807 29.8189 21.1705 29.4672 20.3212C29.1154 19.4719 28.5998 18.7003 27.9497 18.0503C27.2997 17.4002 26.5281 16.8846 25.6788 16.5328C24.8295 16.1811 23.9193 16 23 16C22.0807 16 21.1705 16.1811 20.3212 16.5328C19.4719 16.8846 18.7003 17.4002 18.0503 18.0503C17.4002 18.7003 16.8846 19.4719 16.5328 20.3212C16.1811 21.1705 16 22.0807 16 23Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const NewAssistant: React.FC<IconProps> = ({ color, width, height, ...rest }) => (
  <svg
    width={rest.size ?? 24}
    height={rest.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="new-assistant"
    {...rest}
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 12H15M12 9V15M3 5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AliIcon: React.FC<IconProps> = ({ color, width, height, id, className, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="ali-icon"
    id={id}
    className={className}
    {...rest}>
    <rect width={width} height={height} rx="12.5" fill="white" />

    <rect width={width} height={height} rx="12.5" fill="url(#pattern0_29960_4575)" />
    <defs>
      <pattern
        id="pattern0_29960_4575"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1">
        <use xlinkHref="#image0_29960_4575" transform="scale(0.002)" />
      </pattern>
      <image
        id="image0_29960_4575"
        width="500"
        height="500"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0CAYAAADL1t+KAAAABHNCSVQICAgIfAhkiAAAIABJREFUeF7sXQd8FUUTn5e89NASCIQWqogoonQRKdJBkE5CCyAg0osU6b333iS0BAiKhSIdEaSIKCC9BQglJIRAGslr31yQT0rK3b27e3t3s9/vfQlmd3bmP/ve/+3e7IwBqBEChAAhQAgQAoSA6hEwqN4CMoAQIAQIAUKAECAEgAidFgEhQAgQAoQAIaABBIjQNeBEMoEQIAQIAUKAECBCpzVACBAChAAhQAhoAAEidA04kUwgBAgBQoAQIASI0GkNEAKEACFACBACGkCACF0DTiQTCAFCgBAgBAgBInRaA4QAIUAIEAKEgAYQIELXgBPJBEKAECAECAFCgAid1gAhQAgQAoQAIaABBIjQNeBEMoEQIAQIAUKAECBCpzVACBAChAAhQAhoAAEidA04kUwgBAgBQoAQIASI0GkNEAKEACFACBACGkCACF0DTiQTCAFCgBAgBAgBInRaA4QAIUAIEAKEgAYQIELXgBPJBEKAECAECAFCgAid1gAhQAgQAoQAIaABBIjQNeBEMoEQIAQIAUKAECBCpzVACBAChAAhQAhoAAEidA04kUwgBAgBQoAQIASI0GkNEAKEACFACBACGkCACF0DTiQTCAFCgBAgBAgBInRaA4QAIUAIEAKEgAYQIELXgBPJBEKAECAECAFCgAid1gAhQAgQAoQAIaABBIjQNeBEMoEQIAQIAUKAECBCpzVACBAChAAhQAhoAAEidA04kUwgBAgBQoAQIASI0GkNEAKEACFACBACGkCACF0DTiQTCAFCgBAgBAgBInRaA4QAIUAIEAKEgAYQIELXgBPJBEKAECAECAFCgAid1gAhQAgQAoQAIaABBIjQNeBEMoEQIAQIAUKAECBCpzVACDCOQFRUVF6DwZDfZrPlcXJy8rVarbnw3z74b+5nrn9/5sSfnomJiYXxlY+PSV5eXvfxdQdlJOLYJ/jzMf6M/ffnY5wrFufi/v3Qw8PjXrZs2R7ykUt9CAFCwDEIEKE7BnealRBIQ+DBgwdeSJxv4a/F/30VQlLNj78X4EgcfxYUAlVSUhLEx8fzGuLt7Q1I6Lz6vuiEut3G3++hbve4n//++zr+fs3Pz+8q/vdkQQKpMyFACEiGABG6ZFCSIEIgYwTi4uJypaamVsUeHyIJlsKfJTgCRwLMIyVuchN6VrqibVFo0zXsx5H8Jfz3KfzCcjxPnjz8vmVkNQH9nRAgBDJEgAidFgchIDECSGLuDx8+LI9EVgl/T3shyRWTeJp0xTma0DOw0Yb//QricBJxOIm4nPT19f0bf09VAhOagxDQCwJE6HrxNNkpGwJIVB5I4J8gQdXE32vizwo4mVG2CTMRzCihv6Ex4pSCOB3Hn4eQ4A/lzp37OP77mSMwozkJAa0gQISuFU+SHYohwD33RvL5GF+1kJCq48+PFJs8i4nUQugZmHH4BcHjEf1BVjAlPQgBtSBAhK4WT5GeDkOA24E/evSoGkZ8cwReCwm8oqN24FmBoHJC/795iPMzxPkYvg7i7weR4E/g76as7Ke/EwJ6RoAIXc/eJ9szRCA2NvY9k8nUEkmkDnaqphaotELor+ONpM5Fzx/F115XV9ctuXLlilCLT0hPQkApBIjQlUKa5mEeAdyFlzGbzW2QxFujsqWZVzgdBbVK6OmY+hf+t3Ak+i158+blIuqpEQK6R4AIXfdLQN8AYNIWLvq8E75aI5G/o3Y0dEToL7uKi5j/3sXFZUPOnDlvqt2HpD8hIBYBInSxyNE41SKAuzpDdHR0QzSgN764n5p5H+iU0F+sRSv+sgv9uwB37XtUu0BJcUJAJAKa+SATaT8N0xkCeL2MS+gShi/uapnmms4J/WV/HkVi70zH8Zpb4mRQJggQodPy0A0CSObfoLGTtWwwEfqr3sWj+CEYIT9byz4n2wiBFwgQodNa0AUC+Kx8A364t9e6sUTob3oYd+orcafeQ+u+J/sIASJ0WgOaRgA/zJ3xeTl3xM5Frmu+EaFn6OJ1WDyms+YXABmoawSI0HXtfu0bj8fsW/RC5pw3idAzXtP45W4F7tR7an/Vk4V6RYAIXa+e14HdSOYT0cxROjD1/yYSoWfubXqmrqd3g/5sJULXn891YTEes3+GO7KfdGHsS0YSofPyeA08fj/Mqyd1IgRUhAARuoqcRaryQwCJ3BUJnavJXYjfCO30IkLP2pe4Pi7g0XuZrHtSD0JAXQgQoavLX6QtDwT0cD0tIxiI0HksEOyCR+898TrbCn69qRchoA4EiNDV4SfSkicC/+7Oo7F7dp5DNNWNCJ2fO3Gd3MJdehF+vakXIaAOBIjQ1eEn0pInAjExMR2wzOl6nt01140Inb9LkdTrIanv5T+CehICbCNAhM62f0g7gQjgcTsX7FRd4DDNdCdCF+TKLRgc11bQCOpMCDCMABE6w84h1YQhEBcXlys1NTVW2Cht9SZC5+9P3KE/Q0L3xufpFv6jqCchwC4CROjs+oY0E4gApndtgR/O3wkcpqnuROjC3Onk5FQld+7cJ4SNot6EAJsIEKGz6RfSSgQCeNw+H4f1EzFUM0OI0IW5EnfpQ/E5+kxho6g3IcAmAkTobPqFtBKBABL6LzisvoihmhlChC7YlWvw2L2r4FE0gBBgEAEidAadQiqJQwCP3I/hkXsVcaO1MYoIXbAfdyChNxE8igYQAgwiQITOoFNIJXEI4A79Ao4sLW60NkYRoQv24x9I6JUEj6IBhACDCBChM+gUUkkcArhDv4U79MLiRmtjFBG6MD/iM/Sb+Ay9mLBR1JsQYBMBInQ2/UJaiUAAd+h3cFhBEUM1M4QIXbArI3GHrruc/4JRogGqQIAIXRVuIiX5IECETvXQ+ayT1/oQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIECEToQuYtkQoYsAjYawiQAROpt+Ia1EIID10B9jPfScIoZqZgiVTxXmSqyHHof10HMJG0W9CQE2ESBCZ9MvpFUWCJw9e7aYk5NTJavVWhlJvBJ2/xA/mN31DhwRuvAV8ODBg0Qc9Seuo5O4pk7gmjrx3nvv3REuiUYQAo5FgAjdsfjT7DwRuHz5coHU1NSmuKOqj0NqpLcTR0LnKU273YjQhfsWT3bSGxSDa+0QrrNf3N3dfypZsmS0cMk0ghBQFgEidGXxptl4IoAfps7nzp2rht0bcS/8YH0vq6FE6PQMPas1kt7fMyD0l7vicrSdxt37DlyHO995552T+NMmZi4aQwjIiQARupzokmzBCPzzzz8t8cizJX5gNsbB2YUIIEInQheyXl705UHor4t9hP/hJyT5rWXLlt0pZk4aQwjIgQARuhyokkzeCNy8edM9MTGxMX44tsJBTfDlzXvwax2J0InQxawdEYT+/2lw3XKBmD/gz3B87r4XfzeL0YHGEAJSIECELgWKJEMwAufPn29gsVg64sDm+CHoIVhAOgOI0InQxawjewj9tfme4r+34NH82jJlyhwRowuNIQTsQYAI3R70aKwgBHA3njM+Pr4rEngvHFhC0GAenYnQidB5LJM3ukhI6C/LPoPrfHGOHDk2FCpUKFmMXjSGEBCKABG6UMSov2AEcDdeDp+L98VjyUCpduPpKUGEToQueHHiAJkIPU0VXPNPcM2HODs7L8Zguqti9KMxhABfBIjQ+SJF/QQjgDvyKfhhxh2rF8RjSMDfAYk97ZWSkgImk0mwzMwGEKEToYtZUFITuqurK7i4uACSOHDrHkk9bc1ju44/Q4oVKzZJjJ40hhDICgEi9KwQor8LQuDOnTuVkLiX4QdaOfyZ6friPuSSk5MBg+LSPvTsbUToROhi1pAUhM4tdU9Pz7QXR+KZNVzrVvwy+4fRaOyeL1++c2J0pjGEQHoIEKHTupAEgYiIiPb4ATUZdycBQgVicBwkJCTAs2fPhA59pT8ROhG6mAVkL6Fj4hnw9vZO25ELbXhSdcVsNvcvWrToL0LHUn9C4HUEiNDVviY6dvRzsTi1s4HBJ80Umy0JwOmEOWzNr0qYduvWrY74QTYPifz5/HY0bqduz26dCJ0IXczyE0vo3K48W7Zs4OFh/yUNzIJ4D4m9X5EiRb4TY4PQMcbALrUBrBXwOZgnNxYfhsWYTM6bIXwNZcQTCiZD/YnQGXKGIFUCO5U1gmEcfqg0z2DcDasNBljCQn4WJJdnZzxa74ZHi9PxaN2X5xBe3bgj+KdPuds/whsROhG68FUjPigOI9iB251L2fAo/h6+p/vmz5//eynlvpDlHNi5jZPBMAP/ne5JGpcsx+zkNBY2rrkgx/wkU14EiNDlxVcW6cagzhMNYBjFRzg+mf7e7GzpBevXP+TTP6s+d+/e5a6dzcDjdUmJ/OV58WobcDnJhTYidCJ0oWuG6y9mh84dsXt5eYmZjtcYfAz1ADv29ff338prQFadOnTwN1qcF2eyAXhFAn5uTDSHhozJSiz9nS0EiNDZ8kfm2rTuksdotIXjSV8NIWrjmzPOZoWhlk0hK4WMe7kvRqxXwd34VjxaLyBWBt9xXIBcTEzMi8hgvsOACJ0InfdieamjUELHL7Pg6yvb99lXTMAd+zU8BWiG84ndMRtcgjp3t9kMM/BzI4cQfPBt+KvZbGhNx/BCUHNsXyJ0x+LPe3Zjuy4fgcH2Hb4p8/Ee9FpHfIP+ZjY4BUPotzf4ynjy5IkPvn50c3P7OIugdb4iefXjAuRwXl59X3QiQidCF7Rg/u0slNBz5coF3NU0pRpXGQafse8sWLBgG3wP8j+6CgouabTBavzMqC5WV/zMeAA2Q0vzpjW/i5VB45RDgAhdOaxFz2QMCh6GwW6T8c0sPIz2dVIHeIayJpjNSTMgPNySmVK3b99eih9c3fFZud3zijGe26VzEfB8GxE6ETrftfJyPyGEzhE5R+iOaHjN04TvhykFChQYl+n8PXq4GBNSvwYbjEEyd7NXV/w+weWnH24OWzvbXlk0Xl4EiNDlxdc+6U27ZjN6WcL+rTxmn6zXR9ts/4DV0NW0OeSP1/+EV9Ba4gfXGjxazCbtpMKkCX2WToROhC5shT3vLYTQuah27q65IxtGw8fgjr0NRsQffF0Pl6BOlXBHvRqj19+VWkd8dPej2WDqBBs3iotalVohkvcGAkTorC6Kth1Luzg77cALJUXlUhG/eVvwvsoCsylpJO7WkzHgrRDuAnbi8brkHwZibMAPLXj8+DHvoUToROi8F8tLHYUQeu7cuUXdNxejV1Zj8P3xe/bs2Zvi6xF07OhlNDtPwvdzP/xQzzyzTVaCM/u7zXbd5OzcGDZ8e9keMTRWHgSI0OXB1S6pzu06tcJd+To5856/puCt73v3PFCxeNHOeLwu34eBQFS44LiHD/kH5xOhE6ELXGKCduhcDImfn5+YKWQbg1/AzfvOXljSJWRdM5xEcFInMYrZwJaIeS86WUJDZLlaJ0YnGvMcASJ0llZCzZpGZ/8ic5wM0FcptYrgjmNjj2AowtgH1Qv7o6OjeUe7E6EToYt53/DdoXOZ4LgdOovt3O070GHlGoiJT1BMPfy+PdNsThyRVSyOYgrRRETozKwBzPhmNDv9gLuAqkrpNLJxA+hR6xPgruGw2mJjY3kXcSFCJ0IXs475EjpXcMXHx+6EiGJU5DXGZDbDhB+3w7e/KReQjrv1w2aTsTmEr47lpSR1khUB2qHLCi9P4UHdAlzAwqVqVeTILA8G9oR/9QWU9PfnqaDjuhGhC8OeS8jDBRPyaXInR+GjAwt9tELoL7D84/oNaL9iDSRiRUNlmu2ayepUGzatuaPMfDRLRggQoTt6bQR2LoMpXA/i47k8SqjSsvwHMDuwNbgwvCt/GQcidGGrgghdGF5cb60ROmdTMpJ5r7WhsPfCReGAiBiBO/X7ZpuhNoSFXBIxnIZIhAARukRAihFjDOxUFQxOu9EJsl8P83Jzg3VfBEOVksXFqOqwMUTowqAnQheGl1YJ/QUK2/86Cz3XbhAOiogRXEZKLPJS3xS67qSI4TREAgSI0CUAUYwI56AuzQw222YpEj9kNX+pfHlhW79ekMPB92ez0jO9vxOhC0ONCF0YXlondM6+B3Fx0GTuYrgvMPOicCS5Yo+2ZLDC5+bNa/eIGU9j7EOACN0+/ESNxopHXbDi0beiBgsc9PkH78P8Du3AKKJWs8CpZOlOhC4MViJ0YXjpgdA5G1NNJgheFQK/Xr4qHCARI6w2W1tL2NotIobSEDsQIEK3AzwxQ52DOncy2CAEo9llx35221bQrmolMWoyM4YIXZgriNCF4aUXQufs5PI6LNizH2bskn/zzCWtwlc7y6Z10lSLE+5WXY6QnVR0iWoGRitF5tzz8h0DemMUu+g6Lsy4jQhdmCuI0IXhpSdCf4HMiWs3oO3SlYCJ4YWDJWAEkboAsCTqSoQuEZBZiVGKzN8t4A/f9fkSvD08slJJFX8nQhfmJiJ0YXjpkdA5m2OexkPDOQvhHj5fl7MRqcuJ7puyidAVwNu5XXB3g8G2XO5j9raVysNMPGbnMlpppRGhC/MkEbowvPRK6JzdqZiIpj3u1H+/flM4aAJGEKkLAMvOrkTodgKY1XCOzDE7+oqs+tn797FNG0OP2jXsFcPceCJ0YS4hQheGl54J/QVS47b9BCt/PSIcOIEjrABtMP97uMBh1F0AAkToAsAS2tW5facmBpvTj7JWP0Kl1nbrDHXeKyNUPVX0J0IX5iYidGF4EaE/D5ZbvPcgTN35i3DwBIx4Xlfdqb45bM0BAcOoqwAEiNAFgCWkq7FdcE0w2HbjMburkHFC+uLVN9gzqB+ULlRAyDBV9SVCF+YuInRheBGh/4fXzr/PQvcQeZPQcJXazFZbddi07i/hnqIRWSFAhJ4VQmL+3rbr+0Zn6+8IrqeY4XzGeGMk+4GhA6CAry+f7qrtQ4QuzHVE6MLwIkJ/Fa+/I25B43mLhYMoYASS+iOzBSrD5rXXBQyjrjwQIELnAZKgLkFdixnBctIABtmY1tfLCw4NHwQ+WGRF640IXZiHidCF4UWE/iZeN6MeQo3pc8BixafesjXbbZPVuSps+vaebFPoUDARupROD/wir4vBfAJFylY1rbBPLtj79QDNXEvLCn4i9KwQevXvROjC8CJCTx+ve7GPoca0WZCUahIOKN8RNtt5k9mtGoSveMJ3CPXLHAEidKlWSMO+bi45n54Eg6GsVCJfl/M25mTfMbAvuLvJ9lheLtVFyyVCFwYdEbowvIjQM8YrNj4Bak6bDY8SE4WDynMEHr8fNJuS6kJ4uLxZbnjqo/ZuROgSedAY2HkrBsC1lEjcG2IqFAmA8N49wNXFRa4pmJQrhND9/Pzw+5S0Sxojc21WK2am5kJ0LRb8Baz402axWqwpqSaryWqxmEwmLDTFRsNASWdng4HXIsHcnCY0iJkPUhcXF4OLk7Ozmyv+P/7PaERLMCzaaDQ64U+DkxNaJ7GDuQjvhw8f8nIe6gc+Pj68+mql09OkJKg9fa6shV2sYFtkCV3bVyuYOdIOaT/9HGmJA+dGMh+DnzPj5VKhbMEC8GP/r3RH5hyechI692GOzwktsU+eJN17FJt6J+qh6fLtW7bTV6+7nLl2PXfs06dyuZTk2oGAT/bsUL5UyZiyxYuZ3i4c4FQor5/R39fHDWNKPDGpEsf6vKUToWcN1dPEJPho8gx4jOQuV7ParN0tYetWySVfL3L5r3y9ICLQTu6uuZPN6WeBw3h3L5bHF/YOGYDH7G68x2ipoxBCz5s3b4am/5+8nz5NRrJO2vbbEcPPR4/lMWO2LGraQcDVaITPP/k4ulm1alC2RHGPnNm8PZ2fb+0zNDIqKooXAHrcob8AJga/3FYYP1W2/O9cNjlwghrmjWuP8nIGdUoXASJ0exZGYKeyRjAcxw8LWRKn+2EU+28jhoC3pyzi7bFcsbH2ELrJbLbcvP8gcfP+A5ZVP+/IxaW6pKY/BDzd3aFH0yaxrWp8Ygzwz+eFpYRfyY1MhM5vTUQ+eoQ79ZmyRb/j8/THZpO1PISvlzcXLT9zVdmLCF2s2zp18jWaDX/j9bSCYkVkNi4b7siPjRoGubJ5yyFeNTKFEHru3LmtcYmJz/acOJkyd8t3ue7wfDaqGjBIUUkQKJIvn21gm9axdSuV98zh5eUWHR3txEewnnfoL/C5gacZn0ybk5ZdTpZms100JbhVgJ9XyHe+L4vibAglQhfnB4MxMPgAnuLVFDc881GuuIE4MXoY+OXMKYd4VcnMjNAtFov50Jmz5zbsO/j07+vXS+CHjHZT5qnKa+pS1ujkHFHx7VIRHevWzl31ndJlMgq8I0J/7tczEbeh0bxF8jnZZttiClvbVr4JtCuZCF2Eb43tOo8yOBkmihjKa8ixkV9D4Tx5ePXVeqf0CP3nY8f/3LDvQPLlO5Hvo/3az66jdSczZB+SeXSZgIBL3Zs0zFGj7HuvXEElQv/PUb9euARBK76VzXN4+6KrJWztGtkm0KhgInSBjjUGdqqKF2iOyFVwZeeA3vA+XlGj9hyBF4R+JfLutblbt0Uev3ipNF4kyzj6jYAjBCRCAOPlb3/64Yc3+jVvVrxgntyFiNBfBXbL8T9g4CZ5iqfhgf4zs8FQHjauuSCRO3UhhghdiJu55+Ymp/N41C4LoSzrFASffVhOiEaa77tl34FzI1auck56lvKO5o0lA5lFwDd79tMze3X3aPjRR6WZVdIBik35aQcsPvCrTDPbrpni3d6n5+n84SVC54vVuHFOxssR++V6bt63dk0Y9llDyROj8DWPtX5RsbHxk9duSNz66+F8sgXgsGY06cM0AtzVt6A6n94a0SHI1zdnDn1Hq/7rKe69GbxyDezDI3hZGj1PFwQrETpPuIxBnYdgRPtMnt0FdWtS9l1Y2qUjcOVQ9d5u3L37aPCiZabjFy7k0zsWZD+7CFR//71bc/p8lb2gn18udrVURjPMnAj1Zs6Dyw/43ecXqhU+Tw/C5+lhQsfpsT8xCB+vB3ULMNrMF+W4b/5ewfywfUBfwDSXfDTRbB+OyHvMmJ1yPuJWfs0aSYZpDoEP3ipxffmQQT6F8ubVNbEnPnsGH46dDAkpKZL7GA8BYs1GS2lYv55fjl7JNVCPQCJ0Hr7C1K6/IZl/zKOroC45PDzgj7EjwAsTX+i13YmKetxz1pyUv65cox25XheBBuyuUuadG0sGD/D19/XNoQFzRJkQ+SgWqk6aDlzBA6kbHu3vMIetbSK1XK3JI0LPwqMugV16gsG2TA7Hn8S75gV8ZSubLofKkslMSEp61n3GrEeH/jpDd8clQ5UEORqBhpUrX100sG+Ap4eHfkoivgT6vn8uQOdVIbK4wWo1tLNsWrNZFuEaEUqEnpkjW3cqYDQaLuHuXPIAmA3du0CtMvoLmMXc6dbF2368PSN0UxGsYqaRtxGZQQj8hwCWhbNM7NrlZnCj+sUxy6zuPmMX7NkP03fulnxJpB29m51LQvjqWMmFa0Sg7habEL9hINw+DIT7VMgYPn0H1a8DgxvW49NVU32OnDl7r8fMOfkfx8dryi4yhhBIDwGsChe/buTw+PJvl9JdXEjwqjWw95+Lki8MPMz/3hwaIluZaskVVlggEXoGgDu369QKizRJnjXh3QL+sGtwf0DZCrvacdPFxMUldJw0xfT31eu6DhxynAdoZkciULF0qXvrR32DF928PR2ph5Jzp5hM8MGYSfAkOVnyaa02aG4JC/lBcsEaEEiEnp4TW7f2MBq9buAtMkkDtbh7rBcmjYXsXvp4X+N1Fsus0M3RC777nu6Sa+DDgkwQjwD33h/RIfDWVy2aF+LKuYqXpJ6RF+/egzp4nU3qhlXZ7pvj3UpQwpk3kSVCT2e1YeGVGfj++1rqhbjhi2Co9a4+Ep5di7wb23zkmOy4OzdKjSPJIwTUigAWXErcNWuaKX+ePLqovDR9xy+wYO8Byd2FR+/T8eh9uOSCVS6QCP11B3boWsposWB6V4OkF8OblSsLizu313wmOC5z1PKftj+YsGYt7cpV/uFA6suDALdbn9WnV0Tgp7WLcL9ruVkw8LXW1FlwPTpGUjOR0E1mG5SFsBCZUtRJqq5iwrS9mkTAiLvzo/ge+0jE0AyH+Hh6wp/jR4Kri4uUYpmTlZySktp27PiUPy5epgpozHmHFGINgY/Lvnd/49hRuV2NRk1/MDx88gQ+HDdF8hrqePR+1By6VvL8IKytEyH6EKG/hJZzUHBHfLi1TgiAfPru/3oAvF1A24GuV+5EPm7+zahcsU8pgp3PmqA+hACHABZ9Sd0zd2Zy/ty5NZ2QZssJrMwWJnmMMZfEhtLCvvRWIkJ/AUbHjl5Gi9MNvKbmJ+VHTd/aNWB408ZSimRO1sY9e+8NXboiP90rZ841pJAKEOBi5FZ+PTii0UdViqhAXVEqco/iWi5cCiduRIgan9GgtAA5V0MxCAl5JqlglQojQv/Xccag4HEIxlgp/Vgsd244NGIwYHIJKcUyIwuD2K1dp82I3nPylCzlZJkxlBQhBBRAoEWN6tcWDuhXHAlek5/LCcnPoNzYiZCcapKOjd1rAAAgAElEQVQUTXyePhID5KZIKlSlwjS5cAT7onU3H6OL+Tbuzr0Ej81kwPFRw6BQbm2mdo3H1K11Bwyx3oqK0scdPCkXBskiBDJAoGShgnd3z5ru5+Hursnn6nvO/gNdvpX2qSZu/p+Yza4BEL7iid4XFhE6rgAMhJuLgXADpFwMA+rUgq+bNJRSJDOy7kZHP6nZb5A35mPX5tEDM0iTInpEILuX19Pfly508s2hvZrr3NF7s3mL4c9btyV1LV1jew4nEXr79gWNNhd8dg6SfSPmotr/mjAKS6Jq7wr2ifMXoluNHpeHq4FMjRAgBORBAB/TWQ7Mn/3orUKFJI3pkUdbYVJjMHD2/TEThQ3KojcS+jOzCYpCeMgDSQWrTJjuCd0lMHg1fq3pKqXffhnQB94rUlhKkUzICt277/7gRUv9mVDGUUpw94a5R5wGJ7BhMFPaPWL8nZoECNisaVebDFzRHvwdLFS8B3PB36pbqWKABOgyJeLbX4/A6G0/SaoTpoRdgilhe0sqVGXC9E3oXBIZq/UC9xEtld/aVSwPs4LaaCqBDPchO21D6O0FW7/X3rcUzvGubvjcxQgGFyOSNP7kghiN+OIydHJkzb2ckbz1kbFTqreCZHJsVjwNsuAejCN57sURvtkCNosZDPiycadFZjNASopkc7IkaHbvL68F1atbgiWd7NWFSzjz0YRpEBkXZ6+o/4/HzymL2eZUFDatuSOZUJUJ0jWhuwQFb0J/tZXKZy5IBBcmjwVPd3epRLIgxzZs2Yob63btLs6CMnbr4OYGBnxxJG7giJz7nZpmELCl4O2lVCT2lFSwcQTP/a6BNrJj0LU+rVpy70HNfGZfwlzvn0qf6z3EFBrSRQMuF2WCZhaHYOs7dChhtBovS7k7X9YxED4r/4FgVVgdwN0r7zVnXuRPvx0tyKqOmellQ8J2ekHebq5I3pr6oqVGlzhEZ47kbUjwkIpk/wyrf5lwN6/C1q9Vi7sjOrYvoELVM1S597pQ+OH035KZhLt0s9lgLAGhq29JJlRFgnRL6Lg734h+CpLKV8W5O+ffDNFMWVTumL3H7Hlx2387oq4iEu4eAJ5eeAHREwzazqgp1dLVnRxbKu7ek5IAkhOR4NWVj6RH82ZPx3XumF0rOeATEf93R46HVCmDbG22Vaawtd11t7C1dHwjyHky7M4PDx8ExfNJWm1VkElSd+6/ZJlly+697F9L44LS8FaBwQOvw3shkTuxr7LUviJ54hFIe/6emIgEj+SejCSvgtanTSvryPaBksX9ONrkrSdPQf/QLZKpoeddui536C6Bnddj1FoHqVZQ0/ffg6VdOkolzqFyuJ358FVrYN32HQ7VI9PJueC0tF04vvAnNUJACgRsXLAdEnva7p0jeHwvsNq+6dIZ+n7elFX1BOnFBciVHzsJouMTBI3LrDN6cpklNKSXZAJVIkh/hC7D7vws3jnHIgsqcXnmak7fHA7zQrlYQQYbtxP3xkJuHJlrvOwkg+jrSqU0ck9MAFsCFhti9Fh+Zr/e0OHT2prwy5FLl6HtstWS2YIbk1Szs6UIbNhwXzKhKhCkO0J3Ceq8HANFe0jlmx7Vq8HYls2kEudQOduPn4DuU2c4VIc3JnfG5DzZc4AhW7bn18moEQIKI4BhVgDxT8H2FDOLckTPUPtpxlSoWOothjQSpwoXgFtt0nS4HftYnIB0RiGpzzaHrR0imUAVCNIXoX/Ww9OYLTWae+oqlW8uTBoLObzVf+x7NfIufNK7n1Sw2C+HuweeIxcSeXbajduPJkmQAAHuPrwNa3sD9+LuwzPQjPgl9+TKpeDvq/6aESev34DmC5dJhmpajve4bHlh10Jt3F3kgYyuCN2lXefemOVrEQ9ceHXpVbM6jPr8M159We70OD4eynXtAakY/evwxiV4yfmcyKkRAiwiwB3H2/A9A3G4m+SS3ji45cDTq79XLwd3ledU4OJ3PpkyE25Ex0iGKH7t6oTP0tdLJpBxQfoi9KDg8+iPd6TyycUp4yA7PtdVc0tBEq/QszfExMY61gw8Wjfk8gHw9qYduWM9QbPzROA5sT/FHTsSu4PT1JYpUQL2zJyq+muzp27chGYLlvL0QNbdsF76UXPo2o+z7qmNHrohdGNgx48NBuffpHLbwLq1YUjjBlKJc4gc7htx09Hj4NS5fxwyf9qkaTtyInLHOYBmthcBVoj981o1YemAvvaa49Dx3GdS7Wmz4UrUQ8n0MBmgLGwMOSeZQIYF6YbQMRhuAwbDtZfKF1emTQAvlad4nb5lK8zbGCYVJMLkcPfFc9EzcmGgUW+WEUiLjH8Sh8/ZMT+5g668LR06BD6vVpVlmLLU7a+IW9AES6xK1fAcZbEldG0fqeSxLEcfhN66m4/RaI7Cq06S1DMdVO9TGNyoPst+zVK3Excvw+fDv8mynxwdDDlyAOCunIqdyIEuyXQ0Ajas42njHmHhtTelG3ed8wQGyRXKk0fpqSWbj9ul18Jd+lWJdul47J5ofpzdVw/BcbogdCyROgBLGsyVasVdnIzPzjG1qFpb7NOnUKZTN+UjdblEMLl8saqZZKXn1eoC0lsHCNjw/rr1UQwYFC4Q45MjJ/y5aim4u2L9ApU2qSPerTZDsCVszVqVwsFbbb0Q+t9I6O/zRiWTjoGVK8CswDZSiHKIjLT7nn0HQkRkpHLzY051A+a6T0vPSo0Q0BEC3G4TMDmN7fEjRQPnqrxfFr4fP0a1AaYcbh+MngjRCdKccuAu/SAGx2kjC08m7x/tE3pg8NsuBrgo1WfIiVHDoGBu9d75nLElHOZuVCgTHFdHnLuChkfslNlNqhVIctSIgI2Lgo+LfZ6cRqE2vW9v6FRHvRz2w6nT0HuDNJ9V+AXBZnYyF4aNGxXcySjk6Jem0TyhG4M6zzGAYaAU0FYpWgS29uulWnK6fu8+fNxLodgQLFVq8MuLFc8kCVuQwn0kgxBwOAJcjXbbwwcAXPY5Bdofq5ZDwTy5FZhJ+ilSscxtiWGj8EagNEl8kNNHYea4ydJryo5EbRP6uHFOxssRDzBORJIIkV0DekPZIgHseE+AJqkmE3zY/Ut49BgjcOVu3K6ce1G+dbmRJvkqRCDtmhs+W+eO4uVu/nn84OTyRcBllFNjm797H8zYtUcq1W+YQkOKSyWMRTmaJnTnwODPnAzwkxTAF8iZE46PGa7axA3DV66Gtdt3SgFFxjK4O+V5cFeu8ut88oJE0gmB5wjY8PmwLQbvW8t8xa17i89hQmd1VoOMw9K2ZbBeulTNZrN+ZA5bd0wqeazJ0TShuwQFc0V2W0sB+vJOQdDkw3JSiFJcRsSDKKja8yt553X3AEPefHQVTV6USbrGELDhyZktCguC4U8528mVy6CQnyQHlXKqma7sTstXw368ZitFs9pgiSUspLcUsliUoV1Cb93a1Wj0jMNjXw8pgL8+Y5Iqr4Gk5UfuOwCu3ZEvFsSA12QA07bSEbsUK41k6A2BtCN47rl6crJsphcpWACOLpynyhPG81g4qt6s+ZJggx+H98xhIQUkEcagEM0SunNQcCOMsd4hBeY9PvkYxrZoKoUoxWWs33cAhi6ULuvSKwbgM3IDPqMzeHkrbhdNSAhoCYG0621Y7MXGFXyRqY3r8QX0bNxQJunyieWwKYdX2GIkusKGBXUqmjatPyWfxo6TrFlCl7Lu+bGRQ6GwCiNFkzGi9t1OXSEJE1xI3rCYilO+fACubpKLJoGEgF4RsGF2OVu0fM/Vr27aAN4ekhxaKuqi8BOnYEAY9wTV/oZfnSaaQ0PG2C+JPQmaJXS8rhaD+0e7L4znzeYNf04Yrcrj5BGr1kDIz9ulX3VI4gYkcwOSOjVCgBCQFoG0q20P8Lm6DKVZ29SvC/O/+lJahRWQloCbklLDJeJgG5wxhYWoMyAqC6w1Segu7bpUBifbcSnW2dx2LaFNlcpSiFJURtTjx1Au+Avp5/TE9K3c/XK6kiY9tiSREPgXARveU08jdVOq5Jic/nYl+PtihUOVtVYLl8Gx6zck0dpkdSoAm769J4kwhoRoktCNQcGT0TBJKo+cmzgafLJlY8hl/FRpNWYCHD1zhl9nnr3S7pZzNcupEQKEgOwIPA+Wi8JguSRJ5ypf5h3YPmWipDKVEHbg/AXouDJEmqls0A936QulEcaOFE0SOhZjkSR3+7sF8sPurwew4y2empy5cRMaDBzCszfPbkjmTkTmPMGiboSANAhwAWFppJ6UKI3Af6Xsmj0DypVQV46V5NRUKDF0lCQ4IKy/YLS7+iIEs7Bee4T+eXBOF0+QJFR0Bd49b6zCu+d1Bn4N529IczSVtn7wWpqTj93hCJK8EUkIIaA3BNJInUtAI1WUNwJYvHBh+G3BHNU9Ouu84lvYd+GS3UsAA+Oeme9FZINDh5TJwWu3xvwEaI7QnQM7t3EyGDbzMz/zXhenYJlUT3VVCDt5+TI0GyrJ04bn4GTPAU6+6swFLcUaIBmEAAsIpJH6o2iAeOnSxW6fNR3KlyzBgnm8dThy+Qq0XbqKd//MOtoMto/NG9celUQYI0I0SOjByzDda0978S1bMD/sHNxfdd9gq3NJZG7fsdf8tPGG7NnxnoA6s0tJAgAJIQQYQ8AWEwO2eGkqtqlxl56KwYJFh0izYcFd+hi8vqa+YIJM1qTmCB3vn19FKrL7a+fabp2gznvvMvZ2zlyd4xcvQfPhI6XRGZPFOGE0OzVCgBBgB4Hnx++4U5eosMtPM6ZCxVJvsWMgD026f7sOdp79h0fPzLsglIfwOXotuwUxJEBbhN6xo5+LxRkjSOxvV6aOBy+VJWCoNWAwXLoZYb/xXng1jSuyQlfT7MeSJBACEiMgZaBcmRIlYN/s6RJrKK+441evQ8vFy+2ehCuRbnYzZIOQEBkyb9mtnigBmiJ058AunZ0MthBRSLw06KMSxSC8j7qSL1zCXO21+vS313QAD8/nRVaIzO3HkiQQAjIhkEbqXFEXCfK/H16yAEoWUE96cxMeuxeR6tjdaqtj3rR2v0xuUlyspggdr6utAAN0txfFRe3bQPOKFewVo+j4L2bOgR1H7Izv4DLA5S9AZK6o52gyQkAcAmn31O/fBcDrXPa0+tU+gpChg+0RofjYFguWwIkb9p9G4nP0cfgcXbr6rIoj8eqEGiP0zqeRjT6wF9M/x46AfLly2StGsfFPsGZw6fadsawyLk+xzdkZDAUKYTpXZ7ESaBwhQAgojEBaRrl7WEnRYrFr5vPrQ8Anu3oSaG09eQr6h9qf2x3POXaZQ9c2sgs8hgZrh9B79HAxJqQ+Q4OwyJr45u3mBhfx+bmTk11ixCsgYuTUsM2wYJMdi5urmpa/IBhcXUXMTkMIAULAkQik5X7ndup2fKHv3qI5TOjcwZFmCJr7bmwsVJowTdCY9DojZE8wMA7rP2ujaYbQXdoGVwRnOGmvW7p/Ug3GtWhmrxjFxlvx2O1t3J3HJ4lPD2nI5w8GfHZOjRAgBNSJgA1P6dJqqotsbi4uthtbQg1q2chwp5HFvx4JKXhCYW8zOZlLwoYN1+yVw8J47RB6u+AvcW++1F5Qt/XpCZVUlBLxwN9nof1YOx4BYTpXJ0zrSo0QIATUjYA19hHAkzjRRoRNGAs13y8rerzSA4dtCocNx/+we1qMROhgCV270W5BDAjQDqEHdcb0QYZu9mKqtutq7cZPMv16+i8XUXbjrtwJd+fUCAFCQP0IpEW+cxXaniWLMqZauXKJW8eP9hI12AGDjl6+Cm2WrrR7ZqsNFlrCQvrZLYgBAdoh9ED7A+JK5MkNh775WjVR3vHJyba32nUQ50Oj8XkQnIpiBRh4v5AKhADTCNiwhrotkguSE3cUfWXTBls2Dw9xnykKI/MkMQneGTnO7lnxa9BJDIxTX43sdCxXheP4eMwY2Dke70578+mbUZ+hDepCf3yppYX8sufxiKXLhZ+XUxCcWlxMehICghGwpWKQ3F0kdRFtTv8+0YG1a6km3/O7SOiPkdjtaVoKjNMSoSchoXvY49gd/XtDuaIB9ohQdGyNPv1NV+5ECj5uN2BKVwOmdqVGCBAC2kTA9vQJFnOJEWxcgH/eB8eXLckneKCDBoz57gdY/dvvds2OO/RE3KFr4gNRM4TuEhTM1dQrZY9nL+N1NW+VpHt9kpDwDKPb3YXaa/POBs55/IQOo/6EACGgMgSsURj1LqKO+uWNa1Oye3u7qcHcI5ew+toyO6uv2WznTWFr1VW4IwPnaIbQjUHBP6Axou+bZXd3gwtTJ6jm+fmWAwfv9Z+/KL+gN53RBZ+b431zem4uCDbqTAioEYG0THKRtwUnnVkyeMCN5p9UL6YGm2OwnOz7o+0umBZuCg1powZ7s9JRM4SOddADsQ56aFYGZ/T39lUqwox2rcUOV3xco8HDzH9du2bkPTE9N+cNFXUkBLSCgO3Zs+dJZwQ0NR27W/EBeOFBw+3KkmkFaGkJDfleAETMdtUMoUNwsLsxFe6jQaKy/izrFAiffWh31lhFHJ2YnJxaol0HYWndcvnifXNR0Chik9omyebuDsXy+kHh3L5QIl9e8PX2Bk83V/DCTIOemHEv7See+pjMFniCSX8eY+KP2IRE/D057Xfu9Sg+ASKiY+DOI7w/TI0QkAkBMffTr23akIrVJoV9xsikf1ZiP5u7CE7fwpMIEQ2v+sWYw9aqJggwKxO1Q+hoqXNQl2ZOYPshK6PT+/vh4YOgeD51xIIcOv3Xg8Dxk/griwSTltqVKqiJWRrggfjVKlM67VUNa0cX8/MDH29pr+tevf8AzkfehT1Y53n76b/gQdwTUbrSIELgdQTS7qdzR+8Csqr9OGXi3Upl3lFFCbZ5v+yFmfgS2hAXGxhs9cyh6/YJHctqf00ROgcyPksfh0aNFQq4mhLK9J07//HWQ4d5X1dLu29OedoFLYn3CheCBu+/B5++VwZql3lH0FgpOv+D5XD3IrlzBL//n/NSiCQZOkbAhmVWbQ/u8UYguEH9K1N79XiL9wAHdjx88TIELl8tWAP8mvM1RrfPEjyQ4QGaI3QOa+egzu0NNgjBHSmvZ8xcQZZL01QTEGd7K7CjgXfu9uw5wMk3N8NLkB3VuCP0oGpVoW3VylAqPzsZ9JKwPObO039D6O/HYfuff7EDGGmiKgQs0VFgSEjgpbOnm1vi9S2hXIEH5jniXuxjqDhhKi+7uE64MU+1GQyY7jUknPcglXRk3lmicWzbsbTRyWkdknqWhc0/w53Ysi4dRU+l5MCo2Nj4cl2686tzaMSSqAUD6Kg9Ewdlx2uK3T+tCe0//gjeLVRQSVeKmot79h5y6DeYs2MXRD15KkoGDdInAjYssZp29I7R73za+XXfJvrkyCHtsyU+EwvsY0K7igwewWsUkvkps9XaCTavv8hrgMo6aZfQnzvC4BIY3N9msE3CAqEZLsxpLT+HjtU/UoXrthw8FNl/3kJezGPI7QeGbPy4XxXGS6hkHqz9PKhxwzQy50hdbY3btS/YtQdm/bwTnuJxKjVCgA8C1rjHAI9j+XSFjaO/uVW7QnlVZNqqPH4qRD5G2zJoSOQJGEI00hS6diF2sfECQIWdtE7oz13Svn1Bo824Gkm9Xno+2tH/K8wQV0QV7us8efqjPSdP+mapLD4zd8Jn59ReRYCLSh+DX+A6ffKxJqDhIufHb90GS/fu14Q9ZIS8CAgJkFPTc/QRW76Ddb+fSBc8fFa+x2wwd4ONG8Xlw5XXJZJK1weh/wvZv8/W5+Ex/CsPlc9NHA0+KtnJlmjbHhLxbmlWzeBfAAx4tYracwS4CP9edT+Fye1apV0p01q7HvUQhodtgR//+FNrppE9EiNgw+foNnyenlXLnSN77Ll1a3yy6sfC33/A2JLe68NeUQVj2KPxNcCyKUR0fhIWbBOig64IPQ2YoKBcLjaXBfgJ3+EFULdmTQEjVh9jvWG612RM95r1+bAnlkXNy05Ql6NxDcBd+dqvesJHpUo6WhXZ5/8dS0r2Wh0CF+/yj2iWXSmagDkErFzxFiziklWLCA8zu7m6Mv/hyN0KqT97wX/m2GzrTAbTAAgNzfgcPivjVfh3/RH6v04yBnWqhfu2dT6engXPTR6nisCx4+cvPGj+zegs75/TNbX/3om969eBqYFtwN1FcA0bFb6d/1N5xf6D8E1YOD1fV7UX5VPemowVyrja6Vm0w4vmRZcsVIj5xCtRmLfhw3GTOWtu2cDaBe+WH8zKNi3+XbeEnubMjh29ulaqGjqtbaumanDutA0b78wP/z7zB+O0O09zJZe1bX3vL+Gz8urI/ifH+uOO4ZvNnAtXMGkNNULgdQSs93CXnpL5Ln1+/z7X29SuVZx19JJTUqH40FFzzObEURAertsoUX0TOq7S69evj8mWLdt41hcsp1+Tr0ck/HnlSqZl/mh3DlAC75P/OHQQlMSUrHpvic9SoMvSFfDDqdN6h4Lsfw0BK6YkhqjMd+lta9e8Oq9/XzU8q7L5+fk56d3Juif0iIiIUE9Pz0A1LIRCLdqAGe9cZtRsnt7gnFffJFYfcwps6tcbvDCPOrX/EJj4/Y8wEWtHUyMEXkYgq116gTy5H55atVwV9ZYxDirAx8dHXFJ3jSwL3RP6zZs3j3t5eVVm3Z9YkCUFC7JkylJ6351zUezzOrdXRTyEI9bbT3+ehvYLl0KKyeyI6WlOBhGwYb10G1c3PZN274etmFiN/UIQKSkprQoVKvQdgzArppLuCf02Nnd3d+YvbF++fTumZt+BGedw9cDI9nz6jWwf37oFjPj8M8XeOGqd6ChGwTecOhOemUxqNYH0lhgBK5c9LpP1oJaMcUjoE5DQBdfxkBhOh4rTPaFHRkY+dXV1ZT6d2g+Hf7vVa/a8jLM2IZk7IanrsS3tFgzdatfQo+mibN595lxasBxXS5oaIWCLjwdbzMMMgdg/b9aDd4oWzfJ2jaORREIPQ0IPcrQejpxf94R+7949Ez57Yf6e5bT1oTfnb/2uaLqLxQWzwhVk/pBBlnW+9qseEIgFVagJQyD0yDEIxmA5aoRAWva427cwx3v68TlrRgy92aBK5fQ/exiCDwn9MBK6rr/Z657Q79+/b3N2dmZoWaavSqdJU+7v/ePPdM/UDXkwZ7s384cMkmM85LNGMKVda8nl6kUgBcrpxdNZ25lZjvdh7dtdGdCmNfOlVE0m06UCBQqUztpa7fbQNaFfu3bND6+sRakg3gOq9vzKHPEg6s2TBCcnMBQuortAsFplSsOu4UPACe2nJh6BwPmL4buTp8QLoJGaQCCtEtvtiHRtaVy18rVVw4eWYN1Qs9n8MH/+/Lq+5qNrQscra1XxytrvrC9U1M9WsHlrgyW9soc6rHcekCc3nMTsfrm8mK/syPzS4oLjamEt6T9v3GReV1JQXgSsXOY4LoPca61Yfv/7R5cuYj7i1mq1JuTLl09/R5Uv+UvXhI479M+zZ8++Td63if3SU00mc0Crduk+5zfgs3MDPkPXS/PAKnLHJo6BdwoW0IvJstt5L/YxVPhmLMRgcBQ1/SJgTUwEePjmFTY3F5dnEVs3MV/pyWKxpPr7++s6AYXeCb07EjrzkUFYlCUJi7K8GcLu6oYlUnmVRtfMp9SC4I7wZd3amrGHFUN+vXAJ6k6ezoo6pIcDEHgeHIfH7umcBN7dFs784y3U35o3b172A6Jk9K2uCf3q1avf5MiRIy2jP8vt7sOHcRW698r5ho6+ecApe3aWVZdUtwbvl4Wfhg6UVCYJ+w+BMVhTetqP2wkSHSNgi40B25MnbyBwa+smi6uLC/Nkielfdc1pujYej9wn4A59NOvv34s3Ix7WHjD4jfSLacFwKojQlwLf3Fiv/q/pkyBvDra/wFy+dx8iomPgUXxC2hF2PNau9/X2hhyeHvjyBD/Uv0Ixdm8AFes3GCIfxUrhMpKhQgSsuF7h/t03NL8Suu5ZNi8v5o/d8Tm6Nz5Hx2cH+my6JvQbN25M9vb2/oZ11x85e+5u69HjXn1o7O4OTv76eY68bcgAaPzB+0y56uHTp3Do/EU4hMfVJ65dh3O37/DWr2zhQvBB0SJQuUQxtKsc+Od68wCGtzAJO27DiPe2GPlOTb8IWLk76ZZX0wOfWbPqqZ9PLra/TaPL8Ng9Hx67R+nVe7omdKy0Nh2vrQ1l3fnbj/5+q/uM2a9kiTPgcbtBJ8ftHOFtG9KfCTclpabClt9PwIYjR+HwxcuS6VSmUEFoVK4s9G1QD/LlzCGZXDGCuGfp3DN1avpEwPooBuDpq8fux5YtelTE39+XdUTwLvqHeBf9L9b1lEs/vRP6bCT0QXKBK5Xc7w79eqPP3AXFXpanp+P2U1PGQ9mAwlLBKUoOd2Vw5f5DMHrLVniSJF+5ZS6Kf0Cj+jCoccO0Y3pHtEv42KDc0JGUGtYR4DMwZ3rH7ocWzn1YqnBh5quuJSUlNSpSpMguBmB0iAq6JnSstDYfK631cwjyAibdioTe92VCd/fA4/b8AiSot2uLShVhU/+vHGrAyWs34KvVIXBWwJG6vQr7eHvBoi6doFWVSvaKEjX+6w2bYP6u3aLG0iD1I2Dlot1fKtW8a+a0e+XeKsn8h05ycnJwQEDAWvV7QJwFuiZ0fIa+GJ+hO5YtePjtDULP6QNOuXLxGKn+LmdmTIbSBRzzOcIdr3OR3wt27XEYkF/UrglLunVWfP64pCQI6D0QkhEDavpDwBIdBYaEhP8bvnXi+DvVyr7LfMEI3KF/jTv0Wfrz2HOLdU3ot27dWubh4dGTdedvPXDoRt/5C/9/5G7IXxAMbtrPn9D+449gTa/uDnFP9NP4tHvZFyLfjPhVWqG3/PPBTkxzWzi3Mo8wtxw7AWPCv4cbURlX4FIaA5pPWQRer8C2buTwiLqVKhZRVgvhs+EOfRru0EcIH6mNEVaCdNAAACAASURBVHon9OVI6D1Yd+XWAwev952/qPjzr2BO4FSE3WtPUmL5N15Tc0RGOO7aWd1J0+BWzCMpzbFLVhFMd/vr2JGyRsMfvngJhm7cDKdvRtilKw1WPwI2jHJPq8D2b1syeMD15p9Uf/4ZxHDDHfpS3KEzf+oqF4RE6Gog9Jeeodu8vMHZT/v1B6q+VSKNwJRuUZhUo/LIcXDvcZzSU2c5X4m8fvDruJGQR+LbDVxswMhN4cDVSadGCLxAwBJ5GwyY659riwb2u9GyZo1XAnNZRAp36Mtxh/4li7opoRMRuhoI/aUjd71cVwvp1QOCPla2zjn3zLzGuMlw5tZtJd57ouZ4F6+3/TZ+FHhJ8MjlLuZwH7V5K2w8oob6RKLgokF2IGCLwaxx8c+vrxGh2wGkgkOJ0NVG6Ji73YA53LXcuMxq95cvVNzE5rPmw46//lZ8XqETNqtYHsIH9BE67P/9YxMSYfK2H2HhL3tFy6CB2kfAlhAPtujncRRE6OrwNxG6mgjdYMDn58yfetm98gc2bgDTg9raLUeIgNUHf4Veq0KEDHFo32lBbdLuqgtp3AnE/J27YdbPO9NS0lIjBDJDwIbH7TY8didCV886IUJXE6Hr5P650lfVIqKjMZHKKOAIT01t76hhUKP027xUXnXgEEz47gd4EPdm4Q1eAqiTLhGw3rqZVn2NdujqcD8RupoIPUdOcPJR5uqSo5ZvAF7Nujpf2Wukajlqf90nebJng4uzp0P2TDLKcbnZR2DAG11Bc9SKVve81gf3AZKTiNBV4kYidBURusEvHxi8vFSytMSpyaU9ndG+nbjBIkZxV7XqTFJvHfCM7ur/fvkqDFofSlfQRKwJGvIfAtbHWHkv7jERukoWBRG6mgi9UGEwGF1UsrTEqbl/9HCo/nYpcYNFjCo/YoygKmkippB9yI9fD4SGWNiFa1winJGbtqoiuE92YGgCuxGwJmK2uIdRROh2I6mMACJ0tRD6gkXFtB4Qx+Uvv79sIRgw+E+J9uOp09B6rvLR9FLb5of30rcPG4S51/dA6NFjXAlJqacgeTpFwJaKgXF3bxOhq8T/ynxyMgoGpn5VSaY4TP26bGUxp/zarn+udKpXLoHMXxH/ZcNidJmSWoSAQxGw3rxOhO5QD/CfnAhdLTv0b9cWc8qdh79nVdhzcdfO0P3Tmopo/is+O6+r4mfnioBEkxACiIAlMhIW9+lJmeJUsBqI0NVC6OvDijnlyKGCJSVexZNY97ycQnXPv1q9FrirXNQIAUIgcwSs3DP0Hl2J0FWwUIjQ1ULoYeHFnDQc4W50doaEkBXg5OQk+9vGgvdq/Xv2Ba5EKDVCgBDIgtBjH8Girp2I0FWwUIjQVULo/cK3FdNyydRKJYrBkfGjFXnL7Dt3HhpNU/auuyKG0SSEgAwI2J4+hYWdAonQZcBWapFE6Goh9B+2FzMosHuVeoHxlfdVvTowr3N7vt3t6jcsdDPM3fGLXTJoMCGgFwSsSYmwKKgNEboKHE6ErgJC37T/YMTgn3cVUcF6Eq3iqp7doNMnH4seL2SgFu6eC7GX+hIC9iBgw5TIC9s0J0K3B0SFxhKhq4DQ1+3dHzlix+6CCq0Jh0zD1T7naqDL3R7i8WHBXv3lnobkEwKaQcCGMScLW3xGhK4CjxKhq4DQQ/buuzdyx578KlhPolW8vXge5MspfxT/nrP/QJPps0XrSQMJAT0iMP/zxjda1azBfKnH5OTk5QEBAV/q0UeczUToKiD0VXv2Ro3duTevVhepM8YGJK1bpUiGOO7ZOfcMnRohQAjwR2B200a32tWuGcB/hGN6EqE7BncmZlVLprhlv+yJmfjLvtxMgCaDEm/554N/Zk2VQfKbIr9YvhrWHT6iyFw0CSGgFQSmN2kY2aFOLeYf+xGha2XFibBDLYS+ZNee2Mm79/mIMFEVQ+q+9y7sGD5YEV2rjZkIf1y/ochcNAkhoBUEpjSpf69znU+Zf+xHhK6VFSfCDrUQ+qJdu+Om7t6fU4SJqhjStVYNWPZFsCK6BvQZCPcfxykyF01CCGgFgYmN6kd1rfcp84/9iNC1suJE2KEWQl+wY/eT6Xv3yx8xJgJDKYYoVQOdq0Lm1qGrFCqTDEJAVwiMb1Tv4Rf16vixbjQROuseklE/InQZwRUgemjTxjCpbSsBI8R1vYc78yK4Q6dGCBACwhAY17B+dPf6nzJfHYoIXZhfNdWbCJ0Nd45q0QzGtPxcdmXO3r4DFUaMkX0emoAQ0BoCYxrUfdSzQV1f1u0iQmfdQzLqR4QuI7gCRE9s0xKGNWsiYIS4rqdv3oIqo8aJG0yjCAEdIzCqQZ3HvRrUy8U6BETorHtIRv3UQuiLdmJQ3B7tBsVND2oLAxs3kNHTz0Wfun4TPhozQfZ5aAJCQGsIfFO/TlzvhvWYD8wlQtfayhNgj1oIXetBcXM7tYfe9esI8Jy4rieuXYfqYyeJG0yjCAEdIzCiQZ24Pg2I0FlfApQpTgWZ4rRO6HM6BUGf+nVlf69w98+5e+jUCAFCQBgCROjC8HJUbyJ0InRHrb3/zzu5XWv4+rNGsuvxz51I+HC4MjXXZTeGJiAEFESACF1BsO2YigidCN2O5SPN0JHNm8LYVs2lEZaJlGtRUfDOoOGyz0MTEAJaQ4AIXR0eJUInQnf4Sh3UuCFMC2ojux6RsbFQrK8yKWZlN4YmIAQURIAIXUGw7ZiKCJ0I3Y7lI83QL+vWhgXBHaURlomUuKQk8OveW/Z5aAJCQGsIEKGrw6NE6EToDl+pnT/5GFb27KaIHp6dvgCzxaLIXDQJIaAVBIjQ1eFJInQidIev1JaVK0JYv68U0aPUwKFw82G0InPRJISAVhAgQleHJ4nQidAdvlKrlXoLDo4ZoYgeNcdPgd+vXFVkLpqEENAKAkTo6vAkEToRusNXauHcvnBt/ixF9Phi+WpYd/iIInPRJISAVhAgQleHJ4nQidCZWKkpG74Fg0H+5bhg1x4YsiGMCZtJCUJALQgQoavDU/J/gjKMA6V+Zcc53A6d26nL3Q5duAj1Js+QexqSTwhoCgEidHW4kwidduhMrNQDo0fAx2+/JbsujxMTIW+PPrLPQxMQAlpCgAhdHd4kQidCZ2KlhnzVA4KqVVVElw+GjYLzkXcVmYsmIQS0gAARujq8SIROhM7ESh3atDFMattKEV36r90AS/fsV2QumoQQ0AICROjq8CIROhE6Eyu1VpnSsPuboYro8v3JU9Bu/mJF5qJJCAEtIECErg4vEqEToTOxUrN7eEDMqiWK6BKfnAz5evYFE2WMUwRvmkT9CBChq8OHROhE6Mys1LMzp8Db+f0V0afVnIXw05+nFZmLJiEE1I4AEbo6PEiEToTOzEpd1fML6PRJNUX02XzsBHRctEyRuWgSQkDtCBChq8ODROhE6Mys1B6f1oJFXTspok9yaioU6TMIuGtsam9ebm6wf/RwWLr3AKz99Te1m0P6M4gAETqDTklHJSJ0InRmVmqRPLnhyryZiukzZdtPMG7rNsXmk2uiCW1awvBmTdLEX7n/IM2m7078ATabTa4pSa7OECBCV4fDidCJ0JlaqaenTYR3CxVURCcuOC4Ad+kJz54pMp8ck/jnzIlfgmaAm4vLK+LP3LoNY7Z8B7v+PivHtCRTZwgQoavD4UToROhMrdSXd5tKKDb1h59hbPj3Skwlyxxrv+oJgdWqZCj7xNXrMCx0M1WYkwV9/QgdUb/Okz4N6+Vg3eLk5OTlAQEBX7Kup1z66ZrQb9++vdDd3Z35PKBLftkbN/mXvTnlWgQsya1YvBgcnTBaUZWK9h0Md2NjFZ1TiskqlygOv40fxUvUzr/OpB3F/x1xi1d/6kQIvIzAqEb1nvaqVyc766ggoS9EQu/Hup5y6adrQr958+Z0Ly8vZbKZ2OHB1fsPPRnz807mvx3bYeIrQ28tmgv+uZT7/hJ29Bh0XrJCKvUVkePt7g6np02AInnyCJrvxz/+hNF4InHp7j1B46izvhGY3Kzx0+BaNdRA6NOQ0Efo1Vu6JvQ7d+6McXNzG8+689cfOvx0+A/bmX8zSYXjnE5B0Kd+XanE8ZLTYs4C2P7nX7z6stBpNV7x62jHFb/1h4+m7djvPHrEgjmkA+MIzGz1eXzQxx9lY1xNSEpKGlWkSJHJrOspl366JnQ8ch+ER+6z5QJXKrmbjh6LHxy+jfk3k1T2Fs/rBxfnTJdKHC853PW1MoNHQEx8PK/+juzUvGJ52DzA/idFXKa81Qd+hUnf/wgPnz51pEk0N+MIzGvTIqH1R1W8GVcTUlJS+hcqVGgB63rKpZ+uCR136D1wh75cLnClkvv9iT/i+4aF64bQOdy4e9XV3y4lFYS85Px26TJ8OnEar76O6vRe4UJwcMwI4FLlStWemUywBIvVTMMAwbikJKnEkhwNIbCsY7vEz8p/6MW6Sc+ePetauHDhNazrKZd+uib0u3fvtnNxcQmTC1yp5O46/XfCF+tCmf92LJW9nJy2VSvD+j7KB6uGYwa59oxmkCuBJxe/jhsJebLL8/TlKV7jm7dzd9pLzVf5pFyHJOs5Auu6dU7+9L0y0n2LlAlY3KG3wh36dzKJZ16s3gn9MyT0n1j30rHLV5+1WrrSnXU9pdbv3rKFkDub8t9jFv6yFwavD5XaHLvkFc7tC0fGj4Z8OeWPjeQeP0z7cTvM3fGLXTrTYO0g8GO/L1MrFCvmyrpFuEOvjzv0PazrKZd+uib0e/fufWI0Gn+VC1yp5F6MvJtaZ9Z85t9MUtn7Qo7Sd9Jf1p+75tUBd+os7FRLF8gPPw8dBBypK9mK9B0E92IfKzklzcUoAoeGDTKX9M9nZFS9/6tltVqr5MuX7wTresqln64JHZ+hl8Rn6FfkAlcquXdiYy1VJkxzlkqeWuT4eHvBjYVzwNPVMd9luDSqbbFu+vk7kQ6DrGG5srChby/IhtfUlGxT8Hn6OBUn3OGwqgqJsMVwWxHYQmy5AM9PFJnLEZOcHj/SljdHDub5wtnZubCvr+8dR2DEwpzMO0hOkDDXtVt0dDTzeT+fJCXZ3vlmnC59NbpFMxjd8nM5l0GmsrmAsf4hG2DNocOK68DlZ+dOKZRuMfEJULL/EEhMSVF6aknnq4aEHu6kEKFbc8E3Gib0K9MnAlcEiOXG1S7ImzevLj8nX/hF18ZzIERFRdkMBvZhKDCA+fw3srzXuQ+RGwtnQy4vxwbY7j5zDvqv3QA3oh7KYufLQisUKwpLunWGckUCZJ8rvQl6rQqB1QeZfxKVJTZE6FlCxLvDXawXwHrD43YbHrc7sa6nnPqxz2RyWo+y79+/b8ZjGuaPsz8cMwmidHpXeGjTxjCpbSuZVwI/8VwE+LJ9B2Qh9vw+uWB40ybwZd3a/JSRodefNyKg6mjmcy3xspwInRdMWXYqgrEbR0cNy7KfoztYLBazv7//q1WKHK2UwvPrntAxMC4RA+M8FcZd8HRN5y2GP3Wah9sdK4ldnjtD0XSwWTno2JVrEH78JOz/5zxctCONKnfy0KpKRbymVwU+Ka3svfv0bKwyajycvhmRlfmq+DsRujRuql6qJGzq1V0aYTJKMZlM8QUKFJDnTqeMekspWveEjnfRo/Dqmp+UoMohq/e6UPjh9N9yiFaFTC447MevBzKpa9STp3D8ylU4j8TOkXvEw2h4lJAAj/BZNHcFjAvuy+HpmfbiruFx5WE/wOP0soULQ5lCBZixacX+g9Dn23XM6GOvIkTo9iL4fHxQlUowsx0bJ2SZWZSamnq3IDZprFanFN0TemRk5CVXV1fHb42yWD9Tt++CRfsOqnOVSaT16i8xf3n1ahJJIzEvI3ArJgbKDR2l+kC4l20iQpdmjQ9tVB/61/tUGmEySkFCP4d8XlbGKZgXTYQeGXkACb0W657aiBnMhm7WbQKkNPdw6U4vzJ4Gfjl0faom+VI1mc1QGY/a/3Hg9TzJjUKBROjSoLoEiyU1+7CcNMJklIJZ4nZhlrhGMk7BvGjdEzoWaFmNBVq6su6pU/hcs9n8JayrKbt+LB+9y268TBN8tXotrDpwSCbpjhNLhC4N9vuHDYK3/dm/Y49Z4hZhlri+0litTilE6LdvD0FCn8m6+5JSUqHksFGsq6mIftOD2sLAxg0UmUvrk7Ccu95e7InQ7UUQwOjkBDdnTQEn/Ml6wyP3L/HInfliW3LiqHtCx6C4uhgUp4rcv5XGT4G7j+PkXA+qkM3lDfh+cD9o/AH7x4AsA/o33pr4eOwkSMUjdy02InT7vVoad+b7cIeuhoY79Eq4Q/9DDbrKpaPuCR2zC3lgtjhV1IzsuPxbOHDxklxrQVVyuatsRyeMBq6cKDXhCERjToPyI8bAg7gnwgerZAQRuv2OalHhA1jYIdB+QTJL4LLE+fn5GfHLvkXmqZgWr3tC57zz4MEDCx4pMX+mRJHur76X8mJw3B9TJihSgYzpd7FA5ZIwpWv1cZPh3G1tp7wmQhe4MNLpPgqTOvWqXcN+QTJLoKQyzwEmQkcQMLlMAiaXcWxuUR4Lfve589AVA5io/YdAKTwSPDBmhGw1wrWGNXe83mjaLDh88bLWTHvDHiJ0+128rV8vqISpiFlvmFQmDpPK5GJdT7n1I0JHhPE5+g18js78qn2UkAhl8XoRtVcRKJXfH/aPHg5+2ek6W1Zro9XchfDTqdNZddPE34nQ7XfjtRmTwMNB1Q6FaI9X1i7glbUyQsZosS8ROnoVy6huxzKqjdXg4KoTp8HtR7FqUFVRHWmnnjncKVg1rvns+bAPT3n00ojQ7fP0+xifsnOQOm6BYUDcJgyIY/9hv30uyXI0ETpCdOvWreEeHh5Ts0SLgQ56TwGbmQu4nfrekcPomfprIMU/ewZNZ8yFo5evMLCClVOBCN0+rLt+Ug0mYvliNTTcoXfHHfoqNegqp45E6Ijuo0eP3sGgClVsXdYeOQbfbN0m55pQtWwuUG7zgD7w0VslVW2HVMrfi30MTWfOhbMaD4BLDy8idPtW0bLO7eGzD963T4hCozEGKqePj492r2zwxJEI/V+gsC66Ba88MB/pfh0Lf3wyhfk8ODyXnzzdjFgNl0s+07dBXXkmUInUg+cvQuCCxRCLsRd6bETo9nn94tTxaemWWW9YB92EddBdWddTCf2I0P9FGSPdY/Bbnq8SoNs7R8VxU+BeHCWYyQrHth9VgZU9ugJ3Z11vbeoPP8PY8O/1ZvYr9hKhi3e/mp6fY4R7JEa4U0IKdDcR+r9rHgPjTmBgXCXxbwHlRg7ZFA5hx3WdEIk32AG5fWFFj25Qq0xp3mPU3PHagyjovGQF/HH9hprNkER3InTxMParWxuGqSS9MgbE7cOAOH0fx/3raiL0/wh9PhJ6P/FvAeVG/vDnX9B7fZhyE2pgJm63PqN9W/DPmVMD1qRvwvxdu2E0VuR7hhHt1Kjamj1rYGufL6FqiWL2iFBsLBL6GCT0iYpNyPBEROj/OufmzZs1vby8VFFw/HFiErw7chzDy4pN1TzxPu2YVs1hkEp2HnxR3PX3WRi8PhS43Tm1/xCgHbq41ZDdwx0uTp0gbrADRmHa1+J58+alIynEngj9pQWIKWCtmAFWFZgELl0Jhy9fdcDbR/1TcpHw/RrWhy/xWDGbu7tqDdpz9h+Y/uN2+O2S9rO+iXESEboY1ADaVKoAc4PaiBus8ChK+foq4KogL6XWSGRk5ENXV9c8Ss1nzzwbj52AoXi8Sk08At5I5t1q1YDBTRqq6u76tpOnYBoS+V9YLY1axggQoYtbHet7doXapd8WN1jhUVgyNQJLpjKf5VMpWIjQX0IaE8zswAQzjZQC3555uGN3Lg2sFasMUbMPARe85tak/AfQteYnULfsu+CE5VlZa8mpqbDu8BGYs+MXuIlXF6lljQARetYYvd7Dy80Nj9vHgzP7tarSVE9OTl4fEBDQSbil2hzB3ieXA3G+fft2V3d399UOVEHQ1O2WrITfrtCxuyDQsuhc0NcHgmtUT9u5F/BxbK0HLrjtwD8XgDta34InMjHx8VKaqnlZZSEZJhkeKGLnDls2WA65FZlLzknaVa4IswNbyzmFpLIxIK4+BsTtkVSoioURob/kPAyuMGJt9FT8T6rAZcvJP2Fg6GYVLz+2VX+nYIG0jHNVShZP+1kiX17ZFb4R9RB+OXMOdp85C1ywGzVCQEkEtvTuAdVKllByStFz4ee1BYPhjKIFaHCgKohLSdwxwUw0JphRxVdt7hi23OiJkID1ranJj4CvtzdUKF4UivrlgaJ58IU/A/LkhuJ5/QRn1LqLKVmvI3lzBH7j4cO03/+8GZH2b2qEgCMQKOzrC8dGD3PE1KLmpOfnb8JGhP4aJphg5ge8j66OigSo+9ebtkLo8ZOi3hA0SFoEcnp6gqe7G3DX47hnkZ5uruBqfHUDEfXkKVy6e0/aiUkaISABAl83rAcD6teRQJIyIrAgy0osyNJDmdnUMQsR+mt+wtron2Ft9J/U4T6AP25EwOcLlqhFXdKTECAEGEXg9PhRwF3pVEszm82l8+fPf0kt+iqhJxF6OijjfXQz3kd3VsIBUsxRHYu13KDIZymgJBmEgC4RqPn2W7Dxyy9UYzuS+TMkc/YrxyiMKBF6OoDjffSreB9dHZEhqP+6o8dgRDiVVFX4vUPTEQKaQYAjc47U1dIwuv0URrdXVIu+SulJhJ4O0nh9bRFeX+utlBPsnSfFbIYPx0yEuKRke0XReEKAENAZAkUxsPPIyKGqshrvn4/A++fTVKW0AsoSoacD8vXr19/Kli2bqvJpzty1B+bt3qfAkqEpCAFCQEsIzMOiRa0rlleTSTa8iZTLx8fniZqUVkJXIvQMUMbra09w0agmQiQak45wV9ioEQKEACHAFwEuCI4LhlNTw/rnd7H+eUE16ayUrkToGSCNaWC3YBpY9aRMQjuGb/ke1v9+XKm1Q/MQAoSAyhEY3bQxfFm7hqqswOfn8/D5+UBVKa2QskToGe/Q38Yd+kWF/CDJNNwd58oTpoLJYpFEHgkhBAgB7SKQJ5s3HB8zAtxdXNRkpA2vFfvkypUrTk1KK6UrEXomSOOd9Me4eHIq5Qwp5hkejrv0o7RLlwJLkkEIaBmB8c2bwhc1PlaViXjcfhuP2wNUpbSCyhKhZwI2Zo3biFnjghT0h91T0S7dbghJACGgeQS43fnJsd+8kcmQdcMxun0qRrd/w7qejtKPCD3zHXop3KGrLhPRN1u3wdojxxy1pmheQoAQYByBSS0/hy7VP2Jcy1fVw2IsNj8/Py+DwUD3czPwHBF6Fksaj91jkNR91bTyY+IToMrEqZCcalKT2qQrIUAIKIBAgVw5sQjLcNXUPH8BCRZjuV6wYEHVJPxSwJVvTEGEngXqeOy+HI/dVVcAgLuTzt1Np0YIEAKEwMsIrOzaCRqVfVd1oOBx+3A8bp+uOsUVVJgIPWtC98E0sDF4zKMqrJ6ZTFBp/BR4lJCo4HKiqQgBQoBlBD4MKAw/D+zDsorp6ma1Wi358uWj2udZeE5VJOWoVYi79Cu4Sy/pqPnFzht2/A8Ysilc7HAaRwgQAhpDYPeQ/vBuwQKqswrvnh/Fu+fqCsl3AMpE6DxAxyQznTDJzFoeXZnr0nD2Ajh7J5I5vUghQoAQUBaBlhU+hAUd2ik7qUSzxcfHVypevPgfEonTrBgidJ6uxVSwSZhoRnXl+i7dfwB1Z8wFq83G01LqRggQAlpDIKenJxZg+RpyeXmpzrSUlJQHhQoV8led4g5QmAidJ+hYgW0VVmDrxrM7U90m/bQDlh74lSmdSBlCgBBQDoGFHQKhRYUPlJtQwpkoGI4/mEToPLF6/PhxTrw2Eau24DjOPC5Arta0OXD70SOe1lI3QoAQ0AoCtUqXgg09VbkXAYvFYvL393fVii/ktoMIXQDCkZGRRzHiXV3ZGP617+jVa9Bm8QoB1mbelQ7wJYMyU0H0BlUGZ63O4u3mBgeHD4b8ePdcjQ2P28PwuF1V2TodiTN9XghAH4PjymBw3DkcokrcpDp658hclQAI8DV1JQS0gMAqvHPeUIV3zjnsucxwGLeU09fX96kWfKGEDfS5LBBlzBx3EzPHFRE4jInuZqzC1mjOQjh/955d+hCh2wUfDSYEFEEgqEolmNmulSJzyTEJ7s6P4e5clSeicuDBRyYROh+UXuqDu/Q2uEvfLHAYM91vP4qFOhj1npiSIlonInTR0NFAQkARBIrm9oV9wwaprTTqy9jYnjx58m7JkiUvKAKYRiYhQhfhSLzCFodHQTlEDGViyE9/nYFeazeK1oUIXTR0NJAQkB0Brr75zkF9oZR/PtnnkmsCLJN6E8ukFpNLvlblEqGL8CxeYZuIV9hGiRjKzJChm7+DjcdOiNKHCF0UbDSIEFAEgRltW0L7qpUVmUuuSfC4vQUet2+TS75W5RKhi/AsxmoYHjx4kODs7OwpYjgTQ7irbFwWuSsPogTrQ4QuGDIaQAgogkCTcmVheXAHReaSaxK8Hnwfq6rll0u+luUSoYv0Lj5LH4vP0seJHM7EsBvRMVBn+hxIMZsF6UOELggu6kwIKIJAQZ9ccAivqHm4qvvaNh63N8Xj9p8VAU1jkxCh2+FQfJYej8/Sve0Q4fChW06egoGhWwTpQYQuCC7qTAjIjgD33JyrovZOfnVnSEUyj0AyLyo7YBqdgAjdDsfis/Qh+Cx9ph0imBg6+eedsGT/Id66EKHzhoo6EgKyI8BVdv62Wyeo924Z2eeSeQIbVlWriVXVDss8j2bFE6Hb6dr79+/H4bN01Ua8vzC/55r1sP0MlzMn60aEnjVG1IMQUAqBWXjXPBDvnKu9YSDcVQyEe0vtdjhSfyJ0O9HHXfpXuEtfbKcYhw/nks4ELVsFR69ez1IXIvQsIaIOhIAiCPSr3IbMkwAAFlBJREFUWxuGNW6gyFwyT8Ltzivh7vyUzPNoWjwRugTuxWfp0fgsPbcEohwqIjElFVotWpZl/XQidIe6iSYnBNIQaFOpAswNaqMJNHB3fhZ35+9rwhgHGkGELgH4d+7caeHm5vadBKIcLuJpcjK0WLAULmId9YwaEbrD3UQK6ByBT995G9Z8EQzOTk6qR4LL2Y5X1d5CQr+memMcbAARukQOQFK/iqReQiJxDhXzODEJPl+wBK5FPUxXDyJ0h7qHJtc5AuWLBMDWPj3B1WjUBBJ41L4Pj9rrasIYBxtBhC6RA/DY/W0Mjrugxnrp6UHwKCEBms1bDDdj3qyhToQu0aIhMYSAQATeypcXfh7QG7zd3QWOZLO71Wo1Ozk55fLz80tgU0N1aUWELqG/sF76T1gv/TMJRTpU1MOn8dBu6Uq4/NrxOxG6Q91Ck+sUgbfxjnnYl1+AX/ZsmkEAd+eTcHc+WjMGOdgQInQJHYCPgjyjoqLi8Buni4RiHSrqCT5Tb7t4BZyLvPt/PYjQHeoSmlyHCJQrXAhCe30BOTw8NGO9xWKJ9ff399WMQQwYQoQusRMwx/s3SOiTJRbrUHFJqanQeeUa+P3fK21E6A51B02uMwSqv1USQroHq7kUaroeww1Q3bx58+7TmTtlNZcIXQZ48Xl6BF5jC5BBtENFdlm9FvacOw9E6A51A02uIwQalH0XVnftpDmLMar9ABZg+VRzhjnYICJ0GRzw8OHDkij2Er7Uf6fkJXwwgAUGhoVD+B9/Ai0cGRYOiSQEXkKgbeUKMKttK8ATP03hgp8jKbgzz4EBxCmaMowBY+hzWSYnYIDcEgyQ6yWTeIeKbblwGRy/fsOhOtDkhICWEfi6UX0YUE+bG1hMItMB75xv1LL/HGUbEbqMyOPReyweveeScQqHiF6w9wBM3/GLQ+amSQkBLSPAFVpZ0L4ttKjwoSbNxKP2M3jUXk6TxjFgFBG6jE6IiIio6unp+buMUzhENBG6Q2CnSTWOQE5PT1jcKQhqvq3N+iQY1W728vLyz549e4zGXekw84jQZYb+7t27K1xcXLrLPI2i4onQFYWbJtMBApWLF4WlndpD3hzZNWttUlJStyJFinyrWQMZMIwIXQEn4NH7fTx6z6fAVIpMQYSuCMw0iQ4Q4I7YuYppgxvU1URe9oxchkftR/CovboOXOpQE4nQFYAf87yXxAC5S/jm1US4KhG6AouGptA8AnmyecPCjoHA3TPXcsOj9kRMIOOtZRtZsY0IXSFPYN30wVg3fZZC08k6DRG6rPCScB0gwFVLmxfUFny8vTRtLVdJDaPaa2B61980bSgjxhGhK+gIfJ7+Nz5PV33NXyJ0BRcNTaUpBNxcjDC6aRPoUv0jTdmVkTFI5uvxipr2MuMw6j0idAUdExsbmwOLETzE5+muCk4r+VRE6JJDSgJ1gACXj31OYGso5a+ZcJpMvWYymaILFCjgpwPXMmMiEbrCrsCEM03wefpPOK1qsSdCV3jR0HSqRsDD1RWGNqoH3T75WNOBby87CbPBWfC0vQQ+O49QtfNUprxqSUVlOL+iLj5PX4PP04PVagMRulo9R3orjcBHJYrD3KA2UNBHc/mlMoQSiRwSExN7FCtWbKXSeOt9PiJ0B60A3Klfxp26KjNIEKE7aNHQtKpBgCPwsc2aQKP331ONzlIpmpycvDkgIKCdVPJIDn8EiND5YyVpT/wW637//v1ofJ6uuuscROiSLgUSpiEEvN3coD/mYOeO17kAOL01DIK7jkFwJfRmNyv2EqE70BN4P/09jHr/G6spqep+OhG6AxcNTc0sAhyJD6j/Kfh4afsqWkYO4O6b58uXLyfm2zAz6ySNK0aE7mAH41W2bkjqqxyshqDpidAFwUWdNY5Al+rV0rK9+WXPpnFLMzYPg+CsZrP5Q8wGd0a3IDBgOBE6A07Anfp8Nze3fgyowksFIvT/tXfuMVaUZxyeZS/sArtclu4KyGWFXVoXvMBiMKIWRO1VTSyS0BRJi2jS1v+aGBqbtkkbk6Z/NZUW2lJKA429/GMbsWmCmBpTm4aghFpBYJXbsrDclsW9AP0NIHJZdufMmcs37zwnOTknMvPN9z7ve/bxm/nmm0CY2Mgwgcrycs9/XvmzCxd4N40aaTjSwUOTyz1dN1/S0NCwcfCt2SJOAgg9TroFtK2Z71s08/2+AnZJbVOEnhp6DpwyAf/hKf6p9SVz7/JGDx+Wcm/SP7w/o11ra/xAk+C+n35v6AFCd6gGNPO9VTPfJznUpX67gtBdzxD9i5qA/zS05RJ5HmetD8RSt6e9opH5F6LmTXvhCCD0cNxi2au9vb1aqysdcH3mO0KPJf006hiB8aNHeYvvavG+Mme2N2VsrWO9S787Gpnv1Brtmbz1Nn168fQAocfDNXSrra2tt2iS3A5JfWjoRmLeEaHHDJjmUyMwTKu6ffGOmd4TErm/KAyv/glo4NGm224ntrS09MLIHQII3Z1cXO6JfijNuvVjq+5mK3ewex5CdzEr9CksgSF6Jvn9n27yHm+Z5T08s9nzpc7rxgT0bPMT+ts0Xq8uOLlFAKG7lY/LvdmzZ8/cqqqqf+qHU+paFxG6axmhP4US8G8xm6fnkM/VtfEHm2/N9S1nhbDTyLxTE+Gm6Pa0o4Xsx7bJEEDoyXAOdRSdfn9Qt7Ntcm3hGYQeKp3slCKBppvqvdsm3uzNmjxJIp/mTa37VIq9yeahJfMuLR7TqOvmB7IZgf1eI3THc6yR+mMaqf9FUncmV1kWeqkW5Zs9ZZJ34PgJb1/HMcezT/fCEGi8JO/m8eO8OyXw5gnjvOFakpVXeAKSuVZ17Z6uB660hm+FPeMm4Iwk4g40y+3v2rVraXV19W91Xd2JfGVV6EPLyrzfrfj6hRGa/zraedp7Z99+7+0P93kHJfjDp055h0+e9NpOnPL2H0P2rv5m/MeR+qfM62tqPP++8Hp9n6AZ6XdMQt5x5EwrwPXquvntU6ZM+W8c7dNmdAScEER04dhtaffu3U9ppL66tDT9S+pZFPq1Mg9SKb7wfcFfEL0kf+jkCa/zo27vdHeP3hc/u3q6ve4+d5auHjNsmFdfHex5P22nOr2OLnfmNfk58kfS/tt/yMnwoRXeKD8eCbvugrhrLoi8urIySPrYJgICknlfV1fX3GnTpv0nguZoImYCCD1mwFE2r9PvT0rqa9M+/Z41oYeReZR5S7ItLfThdXZ2BjrkiBEjvOE5fZBIIEA530gu18C8Z65G5ltzjiIz4SP0zKTqYkcl9UcvXVNP7QltWRJ6nmTu1wdCz9gP2tHu+hPg9LqtsbHxfUe7SLf6IYDQM1gWWiL2AS0+86ouqady/j0rQs+bzBF6Bn/MDnZZM9lP6Na0abrP/IiD3aNLAxBA6BktDy0+M0dCfyONxWeyIPQ8yhyhZ/TH7FC3NTI/oodETa2trT3pULfoSkACCD0gKBc30xPapmqkvlUT5RJ9ELPrQs+rzBG6i7/S7PRJ18zfGzdu3AwNFFjONTtpu6qnCD2jifu424cOHRqu5xH/T2u/T0gqFJeFnmeZI/SkfgH2jqN7zP86ceLEL9uLLF8RIXQD+db1riE6Bf+WpD47iXBcFXreZY7Qk6h+c8c4r6emvaDV31aaiyyHASF0Q0nfv3//ap2CfyrukFwUOjK/mHVmucdd/Xba10DgrG5LW6qR+QY7UeU7EoRuLP8HDhxYoZH6KoUV221trgkdmX9SxAjd2A86pnB0vfy0LtXdo4esbIvpEDSbAgGEngL0uA+pyXIzNFJ/U5Plgi0ZVmCHXBI6Mr86eQi9wGLO4eaayf6ubklr0eS30zkM33TICN1oenU6rUqj9X9L7M1Rh+iK0JH59ZlF6FFXu5329DfB0yn2NTrFvsJOVERyJQGEbrweNFpfpUewPhPlc11cEDoy779wEbrxH3TI8HR63V+T/at6WtpLIZtgtwwQQOgZSFKxXdTKcot0XX2DFqEpK7Ytf/+0hY7Mb5xFhB5FhdtqQ6PyYzrNPquhoWGvrciI5loCCD0nNbFz586btQLU6xqtNxQbcppCR+YDZw+hF1vddvbXqNw7c+bMJon883aiIpKBCCD0nNVHa2vrCxL7d3QKPvQs+LSEjswHL1aEPjijPGyhEbnWiulepFPsL+chXmK8SACh57ASJPVbNVlui07Djw0TfhpCR+bBMoXQg3GyutWliW9v6kzcQ3V1dcGeo2sVRg7jQug5TPrHIWvC3DqN1pcWiiBpoSPz4BlC6MFZWdtST0nr08j8aa369htrsRFPMAIIPRgns1vt3bv3bv3f/Cbds14TNMgkhY7Mg2bl4nYIvTBeVrbWxLdt1dXVC0aOHNlhJSbiKJwAQi+cmbk9/LXgNRP+pYqKiseD3N6WlNDLS0u93z/9DW9e0zRzzOMKCKHHRdbNdv3b0TTx7Vua+PZLN3tIr5IkgNCTpO34sXRtfZ6urb+sa+ujBupqEkL3Zb52+TJv/memO07Nre4hdLfyEWdvNCr3H538sB552h7ncWg7OwQQenZylVhP9ZCXNRL78hsdMG6hI/PwqUbo4dllZU9dK+/S+xmtw74+K32mn8kQQOjJcM7cUTo6OibpsYp/1mi95drOxyl0ZF5cqSD04vi5vLcujZ3TpLc1EyZM+LYujfW63Ff6lg4BhJ4O98wcta2tbaGu023Uqb3Lt7jFJXRkXnxZIPTiGbrYgkT+r5qamkc08e2wi/2jT24QQOhu5MHpXmhkUHLw4MHvaunY7+ldHofQkXk0JYDQo+HoSis6td6mR50u1gNVtrjSJ/rhLgGE7m5unOuZ/wQ3XV9f9eLm17/2k1f+HnqluWsDQ+bRpRqhR8cyzZY0Ij8mmT+ve8p/nmY/OHa2CCD0bOXLid4OW7r8+d6+vh9G0RlkHgXFT9pA6NHyTLo1/0EqEvlzkydPXp30sTle9gkg9OznMPEIypYsW6nC+VGxB0bmxRK8fn+EHj3TJFrUuuvHdGp9pe4n/0USx+MYNgkgdJt5jTWqKISOzONJEUKPh2scrfrrrkvkR7UwzMrp06czIo8Dcs7aROg5S3gU4RYrdGQeRRb6bwOhx8c2qpZ9keuW0KN6P9fU1PRr3YJ2Pqq2aSffBBB6vvMfKvpihI7MQyEPvBNCD4wq8Q11+2e3rpFv0aj8x42NjcxaTzwD9g+I0O3nOPIIwwodmUeeiusaROjxMw5xhDc0Cn9x7Nixf9JnT4j92QUCgQgg9ECY2OhKAuGEfr7nmwsf+OnKL33uXrU1D6LxEEDo8XAttFWdVj+tfTZoCeWfjRkz5p1C92d7CIQhgNDDUMv5PoUKXX/cerySIY/0bVj7qo9Oy8rO1IzeZ/V1sd7VOccZafgIPVKcBTemWn9bo/BfaWXFdbW1tScLboAdIFAEAYReBLy87lqI0K+V+ZXM9G/lR44ceUifi/TfH9V7wKe85ZV3IXEj9EJoRbOt6ne7VlD8oz431tXV7YymVVqBQOEEEHrhzHK/R1ChDyTzayEi92jKCqFHw3GwVpD4YIT49zQIIPQ0qGf8mEGEXojM+5F7mU7Lz9GKWfPVznz9+z06jVmVcWyJdB+hx4NZdfiBanCzWt+sJxBu1nXxD+I5Eq1CIDwBhB6eXW73HEzoxcj8RlAPHz58r/6gLlDb92sbX/K8+iGA0KMpC9VZm1r6h06lv6bvr+lU+q5oWqYVCMRHAKHHx9ZsywMJPQ6Z9zOCr2hvb58rwX9Wx/Pfd+t7pVngBQSG0AuAdfWmH/riVh1t8T/r6+vfD90SO0IgJQIIPSXwWT7sjYSehMwHGMHfp3/zb4e7U++Zek/PMuOwfUfogcid0Fbb/evgEvhb+tyCwANxYyPHCSB0xxPkYvdKlzy5dIhXsu7KvqUp8xsx0ih+tlbnavYFrz/cM9THJn3e4iLTqPqE0K8i6d829p7y/q7yvl3ft+n69w6uf0dVbbTjGgGE7lpGstCfRYtGlJUN31VS4tX73dVC1F3nz51/4uwf1v0tC91va2ubqn76Ym/U2/8+VX/wx+tztP74j9H3MVmIo78+5kXoytMZ5alDn8f0eUQsWvXpnyZXXZbsqqio2F1TU3M0q3mk3xAIQwChh6HGPp732LJRZVUlt5ecO9/VW3F2h7d+vb8ylpmXRDH0+PHjVVoAp0qjuqG9vb3l+l5WWVlZ5n9qslSZxFGmmfjleg9xJXA98GOU+lcbpD+K66jiOR5k2yS20WIsZ8W9T2dV+vS998pP9VXLoPd8pP9+RhPUOpPoD8eAQNYIIPSsZYz+QgACEIAABPohgNApCwhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQggNCpAQhAAAIQgIABAgjdQBIJAQIQgAAEIIDQqQEIQAACEICAAQII3UASCQECEIAABCCA0KkBCEAAAhCAgAECCN1AEgkBAhCAAAQg8H8lifw+4r6BBgAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
)

export const SelectedFavouriteIcon: React.FC<IconProps> = ({
  color,
  size = 32,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size || '21'}
    height={size || '19'}
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="selected-favourite-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M5.979 1.07352C6.86406 0.922722 7.77169 0.972468 8.63496 1.21909C9.49824 1.46572 10.2952 1.90294 10.967 2.49852L11.004 2.53152L11.038 2.50152C11.6792 1.93882 12.433 1.51932 13.2492 1.27101C14.0653 1.02269 14.9251 0.951278 15.771 1.06152L16.017 1.09752C17.0833 1.28163 18.08 1.75068 18.9015 2.45499C19.723 3.15931 20.3387 4.07267 20.6834 5.09836C21.0282 6.12405 21.0892 7.22388 20.8599 8.28139C20.6306 9.3389 20.1196 10.3147 19.381 11.1055L19.201 11.2905L19.153 11.3315L11.703 18.7105C11.5311 18.8807 11.3033 18.9828 11.0619 18.9978C10.8205 19.0129 10.5818 18.94 10.39 18.7925L10.296 18.7105L2.803 11.2885C2.00922 10.5162 1.4447 9.5392 1.17196 8.46579C0.899219 7.39238 0.928902 6.26442 1.25772 5.20684C1.58654 4.14926 2.20166 3.20332 3.03496 2.4738C3.86826 1.74427 4.88723 1.25962 5.979 1.07352Z"
      fill={color || 'currentColor'}
    />
  </svg>
)

export const ClearSearch: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="clear-search"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TemplateIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = 24,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="template-icon"
    id={id}
    className={`${className || ''}`}
    {...rest}>
    <path
      d="M14 12H20M14 16H20M14 20H20M4 5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V7C20 7.26522 19.8946 7.51957 19.7071 7.70711C19.5196 7.89464 19.2652 8 19 8H5C4.73478 8 4.48043 7.89464 4.29289 7.70711C4.10536 7.51957 4 7.26522 4 7V5ZM4 13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12H9C9.26522 12 9.51957 12.1054 9.70711 12.2929C9.89464 12.4804 10 12.7348 10 13V19C10 19.2652 9.89464 19.5196 9.70711 19.7071C9.51957 19.8946 9.26522 20 9 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V13Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DoneIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = 24,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="done-icon"
    id={id}
    className={`${className || ''}`}
    {...rest}>
    <path
      d="M5.00046 7.20046C5.00046 6.61698 5.23225 6.05741 5.64483 5.64483C6.05741 5.23225 6.61698 5.00046 7.20046 5.00046H8.20046C8.78136 5.00013 9.33855 4.77006 9.75046 4.36046L10.4505 3.66046C10.6549 3.45486 10.898 3.2917 11.1657 3.18037C11.4334 3.06903 11.7205 3.01172 12.0105 3.01172C12.3004 3.01172 12.5875 3.06903 12.8552 3.18037C13.1229 3.2917 13.366 3.45486 13.5705 3.66046L14.2705 4.36046C14.6825 4.77046 15.2405 5.00046 15.8205 5.00046H16.8205C17.4039 5.00046 17.9635 5.23225 18.3761 5.64483C18.7887 6.05741 19.0205 6.61698 19.0205 7.20046V8.20046C19.0205 8.78046 19.2505 9.33846 19.6605 9.75046L20.3605 10.4505C20.5661 10.6549 20.7292 10.898 20.8406 11.1657C20.9519 11.4334 21.0092 11.7205 21.0092 12.0105C21.0092 12.3004 20.9519 12.5875 20.8406 12.8552C20.7292 13.1229 20.5661 13.366 20.3605 13.5705L19.6605 14.2705C19.2509 14.6824 19.0208 15.2396 19.0205 15.8205V16.8205C19.0205 17.4039 18.7887 17.9635 18.3761 18.3761C17.9635 18.7887 17.4039 19.0205 16.8205 19.0205H15.8205C15.2396 19.0208 14.6824 19.2509 14.2705 19.6605L13.5705 20.3605C13.366 20.5661 13.1229 20.7292 12.8552 20.8406C12.5875 20.9519 12.3004 21.0092 12.0105 21.0092C11.7205 21.0092 11.4334 20.9519 11.1657 20.8406C10.898 20.7292 10.6549 20.5661 10.4505 20.3605L9.75046 19.6605C9.33855 19.2509 8.78136 19.0208 8.20046 19.0205H7.20046C6.61698 19.0205 6.05741 18.7887 5.64483 18.3761C5.23225 17.9635 5.00046 17.4039 5.00046 16.8205V15.8205C5.00013 15.2396 4.77006 14.6824 4.36046 14.2705L3.66046 13.5705C3.45486 13.366 3.2917 13.1229 3.18037 12.8552C3.06903 12.5875 3.01172 12.3004 3.01172 12.0105C3.01172 11.7205 3.06903 11.4334 3.18037 11.1657C3.2917 10.898 3.45486 10.6549 3.66046 10.4505L4.36046 9.75046C4.77006 9.33855 5.00013 8.78136 5.00046 8.20046V7.20046Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const WhatsNewIcon: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="whats-new-icon"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <g clipPath="url(#clip0_31574_3625)">
      <path
        d="M16.1667 18.9004C16.6972 18.9004 17.2059 19.1111 17.581 19.4862C17.956 19.8613 18.1667 20.37 18.1667 20.9004C18.1667 20.37 18.3775 19.8613 18.7525 19.4862C19.1276 19.1111 19.6363 18.9004 20.1667 18.9004C19.6363 18.9004 19.1276 18.6897 18.7525 18.3146C18.3775 17.9395 18.1667 17.4308 18.1667 16.9004C18.1667 17.4308 17.956 17.9395 17.581 18.3146C17.2059 18.6897 16.6972 18.9004 16.1667 18.9004ZM16.1667 6.90039C16.6972 6.90039 17.2059 7.1111 17.581 7.48618C17.956 7.86125 18.1667 8.36996 18.1667 8.90039C18.1667 8.36996 18.3775 7.86125 18.7525 7.48618C19.1276 7.1111 19.6363 6.90039 20.1667 6.90039C19.6363 6.90039 19.1276 6.68968 18.7525 6.3146C18.3775 5.93953 18.1667 5.43082 18.1667 4.90039C18.1667 5.43082 17.956 5.93953 17.581 6.3146C17.2059 6.68968 16.6972 6.90039 16.1667 6.90039ZM9.16675 18.9004C9.16675 17.3091 9.79889 15.783 10.9241 14.6578C12.0493 13.5325 13.5754 12.9004 15.1667 12.9004C13.5754 12.9004 12.0493 12.2682 10.9241 11.143C9.79889 10.0178 9.16675 8.49169 9.16675 6.90039C9.16675 8.49169 8.53461 10.0178 7.40939 11.143C6.28417 12.2682 4.75805 12.9004 3.16675 12.9004C4.75805 12.9004 6.28417 13.5325 7.40939 14.6578C8.53461 15.783 9.16675 17.3091 9.16675 18.9004Z"
        stroke={color || '#EB5C37'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_31574_3625">
        <rect width="24" height="24" fill="white" transform="translate(0.166748 0.900391)" />
      </clipPath>
    </defs>
  </svg>
)

export const SelectAssistantIcon: React.FC<IconProps> = ({
  color,
  size = 24,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="select-assistant-icon"
    id={id}
    className={className}
    {...rest}>
    <g clipPath="url(#clip0_29463_4504)">
      <path
        d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
        stroke={color || 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10C9 10.7956 9.31607 11.5587 9.87868 12.1213C10.4413 12.6839 11.2044 13 12 13C12.7956 13 13.5587 12.6839 14.1213 12.1213C14.6839 11.5587 15 10.7956 15 10C15 9.20435 14.6839 8.44129 14.1213 7.87868C13.5587 7.31607 12.7956 7 12 7C11.2044 7 10.4413 7.31607 9.87868 7.87868C9.31607 8.44129 9 9.20435 9 10Z"
        stroke={color || 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.16797 18.849C6.41548 18.0252 6.92194 17.3032 7.61222 16.79C8.30249 16.2768 9.13982 15.9997 9.99997 16H14C14.8612 15.9997 15.6996 16.2774 16.3904 16.7918C17.0811 17.3062 17.5874 18.0298 17.834 18.855"
        stroke={color || 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_29463_4504">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const UploadAssistantIcon: React.FC<IconProps> = ({
  color,
  size = 48,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="upload-assistant-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M30 16H30.02"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6H36C37.5913 6 39.1174 6.63214 40.2426 7.75736C41.3679 8.88258 42 10.4087 42 12V36C42 37.5913 41.3679 39.1174 40.2426 40.2426C39.1174 41.3679 37.5913 42 36 42H12C10.4087 42 8.88258 41.3679 7.75736 40.2426C6.63214 39.1174 6 37.5913 6 36V12Z"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 31.9997L16 21.9997C17.856 20.2137 20.144 20.2137 22 21.9997L32 31.9997"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 27.9997L30 25.9997C31.856 24.2137 34.144 24.2137 36 25.9997L42 31.9997"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UploadDocumentIcon: React.FC<IconProps> = ({
  color,
  size = 48,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="upload-document-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M28 6V14C28 14.5304 28.2107 15.0391 28.5858 15.4142C28.9609 15.7893 29.4696 16 30 16H38M28 6H14C12.9391 6 11.9217 6.42143 11.1716 7.17157C10.4214 7.92172 10 8.93913 10 10V38C10 39.0609 10.4214 40.0783 11.1716 40.8284C11.9217 41.5786 12.9391 42 14 42H34C35.0609 42 36.0783 41.5786 36.8284 40.8284C37.5786 40.0783 38 39.0609 38 38V16M28 6L38 16M24 22V34M18 28H30"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ConnectToDataboxIcon: React.FC<IconProps> = ({
  color,
  size = 48,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="connect-to-databox-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M40 15L24 6L8 15M40 15V33L24 42M40 15L24 24M24 42L8 33V15M24 42V24M8 15L24 24M32 10.5L16 19.5"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ConnectToCornerstoneIcon: React.FC<IconProps> = ({
  color,
  size = 48,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="connect-to-cornerstone-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M6 10C6 7.79086 7.79086 6 10 6H18C20.2091 6 22 7.79086 22 10V18C22 20.2091 20.2091 22 18 22H10C7.79086 22 6 20.2091 6 18V10Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="2"
    />
    <path
      d="M10 26C7.79086 26 6 27.7909 6 30V38C6 40.2091 7.79086 42 10 42H38C40.2091 42 42 40.2091 42 38V10C42 7.79086 40.2091 6 38 6H30C27.7909 6 26 7.79086 26 10V18C26 22.4183 22.4183 26 18 26H10Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="2"
    />
  </svg>
)

export const ManageAssistantIcon: React.FC<IconProps> = ({
  color,
  size = 38,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="manage-assistant-icon"
    id={id}
    className={className}
    {...rest}>
    <rect width="38" height="38" rx="4" fill="white" />
    <path
      d="M10 19C10 20.1819 10.2328 21.3522 10.6851 22.4442C11.1374 23.5361 11.8003 24.5282 12.636 25.364C13.4718 26.1997 14.4639 26.8626 15.5558 27.3149C16.6478 27.7672 17.8181 28 19 28C20.1819 28 21.3522 27.7672 22.4442 27.3149C23.5361 26.8626 24.5282 26.1997 25.364 25.364C26.1997 24.5282 26.8626 23.5361 27.3149 22.4442C27.7672 21.3522 28 20.1819 28 19C28 17.8181 27.7672 16.6478 27.3149 15.5558C26.8626 14.4639 26.1997 13.4718 25.364 12.636C24.5282 11.8003 23.5361 11.1374 22.4442 10.6851C21.3522 10.2328 20.1819 10 19 10C17.8181 10 16.6478 10.2328 15.5558 10.6851C14.4639 11.1374 13.4718 11.8003 12.636 12.636C11.8003 13.4718 11.1374 14.4639 10.6851 15.5558C10.2328 16.6478 10 17.8181 10 19Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 17C16 17.7956 16.3161 18.5587 16.8787 19.1213C17.4413 19.6839 18.2044 20 19 20C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17C22 16.2044 21.6839 15.4413 21.1213 14.8787C20.5587 14.3161 19.7956 14 19 14C18.2044 14 17.4413 14.3161 16.8787 14.8787C16.3161 15.4413 16 16.2044 16 17Z"
      stroke={color || '#2C3E50'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.168 25.849C13.4155 25.0252 13.9219 24.3032 14.6122 23.79C15.3025 23.2768 16.1398 22.9997 17 23H21C21.8612 22.9997 22.6996 23.2774 23.3904 23.7918C24.0811 24.3062 24.5874 25.0298 24.834 25.855"
      stroke={color || '#2C3E50'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Chat: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="chat-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M14 15V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H6L3 21V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H6M21 14L18 11H11C10.7348 11 10.4804 10.8946 10.2929 10.7071C10.1054 10.5196 10 10.2652 10 10V4C10 3.73478 10.1054 3.48043 10.2929 3.29289C10.4804 3.10536 10.7348 3 11 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V14Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DownloadDemoFile: React.FC<IconProps> = ({
  color,
  size = 24,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="download-demo-file"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M4.5 17V19C4.5 19.5304 4.71071 20.0391 5.08579 20.4142C5.46086 20.7893 5.96957 21 6.5 21H18.5C19.0304 21 19.5391 20.7893 19.9142 20.4142C20.2893 20.0391 20.5 19.5304 20.5 19V17M7.5 11L12.5 16M12.5 16L17.5 11M12.5 16V4"
      stroke={color || '#17B0AD'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AdvancedSearchIcon: React.FC<IconProps> = ({
  color,
  size = 24,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height="50"
    viewBox="0 0 24 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="advanced-search-icon"
    id={id}
    className={className}
    {...rest}>
    <g clipPath="url(#clip0_27581_69816)">
      <path
        d="M11.36 33.213L9 34V25.5L4.52 20.572C4.18545 20.2039 4.00005 19.7244 4 19.227V17H20V19.172C19.9999 19.7024 19.7891 20.211 19.414 20.586L15 25M20.2 33.2L22 35M15 31C15 31.7956 15.3161 32.5587 15.8787 33.1213C16.4413 33.6839 17.2044 34 18 34C18.7956 34 19.5587 33.6839 20.1213 33.1213C20.6839 32.5587 21 31.7956 21 31C21 30.2044 20.6839 29.4413 20.1213 28.8787C19.5587 28.3161 18.7956 28 18 28C17.2044 28 16.4413 28.3161 15.8787 28.8787C15.3161 29.4413 15 30.2044 15 31Z"
        stroke={color || '#17B0AD'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_27581_69816">
        <rect width="24" height="24" fill="white" transform="translate(0 13)" />
      </clipPath>
    </defs>
  </svg>
)

export const DeleteIcon: React.FC<IconProps> = ({ color, size = 16, id, className, ...rest }) => (
  <svg
    width={'16'}
    height={'18'}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="delete-icon"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M1.33301 4.83333H14.6663M6.33301 8.16667V13.1667M9.66634 8.16667V13.1667M2.16634 4.83333L2.99967 14.8333C2.99967 15.2754 3.17527 15.6993 3.48783 16.0118C3.80039 16.3244 4.22431 16.5 4.66634 16.5H11.333C11.775 16.5 12.199 16.3244 12.5115 16.0118C12.8241 15.6993 12.9997 15.2754 12.9997 14.8333L13.833 4.83333M5.49967 4.83333V2.33333C5.49967 2.11232 5.58747 1.90036 5.74375 1.74408C5.90003 1.5878 6.11199 1.5 6.33301 1.5H9.66634C9.88735 1.5 10.0993 1.5878 10.2556 1.74408C10.4119 1.90036 10.4997 2.11232 10.4997 2.33333V4.83333"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PluginConnect: React.FC<IconProps> = ({
  color = 'currentColor',
  size = 24,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="plugin-connect"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M9.78435 6L17.9993 14.215L15.9453 16.269C15.4099 16.8259 14.7687 17.2704 14.0594 17.5765C13.35 17.8827 12.5868 18.0442 11.8142 18.0518C11.0417 18.0594 10.2754 17.9128 9.56023 17.6207C8.84502 17.3285 8.19527 16.8967 7.64898 16.3504C7.10269 15.8041 6.67083 15.1543 6.37869 14.4391C6.08654 13.7239 5.93997 12.9576 5.94755 12.1851C5.95512 11.4126 6.1167 10.6493 6.42282 9.93997C6.72894 9.23063 7.17345 8.58947 7.73035 8.054L9.78435 6Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 20L7.5 16.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 4L11.5 7.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 9L16.5 12.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PluginDisconnect: React.FC<IconProps> = ({
  color = 'currentColor',
  size = 20,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    data-testid="plugin-disconnect"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M13.4363 13.409L13.2888 13.5565C12.8425 14.0205 12.3082 14.391 11.7171 14.6461C11.126 14.9012 10.49 15.0358 9.84619 15.0421C9.20241 15.0484 8.56383 14.9263 7.96783 14.6828C7.37183 14.4394 6.83036 14.0795 6.37512 13.6243C5.91988 13.169 5.56 12.6276 5.31655 12.0316C5.07309 11.4356 4.95095 10.797 4.95726 10.1532C4.96358 9.50943 5.09822 8.87338 5.35332 8.28226C5.60842 7.69115 5.97885 7.15685 6.44293 6.71062L6.57543 6.57812"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33398 16.6667L6.25065 13.75"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5007 3.33398L9.58398 6.25065"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6667 7.5L13.75 10.4167"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 2.5L17.5 17.5"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Collapse: React.FC<IconProps> = ({ color, size = 20, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    data-testid="collapse"
    id={id}
    className={className}
    {...rest}>
    <path
      d="M9.5 4V20M14.5 10L16.5 12L14.5 14M20.5 6C20.5 5.46957 20.2893 4.96086 19.9142 4.58579C19.5391 4.21071 19.0304 4 18.5 4H6.5C5.96957 4 5.46086 4.21071 5.08579 4.58579C4.71071 4.96086 4.5 5.46957 4.5 6V18C4.5 18.5304 4.71071 19.0391 5.08579 19.4142C5.46086 19.7893 5.96957 20 6.5 20H18.5C19.0304 20 19.5391 19.7893 19.9142 19.4142C20.2893 19.0391 20.5 18.5304 20.5 18V6Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CollapseHistory: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 25 25" fill="none" {...rest}>
    <path
      d="M15.5 4.5V20.5M10.5 10.5L8.5 12.5L10.5 14.5M4.5 6.5C4.5 5.96957 4.71071 5.46086 5.08579 5.08579C5.46086 4.71071 5.96957 4.5 6.5 4.5H18.5C19.0304 4.5 19.5391 4.71071 19.9142 5.08579C20.2893 5.46086 20.5 5.96957 20.5 6.5V18.5C20.5 19.0304 20.2893 19.5391 19.9142 19.9142C19.5391 20.2893 19.0304 20.5 18.5 20.5H6.5C5.96957 20.5 5.46086 20.2893 5.08579 19.9142C4.71071 19.5391 4.5 19.0304 4.5 18.5V6.5Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChatIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    width={size || 24}
    height={size || 25}
    viewBox="0 0 24 25"
    fill="none"
    data-testid="chat-icon"
    {...rest}>
    <path
      d="M8 9.5H16"
      stroke={color || 'white'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 13.5H14"
      stroke={color || 'white'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 18.5H6C5.20435 18.5 4.44129 18.1839 3.87868 17.6213C3.31607 17.0587 3 16.2956 3 15.5V7.5C3 6.70435 3.31607 5.94129 3.87868 5.37868C4.44129 4.81607 5.20435 4.5 6 4.5H18C18.7956 4.5 19.5587 4.81607 20.1213 5.37868C20.6839 5.94129 21 6.70435 21 7.5V15.5C21 16.2956 20.6839 17.0587 20.1213 17.6213C19.5587 18.1839 18.7956 18.5 18 18.5H15L12 21.5L9 18.5Z"
      stroke={color || 'white'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const NewChat: React.FC<IconProps> = ({ color, size = 28, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26 25"
    fill="none"
    data-testid="new-chat"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M8.5 9H16.5"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 13H14.5"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.51 18.594L8.5 21V18H6.5C5.70435 18 4.94129 17.6839 4.37868 17.1213C3.81607 16.5587 3.5 15.7956 3.5 15V7C3.5 6.20435 3.81607 5.44129 4.37868 4.87868C4.94129 4.31607 5.70435 4 6.5 4H18.5C19.2956 4 20.0587 4.31607 20.6213 4.87868C21.1839 5.44129 21.5 6.20435 21.5 7V12.5"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 19H22.5"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 16V22"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FeedbackIcon: React.FC<IconProps> = ({ color, size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="feedback-icon"
    {...rest}>
    <path
      d="M7 10H17"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 14H14"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4 3C13.445 3.00065 14.4668 3.30788 15.3388 3.88362C16.2109 4.45936 16.8949 5.27831 17.306 6.239C18.002 6.31747 18.6757 6.53225 19.2887 6.87109C19.9017 7.20993 20.442 7.6662 20.8787 8.21383C21.3153 8.76146 21.6399 9.38974 21.8337 10.0628C22.0276 10.7358 22.087 11.4405 22.0085 12.1365C21.93 12.8325 21.7152 13.5062 21.3764 14.1192C21.0376 14.7322 20.5813 15.2725 20.0337 15.7092C19.486 16.1458 18.8578 16.4704 18.1847 16.6642C17.5117 16.8581 16.807 16.9175 16.111 16.839C15.6045 17.735 14.7907 18.4173 13.8201 18.7598C12.8494 19.1022 11.7877 19.0817 10.831 18.702L7 21V17.866C6.60865 17.7755 6.24277 17.5978 5.92968 17.3462C5.61658 17.0946 5.36435 16.7755 5.19178 16.4128C5.01922 16.0501 4.93078 15.653 4.93307 15.2514C4.93536 14.8497 5.02831 14.4537 5.205 14.093C4.25025 13.5438 3.51345 12.6829 3.11821 11.6548C2.72296 10.6267 2.69333 9.49389 3.03429 8.44653C3.37524 7.39917 4.06603 6.50093 4.99076 5.90252C5.91548 5.30411 7.01788 5.04194 8.113 5.16C8.60885 4.48976 9.25502 3.94519 9.99956 3.57005C10.7441 3.19491 11.5663 2.99967 12.4 3Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ConversationStyle: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width={size || 24} height={size || 25} viewBox="0 0 24 25" fill="none" {...rest}>
    <path
      d="M18 19.5L16 17.5V5.5C16 4.379 16.879 3.5 18 3.5C19.121 3.5 20 4.379 20 5.5V17.5L18 19.5ZM18 19.5H5C4.46957 19.5 3.96086 19.2893 3.58579 18.9142C3.21071 18.5391 3 18.0304 3 17.5C3 16.9696 3.21071 16.4609 3.58579 16.0858C3.96086 15.7107 4.46957 15.5 5 15.5H9C9.53043 15.5 10.0391 15.2893 10.4142 14.9142C10.7893 14.5391 11 14.0304 11 13.5C11 12.9696 10.7893 12.4609 10.4142 12.0858C10.0391 11.7107 9.53043 11.5 9 11.5H6M16 7.5H20"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Bulb: React.FC<IconProps> = ({ color, size = 28, id, className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    data-testid="bulb"
    id={id}
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <path
      d="M4.17065 14.0499H5.26822M14.0487 4.17188V5.26944M22.8292 14.0499H23.9268M7.02431 7.02553L7.79261 7.79383M21.0731 7.02553L20.3048 7.79383"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7559 18.4406C9.83448 17.7495 9.15384 16.786 8.81041 15.6866C8.46698 14.5872 8.47818 13.4076 8.84241 12.3149C9.20664 11.2222 9.90544 10.2718 10.8398 9.59837C11.7742 8.9249 12.8968 8.5625 14.0486 8.5625C15.2004 8.5625 16.323 8.9249 17.2574 9.59837C18.1918 10.2718 18.8906 11.2222 19.2548 12.3149C19.619 13.4076 19.6302 14.5872 19.2868 15.6866C18.9434 16.786 18.2627 17.7495 17.3413 18.4406C16.9128 18.8647 16.5901 19.3838 16.3994 19.9559C16.2088 20.5279 16.1554 21.1368 16.2437 21.7332C16.2437 22.3154 16.0124 22.8738 15.6008 23.2854C15.1891 23.6971 14.6308 23.9284 14.0486 23.9284C13.4664 23.9284 12.9081 23.6971 12.4964 23.2854C12.0847 22.8738 11.8535 22.3154 11.8535 21.7332C11.9418 21.1368 11.8884 20.5279 11.6978 19.9559C11.5071 19.3838 11.1844 18.8647 10.7559 18.4406Z"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5242 19.5391H16.573"
      stroke={color || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Sound: React.FC<{ color?: string; size?: number }> = ({
  color = 'var(--text-disabled)',
  size = 24
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 160 160"
    fill="none"
    data-testid="sound"
    role="img"
    aria-label="sound icon">
    <rect x="20" y="50" width="18" height="60" fill={color} rx="5" />
    <rect x="55" y="50" width="18" height="60" fill={color} rx="5" />
    <rect x="90" y="50" width="18" height="60" fill={color} rx="5" />
    <rect x="125" y="50" width="18" height="60" fill={color} rx="5" />
  </svg>
)

export const WaveSound: React.FC<{
  color?: string
  size?: number
  shouldWave?: boolean
  className?: string
}> = ({ color, size, shouldWave, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={`cursor-pointer wave-sound-container ${className || ''}`}>
    <path
      d="M9.5 4C8.67157 4 8 4.67157 8 5.5V18.5C8 19.3284 8.67157 20 9.5 20C10.3284 20 11 19.3284 11 18.5V5.5C11 4.67157 10.3284 4 9.5 4Z"
      fill={color || 'currentColor'}
      className={`wave-bar-1 ${shouldWave ? 'wave-active' : ''}`}
    />
    <path
      d="M13 8.5C13 7.67157 13.6716 7 14.5 7C15.3284 7 16 7.67157 16 8.5V15.5C16 16.3284 15.3284 17 14.5 17C13.6716 17 13 16.3284 13 15.5V8.5Z"
      fill={color || 'currentColor'}
      className={`wave-bar-2 ${shouldWave ? 'wave-active' : ''}`}
    />
    <path
      d="M4.5 9C3.67157 9 3 9.67157 3 10.5V13.5C3 14.3284 3.67157 15 4.5 15C5.32843 15 6 14.3284 6 13.5V10.5C6 9.67157 5.32843 9 4.5 9Z"
      fill={color || 'currentColor'}
      className={`wave-bar-3 ${shouldWave ? 'wave-active' : ''}`}
    />
    <path
      d="M19.5 9C18.6716 9 18 9.67157 18 10.5V13.5C18 14.3284 18.6716 15 19.5 15C20.3284 15 21 14.3284 21 13.5V10.5C21 9.67157 20.3284 9 19.5 9Z"
      fill={color || 'currentColor'}
      className={`wave-bar-4 ${shouldWave ? 'wave-active' : ''}`}
    />
  </svg>
)

export const StopCircle = ({ color, size, className, ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || '#fff'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`cursor-pointer ${className || ''}`}
    {...rest}>
    <circle cx="12" cy="12" r="10" />
    <rect x="9" y="9" width="6" height="6" fill={color || 'none'} />
  </svg>
)

export const SmartinsightsIcon: React.FC<IconProps> = ({
  color,
  size = 15,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="smartinsights-icon"
    id={id}
    className={className}
    {...rest}>
    <g clipPath="url(#clip0_578_3614)">
      <g clipPath="url(#clip1_578_3614)">
        <path
          d="M11.1638 6.29448C11.1138 6.34441 11.076 6.40648 11.0578 6.47461C10.8875 7.10228 10.552 7.67581 10.0718 8.14294C9.39836 8.79814 8.93543 9.64888 8.73429 10.5682H6.26749C6.06636 9.64888 5.60343 8.79814 4.93003 8.14248C4.93003 8.14248 4.92909 8.14154 4.92863 8.14154C4.86376 8.07854 4.76109 8.07761 4.69669 8.14154L4.23563 8.60261C4.17169 8.66654 4.17123 8.77108 4.23563 8.83454C4.23936 8.83781 4.24263 8.84154 4.24636 8.84481C4.76949 9.35394 5.12696 10.0003 5.29356 10.6998C4.94076 10.8883 4.70089 11.2603 4.70089 11.6877V12.7144C4.70089 13.3327 5.20256 13.8344 5.82089 13.8344H6.10089V13.8811C6.10089 14.3967 6.51856 14.8144 7.03422 14.8144H7.96756C8.48323 14.8144 8.90089 14.3967 8.90089 13.8811V13.8344H9.18089C9.79923 13.8344 10.3009 13.3327 10.3009 12.7144V11.6877C10.3009 11.2598 10.061 10.8883 9.70822 10.6993C9.87483 9.99981 10.2318 9.35348 10.755 8.84481C11.6262 7.99688 12.1676 6.81201 12.1676 5.50021V5.49834C12.1676 5.42181 12.0747 5.38308 12.0206 5.43768L11.1638 6.29448Z"
          fill={color || '#17B0AD'}
        />
        <path
          d="M3.79443 4.86465C3.84763 4.81145 3.88637 4.74472 3.90317 4.67099C4.0567 3.99152 4.40203 3.36619 4.91117 2.86265C5.59483 2.18739 6.49503 1.80799 7.4461 1.79445C7.46383 1.79445 7.48157 1.79445 7.49883 1.79445C8.53157 1.79445 9.46583 2.22145 10.136 2.90839C10.1999 2.97372 10.3044 2.97465 10.3688 2.91025L10.8318 2.44732C10.8952 2.38385 10.8957 2.28072 10.8327 2.21632C9.9857 1.35112 8.80503 0.814453 7.49883 0.814453C7.47643 0.814453 7.4545 0.814453 7.4321 0.814453C4.9401 0.849453 2.8975 2.86732 2.83357 5.35885C2.83123 5.44519 2.8317 5.53105 2.83403 5.61645C2.83637 5.69299 2.9297 5.72892 2.98337 5.67525L3.79397 4.86465H3.79443Z"
          fill={color || '#17B0AD'}
        />
        <path
          d="M13.3081 2.05067C12.9255 1.66801 12.3048 1.66801 11.9221 2.05067C11.6659 2.30687 11.5819 2.66994 11.6692 2.99661L8.90838 5.75741C8.74272 5.71307 8.56818 5.71307 8.40252 5.75741L7.29185 4.64627C7.37912 4.31961 7.29512 3.95654 7.03892 3.70034C6.65625 3.31767 6.03558 3.31767 5.65292 3.70034C5.39672 3.95654 5.31272 4.31961 5.39998 4.64627L2.63918 7.40707C2.31252 7.31981 1.94945 7.40381 1.69325 7.66001C1.31058 8.04267 1.31058 8.66334 1.69325 9.046C2.07592 9.42867 2.69658 9.42867 3.07925 9.046C3.33545 8.7898 3.41945 8.42674 3.33218 8.10007L6.09298 5.33927C6.25865 5.38361 6.43318 5.38361 6.59885 5.33927L7.70952 6.44994C7.62225 6.77661 7.70625 7.13967 7.96245 7.39587C8.34512 7.77854 8.96578 7.77854 9.34845 7.39587C9.60465 7.13967 9.68865 6.77661 9.60138 6.44994L12.3622 3.68914C12.6889 3.77641 13.0519 3.69241 13.3081 3.43621C13.6908 3.05354 13.6908 2.43287 13.3081 2.05021V2.05067Z"
          fill={color || '#17B0AD'}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_578_3614">
        <rect width="14" height="14" fill="white" transform="translate(0.5 0.814453)" />
      </clipPath>
      <clipPath id="clip1_578_3614">
        <rect width="12.1893" height="14" fill="white" transform="translate(1.40625 0.814453)" />
      </clipPath>
    </defs>
  </svg>
)

export const SnowflakeIcon: React.FC<IconProps> = ({
  color,
  size = 15,
  id,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="snowflake-icon"
    id={id}
    className={className}
    {...rest}>
    <g clipPath="url(#clip0_578_3622)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0651 6.86155L12.407 7.81671L14.0651 8.76736C14.4835 9.00897 14.6274 9.53961 14.3839 9.9551C14.1426 10.3706 13.6091 10.5128 13.1907 10.2712L10.222 8.56413C10.0227 8.44897 9.88549 8.27058 9.82572 8.06736C9.79694 7.97477 9.78366 7.87994 9.78587 7.7851C9.78587 7.71736 9.79694 7.64736 9.81686 7.57961C9.87664 7.36736 10.0161 7.17768 10.222 7.058L13.1907 5.35316C13.6069 5.11381 14.1426 5.25607 14.3839 5.67155C14.6274 6.08703 14.4857 6.61768 14.0673 6.85929L14.0651 6.86155Z"
        fill={color || '#65B4E5'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4955 11.4838L9.52907 9.78123C9.36968 9.68865 9.19258 9.65252 9.02433 9.66832C8.5705 9.69994 8.21629 10.077 8.21629 10.5354V13.9451C8.21629 14.4261 8.60592 14.8145 9.08853 14.8145C9.57113 14.8145 9.96297 14.4238 9.96297 13.9451V12.037L11.6255 12.9922C12.0439 13.2338 12.5775 13.0915 12.8188 12.6761C13.0601 12.2606 12.9184 11.7277 12.5 11.4861L12.4955 11.4838Z"
        fill={color || '#65B4E5'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.07082 8.14865L7.83774 9.37478C7.80232 9.4109 7.73369 9.44026 7.68277 9.44026H7.31971C7.27101 9.44026 7.20016 9.4109 7.16474 9.37478L5.93166 8.14865C5.89624 8.11478 5.86746 8.04478 5.86746 7.9951V7.63381C5.86746 7.58413 5.89624 7.51413 5.93166 7.478L7.16474 6.25187C7.20016 6.21574 7.27101 6.18639 7.31971 6.18639H7.68277C7.73369 6.18639 7.80232 6.21349 7.83774 6.25187L9.07082 7.478C9.10624 7.51413 9.13502 7.58187 9.13502 7.63381V7.9951C9.13502 8.04252 9.10624 8.11252 9.07082 8.14865Z"
        fill={color || '#65B4E5'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.08568 7.80768C8.08568 7.758 8.05469 7.688 8.01927 7.65187L7.66285 7.29736C7.62743 7.26123 7.5588 7.23187 7.50788 7.23187H7.4946C7.4459 7.23187 7.37505 7.26123 7.34185 7.29736L6.98543 7.65187C6.95001 7.688 6.92344 7.758 6.92344 7.80768V7.82123C6.92344 7.8709 6.95001 7.93865 6.98543 7.97478L7.34185 8.32929C7.37727 8.36542 7.4459 8.39478 7.4946 8.39478H7.50788C7.55658 8.39478 7.62743 8.36542 7.66285 8.32929L8.01927 7.97478C8.05469 7.93865 8.08568 7.8709 8.08568 7.82123V7.80768Z"
        fill="#65B4E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.50693 4.14284L5.47562 5.84768C5.63502 5.94026 5.81212 5.97639 5.98258 5.96058C6.43419 5.92671 6.79061 5.55187 6.79061 5.09349V1.68381C6.79061 1.2051 6.39877 0.814453 5.91838 0.814453C5.43799 0.814453 5.04393 1.2051 5.04393 1.68381V3.59187L3.38138 2.63445C2.96519 2.39284 2.43166 2.53736 2.18815 2.95284C1.94684 3.37058 2.08853 3.90123 2.50693 4.14058V4.14284Z"
        fill="#65B4E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02211 5.96058C9.19258 5.97413 9.36968 5.938 9.52686 5.84768L12.4933 4.14284C12.9117 3.90123 13.0534 3.37058 12.8121 2.9551C12.5708 2.53961 12.0373 2.39736 11.6189 2.63671L9.95633 3.59413V1.68381C9.95633 1.2051 9.5667 0.814453 9.08189 0.814453C8.59707 0.814453 8.20965 1.2051 8.20965 1.68381V5.09349C8.20965 5.55187 8.56386 5.92897 9.01769 5.96058H9.02211Z"
        fill="#65B4E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.98258 9.66832C5.81212 9.65478 5.63502 9.68865 5.47562 9.78123L2.50693 11.4838C2.08853 11.7254 1.94684 12.2583 2.18815 12.6738C2.42945 13.0893 2.96297 13.2316 3.38138 12.9899L5.04393 12.0348V13.9428C5.04393 14.4238 5.43356 14.8122 5.91838 14.8122C6.4032 14.8122 6.79061 14.4215 6.79061 13.9428V10.5332C6.79061 10.0748 6.43641 9.69768 5.98258 9.66607V9.66832Z"
        fill="#65B4E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17676 8.06961C5.20554 7.97703 5.21882 7.88219 5.21661 7.78736C5.2144 7.71961 5.20554 7.64961 5.18562 7.58187C5.12806 7.36961 4.98638 7.17994 4.77828 7.06026L1.8118 5.35542C1.3934 5.11607 0.859874 5.25832 0.618571 5.67381C0.375054 6.08929 0.518951 6.61994 0.937357 6.86155L2.59548 7.81671L0.937357 8.76736C0.518951 9.00897 0.375054 9.53961 0.618571 9.9551C0.859874 10.3706 1.39118 10.5128 1.8118 10.2712L4.77828 8.56413C4.97973 8.45123 5.11478 8.27058 5.17676 8.06736V8.06961Z"
        fill="#65B4E5"
      />
    </g>
    <defs>
      <clipPath id="clip0_578_3622">
        <rect width="14" height="14" fill="white" transform="translate(0.5 0.814453)" />
      </clipPath>
    </defs>
  </svg>
)

export const PromptLibraryIcon: React.FC<IconProps> = ({ color, size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-label="Prompt library icon"
    {...rest}>
    <g>
      <path
        fill={color || '#454545'}
        fillRule="evenodd"
        d="M4.817982857142857 1.1252571428571427c0.3213942857142857 -1.4929765714285712 2.4347999999999996 -1.5036411428571428 2.76936 -0.01207542857142857l0.04335428571428571 0.1932925714285714c0.4089257142857143 1.8231257142857142 1.8507257142857143 3.206725714285714 3.6434914285714286 3.523885714285714 1.5391714285714286 0.27227999999999997 1.5391714285714286 2.4955714285714286 0 2.7678514285714284 -1.792765714285714 0.31716 -3.234565714285714 1.70076 -3.6434914285714286 3.523885714285714l-0.04335428571428571 0.19330285714285714c-0.33455999999999997 1.4915657142857142 -2.447965714285714 1.4808857142857141 -2.76936 -0.012085714285714285l-0.03570857142857143 -0.16585714285714284C4.388279999999999 9.307251428571428 2.9480742857142856 7.913194285714286 1.1521097142857142 7.595485714285713c-1.5361405714285714 -0.2717657142857143 -1.5361525714285713 -2.4906342857142856 0 -2.7623828571428573C2.9480742857142856 4.515377142857143 4.388279999999999 3.12132 4.782274285714285 1.2911194285714285l0.8379428571428571 0.18038914285714286 -0.8379428571428571 -0.18039085714285713L4.817982857142857 1.1252571428571427Zm14.070874285714284 7.06290857142857c0.07337142857142856 -0.030874285714285715 0.15222857142857144 -0.04676571428571428 0.23177142857142854 -0.04676571428571428 0.07954285714285714 0 0.15839999999999999 0.01589142857142857 0.23177142857142854 0.04676571428571428 0.07337142857142856 0.030891428571428573 0.13988571428571428 0.07611428571428572 0.19542857142857142 0.1330285714285714l0 0.00001714285714285714 0.005485714285714286 0.005554285714285714 2.1197142857142857 2.136342857142857 0 0.00003428571428571428 0.006171428571428571 0.006051428571428571c0.055885714285714275 0.05554285714285714 0.10045714285714286 0.12164571428571427 0.1308 0.1944685714285714 0.030342857142857144 0.07282285714285713 0.04594285714285714 0.15092571428571427 0.04594285714285714 0.22981714285714286 0 0.07889142857142857 -0.0156 0.1569942857142857 -0.04594285714285714 0.22981714285714286 -0.030342857142857144 0.07282285714285713 -0.07491428571428571 0.1389257142857143 -0.1308 0.1944685714285714l-0.005657142857142857 0.005537142857142857 -10.07129142857143 10.136297142857142 -3.3461142857142856 0.29005714285714285 0.29000571428571426 -3.3461142857142856 10.136314285714285 -10.071359999999999 0 0.00006857142857142857 0.010971428571428571 -0.011057142857142857c0.05554285714285714 -0.05691428571428571 0.12205714285714285 -0.10213714285714286 0.19542857142857142 -0.1330285714285714Zm0.23177142857142854 -2.189622857142857c-0.3651428571428571 0 -0.7265142857142857 0.07292571428571429 -1.0628571428571427 0.21452571428571426 -0.33394285714285715 0.14046857142857141 -0.6365142857142857 0.34568571428571426 -0.8903999999999999 0.6037714285714285L6.757422857142856 17.16c-0.17974285714285712 0.17862857142857141 -0.29038285714285716 0.4150285714285714 -0.31225714285714284 0.6675428571428571l-0.43393714285714285 5.007085714285714c-0.027325714285714283 0.31525714285714285 0.0860742857142857 0.6264 0.30980571428571424 0.8501142857142857s0.5349085714285714 0.3370285714285714 0.8501314285714285 0.30977142857142853l5.007051428571429 -0.43388571428571426c0.2524285714285714 -0.021942857142857142 0.48894857142857134 -0.1325142857142857 0.6675428571428571 -0.31234285714285714l10.34544 -10.412125714285713c0.2554285714285714 -0.2541257142857143 0.4582285714285714 -0.5561485714285713 0.5967428571428571 -0.8887714285714284 0.1392 -0.33394285714285715 0.21085714285714285 -0.6921428571428571 0.21085714285714285 -1.0539085714285714 0 -0.36178285714285713 -0.07165714285714285 -0.7199657142857143 -0.21085714285714285 -1.0539085714285714 -0.1385142857142857 -0.33245142857142856 -0.34114285714285714 -0.63432 -0.5963999999999999 -0.8883599999999998L21.077142857142857 6.820045714285714c-0.25474285714285716 -0.2595942857142857 -0.5583428571428571 -0.4659257142857142 -0.8936571428571428 -0.6069771428571428 -0.33634285714285717 -0.1416 -0.6978857142857143 -0.21452571428571426 -1.0628571428571427 -0.21452571428571426Z"
        clipRule="evenodd"
        strokeWidth="1"></path>
    </g>
  </svg>
)

export const AgentIcon: React.FC<IconProps> = ({ color, size = 20, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none">
    <path
      d="M6 9C6 10.1935 7.26428 11.3381 9.51472 12.182C11.7652 13.0259 14.8174 13.5 18 13.5C21.1826 13.5 24.2348 13.0259 26.4853 12.182C28.7357 11.3381 30 10.1935 30 9M6 9C6 7.80653 7.26428 6.66193 9.51472 5.81802C11.7652 4.97411 14.8174 4.5 18 4.5C21.1826 4.5 24.2348 4.97411 26.4853 5.81802C28.7357 6.66193 30 7.80653 30 9M6 9V18M30 9V18M6 18C6 19.1935 7.26428 20.3381 9.51472 21.182C11.7652 22.0259 14.8174 22.5 18 22.5C21.1826 22.5 24.2348 22.0259 26.4853 21.182C28.7357 20.3381 30 19.1935 30 18M6 18V27C6 28.1935 7.26428 29.3381 9.51472 30.182C11.7652 31.0259 14.8174 31.5 18 31.5C21.1826 31.5 24.2348 31.0259 26.4853 30.182C28.7357 29.3381 30 28.1935 30 27V18"
      stroke="#74A5B3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DoubleFileIcon: React.FC<IconProps> = ({ color, size = 20, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none">
    <path
      d="M26.6666 10L16 4L5.33331 10M26.6666 10V22L16 28M26.6666 10L16 16M16 28L5.33331 22V10M16 28V16M5.33331 10L16 16M21.3333 7L10.6666 13"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DataboxIcon: React.FC<IconProps> = ({ color, size, strokeWidth, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M26.6666 10L16 4L5.33331 10M26.6666 10V22L16 28M26.6666 10L16 16M16 28L5.33331 22V10M16 28V16M5.33331 10L16 16M21.3333 7L10.6666 13"
      stroke={color}
      strokeWidth={strokeWidth || '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ReorderIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none">
    <path
      d="M6.6665 4.16634C6.6665 4.38735 6.7543 4.59932 6.91058 4.7556C7.06686 4.91188 7.27882 4.99967 7.49984 4.99967C7.72085 4.99967 7.93281 4.91188 8.08909 4.7556C8.24537 4.59932 8.33317 4.38735 8.33317 4.16634C8.33317 3.94533 8.24537 3.73337 8.08909 3.57709C7.93281 3.42081 7.72085 3.33301 7.49984 3.33301C7.27882 3.33301 7.06686 3.42081 6.91058 3.57709C6.7543 3.73337 6.6665 3.94533 6.6665 4.16634ZM6.6665 9.99967C6.6665 10.2207 6.7543 10.4326 6.91058 10.5889C7.06686 10.7452 7.27882 10.833 7.49984 10.833C7.72085 10.833 7.93281 10.7452 8.08909 10.5889C8.24537 10.4326 8.33317 10.2207 8.33317 9.99967C8.33317 9.77866 8.24537 9.5667 8.08909 9.41042C7.93281 9.25414 7.72085 9.16634 7.49984 9.16634C7.27882 9.16634 7.06686 9.25414 6.91058 9.41042C6.7543 9.5667 6.6665 9.77866 6.6665 9.99967ZM6.6665 15.833C6.6665 16.054 6.7543 16.266 6.91058 16.4223C7.06686 16.5785 7.27882 16.6663 7.49984 16.6663C7.72085 16.6663 7.93281 16.5785 8.08909 16.4223C8.24537 16.266 8.33317 16.054 8.33317 15.833C8.33317 15.612 8.24537 15.4 8.08909 15.2438C7.93281 15.0875 7.72085 14.9997 7.49984 14.9997C7.27882 14.9997 7.06686 15.0875 6.91058 15.2438C6.7543 15.4 6.6665 15.612 6.6665 15.833ZM11.6665 4.16634C11.6665 4.38735 11.7543 4.59932 11.9106 4.7556C12.0669 4.91188 12.2788 4.99967 12.4998 4.99967C12.7209 4.99967 12.9328 4.91188 13.0891 4.7556C13.2454 4.59932 13.3332 4.38735 13.3332 4.16634C13.3332 3.94533 13.2454 3.73337 13.0891 3.57709C12.9328 3.42081 12.7209 3.33301 12.4998 3.33301C12.2788 3.33301 12.0669 3.42081 11.9106 3.57709C11.7543 3.73337 11.6665 3.94533 11.6665 4.16634ZM11.6665 9.99967C11.6665 10.2207 11.7543 10.4326 11.9106 10.5889C12.0669 10.7452 12.2788 10.833 12.4998 10.833C12.7209 10.833 12.9328 10.7452 13.0891 10.5889C13.2454 10.4326 13.3332 10.2207 13.3332 9.99967C13.3332 9.77866 13.2454 9.5667 13.0891 9.41042C12.9328 9.25414 12.7209 9.16634 12.4998 9.16634C12.2788 9.16634 12.0669 9.25414 11.9106 9.41042C11.7543 9.5667 11.6665 9.77866 11.6665 9.99967ZM11.6665 15.833C11.6665 16.054 11.7543 16.266 11.9106 16.4223C12.0669 16.5785 12.2788 16.6663 12.4998 16.6663C12.7209 16.6663 12.9328 16.5785 13.0891 16.4223C13.2454 16.266 13.3332 16.054 13.3332 15.833C13.3332 15.612 13.2454 15.4 13.0891 15.2438C12.9328 15.0875 12.7209 14.9997 12.4998 14.9997C12.2788 14.9997 12.0669 15.0875 11.9106 15.2438C11.7543 15.4 11.6665 15.612 11.6665 15.833Z"
      stroke={color || 'var(--icon-color-200)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ExportIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M9.33301 2V4.66667C9.33301 4.84348 9.40325 5.01305 9.52827 5.13807C9.65329 5.2631 9.82286 5.33333 9.99967 5.33333H12.6663M9.33301 2H4.66634C4.31272 2 3.97358 2.14048 3.72353 2.39052C3.47348 2.64057 3.33301 2.97971 3.33301 3.33333V12.6667C3.33301 13.0203 3.47348 13.3594 3.72353 13.6095C3.97358 13.8595 4.31272 14 4.66634 14H7.66634M9.33301 2L12.6663 5.33333M12.6663 5.33333V8.66667M9.33301 12.6667H13.9997M13.9997 12.6667L11.9997 10.6667M13.9997 12.6667L11.9997 14.6667"
      stroke="#878295"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DeprecateIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M3.8 3.8L12.2 12.2M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
      stroke="#878295"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BinIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M2.66699 4.66667H13.3337M6.66699 7.33333V11.3333M9.33366 7.33333V11.3333M3.33366 4.66667L4.00033 12.6667C4.00033 13.0203 4.1408 13.3594 4.39085 13.6095C4.6409 13.8595 4.98004 14 5.33366 14H10.667C11.0206 14 11.3598 13.8595 11.6098 13.6095C11.8598 13.3594 12.0003 13.0203 12.0003 12.6667L12.667 4.66667M6.00033 4.66667V2.66667C6.00033 2.48986 6.07056 2.32029 6.19559 2.19526C6.32061 2.07024 6.49018 2 6.66699 2H9.33366C9.51047 2 9.68004 2.07024 9.80506 2.19526C9.93009 2.32029 10.0003 2.48986 10.0003 2.66667V4.66667"
      stroke="#CC2E2E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DataProductIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M5.33325 8C5.33325 9.06087 6.45706 10.0783 8.45745 10.8284C10.4578 11.5786 13.1709 12 15.9999 12C18.8289 12 21.542 11.5786 23.5424 10.8284C25.5428 10.0783 26.6666 9.06087 26.6666 8M5.33325 8C5.33325 6.93913 6.45706 5.92172 8.45745 5.17157C10.4578 4.42143 13.1709 4 15.9999 4C18.8289 4 21.542 4.42143 23.5424 5.17157C25.5428 5.92172 26.6666 6.93913 26.6666 8M5.33325 8V16M26.6666 8V16M5.33325 16C5.33325 17.0609 6.45706 18.0783 8.45745 18.8284C10.4578 19.5786 13.1709 20 15.9999 20C18.8289 20 21.542 19.5786 23.5424 18.8284C25.5428 18.0783 26.6666 17.0609 26.6666 16M5.33325 16V24C5.33325 25.0609 6.45706 26.0783 8.45745 26.8284C10.4578 27.5786 13.1709 28 15.9999 28C18.8289 28 21.542 27.5786 23.5424 26.8284C25.5428 26.0783 26.6666 25.0609 26.6666 24V16"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FileIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M20.0001 4V9.33333C20.0001 9.68696 20.1406 10.0261 20.3906 10.2761C20.6407 10.5262 20.9798 10.6667 21.3334 10.6667H26.6667M20.0001 4H14.6667C13.9595 4 13.2812 4.28095 12.7811 4.78105C12.281 5.28115 12.0001 5.95942 12.0001 6.66667V20C12.0001 20.7072 12.281 21.3855 12.7811 21.8856C13.2812 22.3857 13.9595 22.6667 14.6667 22.6667H24.0001C24.7073 22.6667 25.3856 22.3857 25.8857 21.8856C26.3858 21.3855 26.6667 20.7072 26.6667 20V10.6667M20.0001 4L26.6667 10.6667M21.3334 22.6667V25.3333C21.3334 26.0406 21.0525 26.7189 20.5524 27.219C20.0523 27.719 19.374 28 18.6667 28H9.33341C8.62617 28 7.94789 27.719 7.4478 27.219C6.9477 26.7189 6.66675 26.0406 6.66675 25.3333V12C6.66675 11.2928 6.9477 10.6145 7.4478 10.1144C7.94789 9.61428 8.62617 9.33333 9.33341 9.33333H12.0001"
      stroke="#878295"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const RecentDataIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M28 16C28 13.6266 27.2962 11.3066 25.9776 9.33316C24.6591 7.35977 22.7849 5.8217 20.5922 4.91345C18.3995 4.0052 15.9867 3.76756 13.6589 4.23058C11.3311 4.6936 9.19295 5.83649 7.51472 7.51472C5.83649 9.19295 4.6936 11.3311 4.23058 13.6589C3.76756 15.9867 4.0052 18.3995 4.91345 20.5922C5.8217 22.7849 7.35977 24.6591 9.33316 25.9776C11.3066 27.2962 13.6266 28 16 28M16 9.33334V16L17.3333 17.3333M21.3333 21.3333H29.3333V29.3333H21.3333V21.3333Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MonitorIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M7 20H17M9 16V20M15 16V20M15 10H9M12 7V13M3 5C3 4.73478 3.10536 4.48043 3.29289 4.29289C3.48043 4.10536 3.73478 4 4 4H20C20.2652 4 20.5196 4.10536 20.7071 4.29289C20.8946 4.48043 21 4.73478 21 5V15C21 15.2652 20.8946 15.5196 20.7071 15.7071C20.5196 15.8946 20.2652 16 20 16H4C3.73478 16 3.48043 15.8946 3.29289 15.7071C3.10536 15.5196 3 15.2652 3 15V5Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PendingIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...rest}>
    <path
      d="M4.33333 11.3333H11.6667M8 8C6.93913 8 5.92172 8.42143 5.17157 9.17157C4.42143 9.92172 4 10.9391 4 12V13.3333C4 13.5101 4.07024 13.6797 4.19526 13.8047C4.32029 13.9298 4.48986 14 4.66667 14H11.3333C11.5101 14 11.6797 13.9298 11.8047 13.8047C11.9298 13.6797 12 13.5101 12 13.3333V12C12 10.9391 11.5786 9.92172 10.8284 9.17157C10.0783 8.42143 9.06087 8 8 8ZM8 8C6.93913 8 5.92172 7.57857 5.17157 6.82843C4.42143 6.07828 4 5.06087 4 4V2.66667C4 2.48986 4.07024 2.32029 4.19526 2.19526C4.32029 2.07024 4.48986 2 4.66667 2H11.3333C11.5101 2 11.6797 2.07024 11.8047 2.19526C11.9298 2.32029 12 2.48986 12 2.66667V4C12 5.06087 11.5786 6.07828 10.8284 6.82843C10.0783 7.57857 9.06087 8 8 8Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TagIcon: React.FC<IconProps> = ({ color, size, strokeWidth, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M24 25.3333L26.1227 23.2107C27.3277 22.0055 28.0047 20.371 28.0047 18.6667C28.0047 16.9624 27.3277 15.3279 26.1227 14.1227L20 8M9.33333 13.3333H9.32M4 10.6667V16.2293C4.00015 16.9365 4.2812 17.6147 4.78133 18.1147L12.3947 25.728C12.9973 26.3305 13.8145 26.669 14.6667 26.669C15.5188 26.669 16.3361 26.3305 16.9387 25.728L21.728 20.9387C22.3305 20.3361 22.669 19.5188 22.669 18.6667C22.669 17.8145 22.3305 16.9973 21.728 16.3947L14.1147 8.78133C13.6147 8.2812 12.9365 8.00015 12.2293 8H6.66667C5.95942 8 5.28115 8.28095 4.78105 8.78105C4.28095 9.28115 4 9.95942 4 10.6667Z"
      stroke={color}
      strokeWidth={strokeWidth || '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FilesIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    {...rest}>
    <path
      d="M12.5 2.5V5.83333C12.5 6.05435 12.5878 6.26631 12.7441 6.42259C12.9003 6.57887 13.1123 6.66667 13.3333 6.66667H16.6667M12.5 2.5H9.16666C8.72463 2.5 8.30071 2.67559 7.98815 2.98816C7.67558 3.30072 7.49999 3.72464 7.49999 4.16667V12.5C7.49999 12.942 7.67558 13.366 7.98815 13.6785C8.30071 13.9911 8.72463 14.1667 9.16666 14.1667H15C15.442 14.1667 15.8659 13.9911 16.1785 13.6785C16.4911 13.366 16.6667 12.942 16.6667 12.5V6.66667M12.5 2.5L16.6667 6.66667M13.3333 14.1667V15.8333C13.3333 16.2754 13.1577 16.6993 12.8452 17.0118C12.5326 17.3244 12.1087 17.5 11.6667 17.5H5.83332C5.3913 17.5 4.96737 17.3244 4.65481 17.0118C4.34225 16.6993 4.16666 16.2754 4.16666 15.8333V7.5C4.16666 7.05797 4.34225 6.63405 4.65481 6.32149C4.96737 6.00893 5.3913 5.83333 5.83332 5.83333H7.49999"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DataProductsIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none">
    <path
      d="M3.33331 5C3.33331 5.66304 4.03569 6.29893 5.28593 6.76777C6.53618 7.23661 8.23187 7.5 9.99998 7.5C11.7681 7.5 13.4638 7.23661 14.714 6.76777C15.9643 6.29893 16.6666 5.66304 16.6666 5M3.33331 5C3.33331 4.33696 4.03569 3.70107 5.28593 3.23223C6.53618 2.76339 8.23187 2.5 9.99998 2.5C11.7681 2.5 13.4638 2.76339 14.714 3.23223C15.9643 3.70107 16.6666 4.33696 16.6666 5M3.33331 5V10M16.6666 5V10M3.33331 10C3.33331 10.663 4.03569 11.2989 5.28593 11.7678C6.53618 12.2366 8.23187 12.5 9.99998 12.5C11.7681 12.5 13.4638 12.2366 14.714 11.7678C15.9643 11.2989 16.6666 10.663 16.6666 10M3.33331 10V15C3.33331 15.663 4.03569 16.2989 5.28593 16.7678C6.53618 17.2366 8.23187 17.5 9.99998 17.5C11.7681 17.5 13.4638 17.2366 14.714 16.7678C15.9643 16.2989 16.6666 15.663 16.6666 15V10"
      stroke="#878295"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PdfIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.12493 0H11.8116L17.4787 5.90705V17.3963C17.4787 18.8356 16.3143 20 14.88 20H5.12493C3.68565 20 2.52124 18.8356 2.52124 17.3963V2.60369C2.52121 1.16441 3.68563 0 5.12493 0Z"
      fill="#E5252A"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8066 0V5.86207H17.4788L11.8066 0Z"
      fill="white"
    />
    <path
      d="M5.41479 14.9225V11.2693H6.96902C7.35383 11.2693 7.65869 11.3742 7.88857 11.5891C8.11845 11.799 8.2334 12.0839 8.2334 12.4387C8.2334 12.7935 8.11845 13.0784 7.88857 13.2883C7.65869 13.5032 7.35383 13.6081 6.96902 13.6081H6.34933V14.9225H5.41479ZM6.34933 12.8135H6.86408C7.004 12.8135 7.11395 12.7835 7.18892 12.7136C7.26387 12.6486 7.30387 12.5587 7.30387 12.4387C7.30387 12.3188 7.2639 12.2288 7.18892 12.1639C7.11397 12.0939 7.00402 12.0639 6.86408 12.0639H6.34933V12.8135ZM8.61819 14.9225V11.2693H9.91254C10.1674 11.2693 10.4073 11.3043 10.6322 11.3792C10.8571 11.4542 11.062 11.5592 11.2419 11.7041C11.4218 11.844 11.5667 12.0339 11.6717 12.2738C11.7716 12.5137 11.8266 12.7885 11.8266 13.0984C11.8266 13.4032 11.7716 13.6781 11.6717 13.918C11.5667 14.1578 11.4218 14.3477 11.2419 14.4877C11.0619 14.6326 10.8571 14.7375 10.6322 14.8125C10.4073 14.8875 10.1674 14.9225 9.91254 14.9225H8.61819ZM9.53273 14.1279H9.80259C9.94752 14.1279 10.0825 14.1129 10.2074 14.0779C10.3273 14.0429 10.4423 13.9879 10.5522 13.913C10.6572 13.838 10.7421 13.7331 10.8021 13.5931C10.8621 13.4532 10.8921 13.2883 10.8921 13.0984C10.8921 12.9035 10.8621 12.7386 10.8021 12.5986C10.7421 12.4587 10.6572 12.3538 10.5522 12.2788C10.4423 12.2038 10.3273 12.1489 10.2074 12.1139C10.0825 12.0789 9.94752 12.0639 9.80259 12.0639H9.53273V14.1279ZM12.2964 14.9225V11.2693H14.8951V12.0639H13.2309V12.6486H14.5602V13.4382H13.2309V14.9225H12.2964Z"
      fill="white"
    />
  </svg>
)

export const AddImage: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...rest}>
    <path
      d="M10 5.33333H10.0067M8.33333 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V8.33333M2 10.6667L5.33333 7.33333C5.952 6.738 6.71467 6.738 7.33333 7.33333L10 10M9.33333 9.33333L10 8.66667C10.4467 8.23733 10.9667 8.11733 11.4547 8.30667M10.6667 12.6667H14.6667M12.6667 10.6667V14.6667"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const RemoveImage: React.FC<IconProps> = ({ color, size = 24, id, className, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...rest}>
    <path
      d="M10 5.33333H10.0067M8.33333 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V10M2 10.6667L5.33333 7.33333C5.952 6.738 6.71467 6.738 7.33333 7.33333L10 10M9.33333 9.33333L10 8.66667C10.6187 8.07133 11.3813 8.07133 12 8.66667L13.3333 10M10.6667 12.6667H14.6667"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const OverviewIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none">
    <path
      d="M8 24L24 32L40 24M8 32L24 40L40 32M24 8L8 16L24 24L40 16L24 8Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const WorkspaceActiveIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none">
    <path
      d="M20.3333 3C20.8637 3 21.3722 3.21086 21.7473 3.58594C22.1224 3.96101 22.3333 4.46957 22.3333 5V15C22.3333 15.5304 22.1224 16.039 21.7473 16.4141C21.3722 16.7891 20.8637 17 20.3333 17H16.3333V19H17.3333C17.5985 19 17.8527 19.1054 18.0403 19.293C18.2278 19.4805 18.3333 19.7348 18.3333 20C18.3333 20.2652 18.2278 20.5195 18.0403 20.707C17.8527 20.8946 17.5985 21 17.3333 21H7.33325C7.06804 21 6.81376 20.8946 6.62622 20.707C6.43868 20.5195 6.33325 20.2652 6.33325 20C6.33325 19.7348 6.43868 19.4805 6.62622 19.293C6.81376 19.1054 7.06804 19 7.33325 19H8.33325V17H4.33325C3.80282 17 3.29426 16.7891 2.91919 16.4141C2.54412 16.039 2.33325 15.5304 2.33325 15V5C2.33325 4.46957 2.54412 3.96101 2.91919 3.58594C3.29426 3.21086 3.80282 3 4.33325 3H20.3333ZM10.3333 19H14.3333V17H10.3333V19ZM16.0403 7.29297C15.6498 6.90244 15.0167 6.90244 14.6262 7.29297L11.3333 10.5859L10.0403 9.29297C9.64976 8.90244 9.01675 8.90244 8.62622 9.29297C8.2357 9.68349 8.2357 10.3165 8.62622 10.707L10.6262 12.707C11.0167 13.0976 11.6498 13.0976 12.0403 12.707L16.0403 8.70703C16.4308 8.31651 16.4308 7.68349 16.0403 7.29297Z"
      fill="#055A60"
    />
  </svg>
)

export const LinktoIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M6.00001 9.99997L10 5.99997M7.33334 3.99997L7.64201 3.64264C7.95155 3.33302 8.31905 3.08741 8.72353 2.91983C9.128 2.75226 9.56153 2.66602 9.99934 2.66602C10.4372 2.66602 10.8707 2.75226 11.2752 2.91983C11.6796 3.08741 12.0471 3.33302 12.3567 3.64264C12.6668 3.95191 12.9129 4.31935 13.0807 4.72389C13.2486 5.12843 13.335 5.56212 13.3349 6.00011C13.3348 6.4381 13.2483 6.87176 13.0804 7.27626C12.9124 7.68075 12.6662 8.04812 12.356 8.3573M8.40201 12.356C7.76934 12.9811 6.91576 13.3317 6.02634 13.3317C5.13692 13.3317 4.28334 12.9811 3.65067 12.356C3.33875 12.0478 3.0911 11.6808 2.92207 11.2762C2.75305 10.8716 2.66602 10.4375 2.66602 9.99897C2.66602 9.56049 2.75305 9.12636 2.92207 8.72177C3.0911 8.31717 3.33875 7.95015 3.65067 7.64197L4.00001 7.3333M10.6667 12.6666H14.6667M12.6667 10.6666V14.6666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AgentChatIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M5.33333 5.99996H10.6667M5.33333 8.66663H9.33333M6 12H4C3.46957 12 2.96086 11.7892 2.58579 11.4142C2.21071 11.0391 2 10.5304 2 9.99996V4.66663C2 4.13619 2.21071 3.62749 2.58579 3.25241C2.96086 2.87734 3.46957 2.66663 4 2.66663H12C12.5304 2.66663 13.0391 2.87734 13.4142 3.25241C13.7893 3.62749 14 4.13619 14 4.66663V9.99996C14 10.5304 13.7893 11.0391 13.4142 11.4142C13.0391 11.7892 12.5304 12 12 12H10L8 14L6 12Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Window: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 4.75H16.75M0.75 2.75C0.75 2.21957 0.960714 1.71086 1.33579 1.33579C1.71086 0.960714 2.21957 0.75 2.75 0.75H14.75C15.2804 0.75 15.7891 0.960714 16.1642 1.33579C16.5393 1.71086 16.75 2.21957 16.75 2.75V14.75C16.75 15.2804 16.5393 15.7891 16.1642 16.1642C15.7891 16.5393 15.2804 16.75 14.75 16.75H2.75C2.21957 16.75 1.71086 16.5393 1.33579 16.1642C0.960714 15.7891 0.75 15.2804 0.75 14.75V2.75Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AIApps: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 5L15 7.5M5 17.5L17.5 5L15 2.5L2.5 15L5 17.5ZM7.5 2.5C7.5 2.94203 7.67559 3.36595 7.98816 3.67851C8.30072 3.99107 8.72464 4.16667 9.16667 4.16667C8.72464 4.16667 8.30072 4.34226 7.98816 4.65482C7.67559 4.96738 7.5 5.39131 7.5 5.83333C7.5 5.39131 7.3244 4.96738 7.01184 4.65482C6.69928 4.34226 6.27536 4.16667 5.83333 4.16667C6.27536 4.16667 6.69928 3.99107 7.01184 3.67851C7.3244 3.36595 7.5 2.94203 7.5 2.5ZM15.8333 10.8333C15.8333 11.2754 16.0089 11.6993 16.3215 12.0118C16.634 12.3244 17.058 12.5 17.5 12.5C17.058 12.5 16.634 12.6756 16.3215 12.9882C16.0089 13.3007 15.8333 13.7246 15.8333 14.1667C15.8333 13.7246 15.6577 13.3007 15.3452 12.9882C15.0326 12.6756 14.6087 12.5 14.1667 12.5C14.6087 12.5 15.0326 12.3244 15.3452 12.0118C15.6577 11.6993 15.8333 11.2754 15.8333 10.8333Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const WorkspaceIcon2: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 18H15M7 14V18M13 14V18M1 3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V13C19 13.2652 18.8946 13.5196 18.7071 13.7071C18.5196 13.8946 18.2652 14 18 14H2C1.73478 14 1.48043 13.8946 1.29289 13.7071C1.10536 13.5196 1 13.2652 1 13V3Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MarketPlace: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 1.58333C0.75 1.36232 0.837798 1.15036 0.994078 0.994078C1.15036 0.837798 1.36232 0.75 1.58333 0.75H4.91667C5.13768 0.75 5.34964 0.837798 5.50592 0.994078C5.6622 1.15036 5.75 1.36232 5.75 1.58333V4.91667C5.75 5.13768 5.6622 5.34964 5.50592 5.50592C5.34964 5.6622 5.13768 5.75 4.91667 5.75H1.58333C1.36232 5.75 1.15036 5.6622 0.994078 5.50592C0.837798 5.34964 0.75 5.13768 0.75 4.91667V1.58333ZM9.08333 1.58333C9.08333 1.36232 9.17113 1.15036 9.32741 0.994078C9.48369 0.837798 9.69565 0.75 9.91667 0.75H13.25C13.471 0.75 13.683 0.837798 13.8393 0.994078C13.9955 1.15036 14.0833 1.36232 14.0833 1.58333V4.91667C14.0833 5.13768 13.9955 5.34964 13.8393 5.50592C13.683 5.6622 13.471 5.75 13.25 5.75H9.91667C9.69565 5.75 9.48369 5.6622 9.32741 5.50592C9.17113 5.34964 9.08333 5.13768 9.08333 4.91667V1.58333ZM0.75 9.91667C0.75 9.69565 0.837798 9.48369 0.994078 9.32741C1.15036 9.17113 1.36232 9.08333 1.58333 9.08333H4.91667C5.13768 9.08333 5.34964 9.17113 5.50592 9.32741C5.6622 9.48369 5.75 9.69565 5.75 9.91667V13.25C5.75 13.471 5.6622 13.683 5.50592 13.8393C5.34964 13.9955 5.13768 14.0833 4.91667 14.0833H1.58333C1.36232 14.0833 1.15036 13.9955 0.994078 13.8393C0.837798 13.683 0.75 13.471 0.75 13.25V9.91667ZM9.08333 9.91667C9.08333 9.69565 9.17113 9.48369 9.32741 9.32741C9.48369 9.17113 9.69565 9.08333 9.91667 9.08333H13.25C13.471 9.08333 13.683 9.17113 13.8393 9.32741C13.9955 9.48369 14.0833 9.69565 14.0833 9.91667V13.25C14.0833 13.471 13.9955 13.683 13.8393 13.8393C13.683 13.9955 13.471 14.0833 13.25 14.0833H9.91667C9.69565 14.0833 9.48369 13.9955 9.32741 13.8393C9.17113 13.683 9.08333 13.471 9.08333 13.25V9.91667Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TeamsIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 17.5V15.8333C2.5 14.9493 2.85119 14.1014 3.47631 13.4763C4.10143 12.8512 4.94928 12.5 5.83333 12.5H9.16667C10.0507 12.5 10.8986 12.8512 11.5237 13.4763C12.1488 14.1014 12.5 14.9493 12.5 15.8333V17.5M13.3333 2.60833C14.0503 2.79192 14.6859 3.20892 15.1397 3.79359C15.5935 4.37827 15.8399 5.09736 15.8399 5.8375C15.8399 6.57764 15.5935 7.29673 15.1397 7.88141C14.6859 8.46608 14.0503 8.88308 13.3333 9.06667M17.5 17.5V15.8333C17.4958 15.0976 17.2483 14.384 16.7961 13.8037C16.3439 13.2233 15.7124 12.8089 15 12.625M4.16667 5.83333C4.16667 6.71739 4.51786 7.56523 5.14298 8.19036C5.7681 8.81548 6.61594 9.16667 7.5 9.16667C8.38405 9.16667 9.2319 8.81548 9.85702 8.19036C10.4821 7.56523 10.8333 6.71739 10.8333 5.83333C10.8333 4.94928 10.4821 4.10143 9.85702 3.47631C9.2319 2.85119 8.38405 2.5 7.5 2.5C6.61594 2.5 5.7681 2.85119 5.14298 3.47631C4.51786 4.10143 4.16667 4.94928 4.16667 5.83333Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AdminIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 17.5H17.5M2.5 8.33333H17.5M4.16667 5L10 2.5L15.8333 5M3.33333 8.33333V17.5M16.6667 8.33333V17.5M6.66667 11.6667V14.1667M10 11.6667V14.1667M13.3333 11.6667V14.1667"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const HomeIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 17.5V12.5C7.5 12.058 7.67559 11.634 7.98816 11.3215C8.30072 11.0089 8.72464 10.8333 9.16667 10.8333H10.8333C11.2754 10.8333 11.6993 11.0089 12.0118 11.3215C12.3244 11.634 12.5 12.058 12.5 12.5V17.5M4.16667 10H2.5L10 2.5L17.5 10H15.8333V15.8333C15.8333 16.2754 15.6577 16.6993 15.3452 17.0118C15.0326 17.3244 14.6087 17.5 14.1667 17.5H5.83333C5.39131 17.5 4.96738 17.3244 4.65482 17.0118C4.34226 16.6993 4.16667 16.2754 4.16667 15.8333V10Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SmartInsightsIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3414 8.02425C14.2766 8.08911 14.2275 8.16974 14.2038 8.25824C13.9825 9.07358 13.5467 9.8186 12.9229 10.4254C12.0482 11.2765 11.4468 12.3816 11.1855 13.5758H7.98117C7.7199 12.3816 7.11855 11.2765 6.2438 10.4248L6.24198 10.4236C6.15772 10.3417 6.02436 10.3405 5.9407 10.4236L5.34178 11.0225C5.25873 11.1056 5.25812 11.2413 5.34178 11.3238C5.34663 11.328 5.35087 11.3329 5.35572 11.3371C6.03527 11.9985 6.49962 12.8381 6.71603 13.7468C6.25774 13.9917 5.94616 14.4748 5.94616 15.0301V16.3637C5.94616 17.167 6.59782 17.8186 7.40104 17.8186H7.76476V17.8792C7.76476 18.5491 8.30731 19.0916 8.97716 19.0916H10.1896C10.8594 19.0916 11.402 18.5491 11.402 17.8792V17.8186H11.7657C12.5689 17.8186 13.2206 17.167 13.2206 16.3637V15.0301C13.2206 14.4742 12.909 13.9917 12.4507 13.7462C12.6671 12.8375 13.1308 11.9979 13.8104 11.3371C14.9422 10.2357 15.6454 8.69652 15.6454 6.9925V6.99007C15.6454 6.89065 15.5247 6.84034 15.4544 6.91126L14.3414 8.02425Z"
      fill="#17B0AD"
    />
    <path
      d="M4.77134 6.16746C4.84045 6.09835 4.89076 6.01166 4.91259 5.91588C5.11203 5.03326 5.56062 4.22095 6.22198 3.56686C7.11006 2.68969 8.27942 2.19685 9.51486 2.17927C9.53789 2.17927 9.56093 2.17927 9.58336 2.17927C10.9249 2.17927 12.1385 2.73394 13.009 3.62627C13.092 3.71114 13.2278 3.71235 13.3115 3.62869L13.9128 3.02734C13.9953 2.9449 13.9959 2.81093 13.9141 2.72727C12.8138 1.60338 11.2801 0.90625 9.58336 0.90625C9.55426 0.90625 9.52577 0.90625 9.49667 0.90625C6.25956 0.951715 3.60623 3.57292 3.52318 6.80942C3.52015 6.92157 3.52075 7.03311 3.52378 7.14405C3.52682 7.24346 3.64806 7.29014 3.71777 7.22043L4.77074 6.16746H4.77134Z"
      fill="#17B0AD"
    />
    <path
      d="M17.1275 2.51268C16.6304 2.0156 15.8242 2.0156 15.3271 2.51268C14.9943 2.84548 14.8852 3.31711 14.9985 3.74145L11.4123 7.32772C11.1971 7.27014 10.9703 7.27014 10.7551 7.32772L9.31238 5.88436C9.42574 5.46002 9.31663 4.9884 8.98382 4.6556C8.48674 4.15851 7.68049 4.15851 7.18341 4.6556C6.85061 4.9884 6.74149 5.46002 6.85485 5.88436L3.26857 9.47064C2.84423 9.35728 2.37261 9.4664 2.03981 9.7992C1.54272 10.2963 1.54272 11.1025 2.03981 11.5996C2.53689 12.0967 3.34313 12.0967 3.84022 11.5996C4.17302 11.2668 4.28214 10.7952 4.16878 10.3708L7.75506 6.78457C7.97026 6.84216 8.19698 6.84216 8.41218 6.78457L9.85493 8.22732C9.74157 8.65166 9.85069 9.12329 10.1835 9.45609C10.6806 9.95318 11.4868 9.95318 11.9839 9.45609C12.3167 9.12329 12.4258 8.65166 12.3125 8.22732L15.8987 4.64105C16.3231 4.75441 16.7947 4.64529 17.1275 4.31249C17.6246 3.8154 17.6246 3.00916 17.1275 2.51207V2.51268Z"
      fill="#17B0AD"
    />
  </svg>
)

export const SmartDataIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4997 7.58466C16.2913 7.58466 15.6163 8.78466 15.8913 9.67633L12.933 12.643C12.683 12.568 12.3163 12.568 12.0663 12.643L9.94134 10.518C10.2247 9.62633 9.54967 8.41799 8.33301 8.41799C7.12467 8.41799 6.44134 9.618 6.72467 10.518L2.92467 14.3097C2.03301 14.0347 0.833008 14.7097 0.833008 15.918C0.833008 16.8347 1.58301 17.5847 2.49967 17.5847C3.70801 17.5847 4.38301 16.3847 4.10801 15.493L7.89967 11.693C8.14967 11.768 8.51634 11.768 8.76634 11.693L10.8913 13.818C10.608 14.7097 11.283 15.918 12.4997 15.918C13.708 15.918 14.3913 14.718 14.108 13.818L17.0747 10.8597C17.9663 11.1347 19.1663 10.4597 19.1663 9.25133C19.1663 8.33466 18.4163 7.58466 17.4997 7.58466Z"
      fill="#7EBD5F"
      stroke={color || 'currentColor'}
    />
    <path
      d="M12.4997 8.41797L13.283 6.69297L14.9997 5.91797L13.283 5.14297L12.4997 3.41797L11.733 5.14297L9.99967 5.91797L11.733 6.69297L12.4997 8.41797ZM2.91634 10.0846L3.33301 8.41797L4.99967 8.0013L3.33301 7.58463L2.91634 5.91797L2.49967 7.58463L0.833008 8.0013L2.49967 8.41797L2.91634 10.0846Z"
      fill="#7EBD5F"
      stroke={color || 'currentColor'}
    />
  </svg>
)

export const SmartFlowIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.89255 1.85647C4.96934 1.58865 5.12752 1.35373 5.34353 1.18672C5.55953 1.01971 5.82179 0.929556 6.09122 0.929688H11.5983C11.8004 0.929688 11.9994 0.98049 12.1784 1.07774C12.3574 1.17499 12.511 1.31579 12.626 1.48808C12.741 1.66037 12.814 1.859 12.8388 2.06696C12.8636 2.27493 12.8394 2.48602 12.7682 2.68216L11.5271 6.1145H14.0644C14.2409 6.11452 14.4138 6.16621 14.5632 6.26363C14.7127 6.36105 14.8325 6.50024 14.9091 6.66518C14.9856 6.83012 15.0157 7.01412 14.9958 7.196C14.9759 7.37788 14.907 7.55025 14.7968 7.69328L13.2157 9.75295L12.9282 9.1567C12.888 9.07388 12.842 8.99418 12.7907 8.91819C12.5504 8.54531 12.24 8.22652 11.8781 7.98087C11.5163 7.73521 11.1103 7.56775 10.6846 7.48848L10.6621 7.48459C10.2974 6.95929 9.7894 6.5593 9.2035 6.33615C8.61759 6.11301 7.98067 6.07695 7.37482 6.23261C6.76896 6.38827 6.22195 6.72852 5.80426 7.20951C5.38658 7.69051 5.11736 8.2902 5.03132 8.93131C4.94528 9.57241 5.04635 10.2256 5.3215 10.8065C5.59666 11.3875 6.03329 11.8698 6.57512 12.1911C7.11696 12.5124 7.73917 12.6581 8.36157 12.6093C8.98396 12.5606 9.57802 12.3197 10.0672 11.9176L10.1984 12.1924L10.2097 12.2131L10.6409 13.1075L6.53869 18.4518C5.47126 19.8413 3.33641 18.6942 3.81638 16.9884L5.41627 11.2993H3.43891C3.29281 11.2996 3.14868 11.2644 3.01802 11.1966C2.88736 11.1288 2.77379 11.0303 2.68637 10.9089C2.59894 10.7875 2.54009 10.6466 2.51449 10.4975C2.4889 10.3483 2.49728 10.195 2.53897 10.0498L4.89255 1.85647ZM9.8897 8.71728C9.73936 8.28594 9.44681 7.92361 9.06378 7.69431C8.68074 7.46502 8.23187 7.38354 7.7965 7.46426C7.36113 7.54498 6.9673 7.78272 6.68461 8.13545C6.40191 8.48817 6.24856 8.93318 6.25166 9.39182C6.25476 9.85047 6.4141 10.2932 6.70152 10.6418C6.98895 10.9904 7.38596 11.2224 7.82237 11.2968C8.25879 11.3712 8.70651 11.2832 9.08642 11.0483C9.46632 10.8135 9.75394 10.447 9.89845 10.0135C10.0159 10.0109 10.1197 10.0148 10.2334 10.0368C10.3307 10.0533 10.4237 10.0906 10.5063 10.1464C10.589 10.2022 10.6595 10.2753 10.7134 10.3609L11.9421 12.9066C12.0862 13.1599 12.2815 13.378 12.5145 13.5458C12.7475 13.7136 13.0127 13.8271 13.292 13.8788C13.4769 13.9151 13.6782 13.9254 13.8619 13.9254C14.0123 14.3568 14.3048 14.7191 14.6878 14.9484C15.0709 15.1777 15.5197 15.2592 15.9551 15.1785C16.3905 15.0977 16.7843 14.86 17.067 14.5073C17.3497 14.1545 17.503 13.7095 17.5 13.2509C17.4969 12.7922 17.3375 12.3495 17.0501 12.0009C16.7627 11.6523 16.3657 11.4203 15.9292 11.3459C15.4928 11.2715 15.0451 11.3595 14.6652 11.5944C14.2853 11.8292 13.9977 12.1957 13.8532 12.6292C13.741 12.6328 13.6288 12.6246 13.5182 12.6046C13.421 12.5883 13.3281 12.5511 13.2455 12.4956C13.1628 12.44 13.0923 12.3672 13.0382 12.2818L11.8096 9.7348C11.6654 9.48147 11.4701 9.26344 11.2371 9.09565C11.0041 8.92786 10.7389 8.81427 10.4597 8.76265C10.2713 8.73019 10.0806 8.71501 9.8897 8.71728ZM8.12607 8.73024C8.29182 8.73024 8.45078 8.79853 8.56798 8.92007C8.68519 9.04161 8.75103 9.20646 8.75103 9.37835C8.75103 9.55023 8.68519 9.71508 8.56798 9.83662C8.45078 9.95817 8.29182 10.0264 8.12607 10.0264C7.96033 10.0264 7.80137 9.95817 7.68416 9.83662C7.56696 9.71508 7.50112 9.55023 7.50112 9.37835C7.50112 9.20646 7.56696 9.04161 7.68416 8.92007C7.80137 8.79853 7.96033 8.73024 8.12607 8.73024ZM15.6255 12.6189C15.7913 12.6189 15.9502 12.6871 16.0675 12.8087C16.1847 12.9302 16.2505 13.0951 16.2505 13.267C16.2505 13.4388 16.1847 13.6037 16.0675 13.7252C15.9502 13.8468 15.7913 13.9151 15.6255 13.9151C15.4598 13.9151 15.3008 13.8468 15.1836 13.7252C15.0664 13.6037 15.0006 13.4388 15.0006 13.267C15.0006 13.0951 15.0664 12.9302 15.1836 12.8087C15.3008 12.6871 15.4598 12.6189 15.6255 12.6189Z"
      fill="#65B4E5"
      stroke={color || 'currentColor'}
    />
  </svg>
)

export const AllAppsIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6663 5.83203H16.6663M14.1663 3.33203V8.33203M3.33301 4.16536C3.33301 3.94435 3.42081 3.73239 3.57709 3.57611C3.73337 3.41983 3.94533 3.33203 4.16634 3.33203H7.49967C7.72069 3.33203 7.93265 3.41983 8.08893 3.57611C8.24521 3.73239 8.33301 3.94435 8.33301 4.16536V7.4987C8.33301 7.71971 8.24521 7.93167 8.08893 8.08795C7.93265 8.24423 7.72069 8.33203 7.49967 8.33203H4.16634C3.94533 8.33203 3.73337 8.24423 3.57709 8.08795C3.42081 7.93167 3.33301 7.71971 3.33301 7.4987V4.16536ZM3.33301 12.4987C3.33301 12.2777 3.42081 12.0657 3.57709 11.9094C3.73337 11.7532 3.94533 11.6654 4.16634 11.6654H7.49967C7.72069 11.6654 7.93265 11.7532 8.08893 11.9094C8.24521 12.0657 8.33301 12.2777 8.33301 12.4987V15.832C8.33301 16.053 8.24521 16.265 8.08893 16.4213C7.93265 16.5776 7.72069 16.6654 7.49967 16.6654H4.16634C3.94533 16.6654 3.73337 16.5776 3.57709 16.4213C3.42081 16.265 3.33301 16.053 3.33301 15.832V12.4987ZM11.6663 12.4987C11.6663 12.2777 11.7541 12.0657 11.9104 11.9094C12.0667 11.7532 12.2787 11.6654 12.4997 11.6654H15.833C16.054 11.6654 16.266 11.7532 16.4223 11.9094C16.5785 12.0657 16.6663 12.2777 16.6663 12.4987V15.832C16.6663 16.053 16.5785 16.265 16.4223 16.4213C16.266 16.5776 16.054 16.6654 15.833 16.6654H12.4997C12.2787 16.6654 12.0667 16.5776 11.9104 16.4213C11.7541 16.265 11.6663 16.053 11.6663 15.832V12.4987Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AdminDashIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 2.5V10H17.5M10 2.5C10.9849 2.5 11.9602 2.69399 12.8701 3.0709C13.7801 3.44781 14.6069 4.00026 15.3033 4.6967C15.9997 5.39314 16.5522 6.21993 16.9291 7.12987C17.306 8.03982 17.5 9.01509 17.5 10M10 2.5C9.01509 2.5 8.03982 2.69399 7.12987 3.0709C6.21993 3.44781 5.39314 4.00026 4.6967 4.6967C4.00026 5.39314 3.44781 6.21993 3.0709 7.12987C2.69399 8.03982 2.5 9.01509 2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TenantIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 17.5H17.5M7.5 6.66667H8.33333M7.5 10H8.33333M7.5 13.3333H8.33333M11.6667 6.66667H12.5M11.6667 10H12.5M11.6667 13.3333H12.5M4.16667 17.5V4.16667C4.16667 3.72464 4.34226 3.30072 4.65482 2.98816C4.96738 2.67559 5.39131 2.5 5.83333 2.5H14.1667C14.6087 2.5 15.0326 2.67559 15.3452 2.98816C15.6577 3.30072 15.8333 3.72464 15.8333 4.16667V17.5"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AuditIcon: React.FC<IconProps> = ({ color, size, strokeWidth, ...rest }) => (
  <svg
    width={size || '20'}
    height={size || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.17933 15.8333H5.00016C4.55814 15.8333 4.13421 15.6577 3.82165 15.3452C3.50909 15.0326 3.3335 14.6087 3.3335 14.1667V4.16667C3.3335 3.72464 3.50909 3.30072 3.82165 2.98816C4.13421 2.67559 4.55814 2.5 5.00016 2.5H11.6668C12.1089 2.5 12.5328 2.67559 12.8453 2.98816C13.1579 3.30072 13.3335 3.72464 13.3335 4.16667V10.8333M10.8335 15L12.5002 16.6667L15.8335 13.3333M6.66683 5.83333H10.0002M6.66683 9.16667H8.3335"
      stroke={color || 'currentColor'}
      strokeWidth={strokeWidth || '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CMSIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.91667 4.08333H9.925M6.58333 14.0833H3.25C2.58696 14.0833 1.95107 13.8199 1.48223 13.3511C1.01339 12.8823 0.75 12.2464 0.75 11.5833V3.25C0.75 2.58696 1.01339 1.95107 1.48223 1.48223C1.95107 1.01339 2.58696 0.75 3.25 0.75H11.5833C12.2464 0.75 12.8823 1.01339 13.3511 1.48223C13.8199 1.95107 14.0833 2.58696 14.0833 3.25V6.58333M0.75 9.91667L4.08333 6.58333C4.85667 5.83917 5.81 5.83917 6.58333 6.58333L9.08333 9.08333L9.91667 8.25C10.175 8.00167 10.4533 7.83583 10.7392 7.75333M12.7667 10.425C12.9292 10.2625 13.1221 10.1336 13.3344 10.0456C13.5468 9.95768 13.7743 9.91241 14.0042 9.91241C14.234 9.91241 14.4616 9.95768 14.6739 10.0456C14.8862 10.1336 15.0792 10.2625 15.2417 10.425C15.4042 10.5875 15.5331 10.7804 15.621 10.9928C15.709 11.2051 15.7543 11.4327 15.7543 11.6625C15.7543 11.8923 15.709 12.1199 15.621 12.3322C15.5331 12.5446 15.4042 12.7375 15.2417 12.9L12.4167 15.75H9.91667V13.25L12.7667 10.425Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ContributorIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    width="16.67"
    height="16.01"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.74951 19.6626V18.9596C4.74951 17.8987 5.17094 16.8813 5.92109 16.1311C6.67123 15.381 7.68865 14.9596 8.74951 14.9596H12.7495C13.8104 14.9596 14.8278 15.381 15.5779 16.1311C16.3281 16.8813 16.7495 17.8987 16.7495 18.9596V19.6666M11.9125 1.12755L19.9335 6.95555C20.6275 7.45955 20.9175 8.35255 20.6525 9.16755L17.5885 18.5976C17.4592 18.9947 17.2077 19.3407 16.8698 19.5863C16.532 19.8318 16.1251 19.9642 15.7075 19.9646H5.79151C5.37388 19.9642 4.96705 19.8318 4.62921 19.5863C4.29137 19.3407 4.03981 18.9947 3.91051 18.5976L0.846513 9.16755C0.71767 8.77014 0.717833 8.34216 0.846978 7.94485C0.976122 7.54754 1.22763 7.20126 1.56551 6.95555L9.58651 1.12755C9.92464 0.882155 10.3317 0.75 10.7495 0.75C11.1673 0.75 11.5744 0.882155 11.9125 1.12755ZM10.7495 11.9596C11.5452 11.9596 12.3082 11.6435 12.8708 11.0809C13.4334 10.5183 13.7495 9.7552 13.7495 8.95955C13.7495 8.16391 13.4334 7.40084 12.8708 6.83823C12.3082 6.27563 11.5452 5.95955 10.7495 5.95955C9.95386 5.95955 9.1908 6.27563 8.62819 6.83823C8.06558 7.40084 7.74951 8.16391 7.74951 8.95955C7.74951 9.7552 8.06558 10.5183 8.62819 11.0809C9.1908 11.6435 9.95386 11.9596 10.7495 11.9596Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ManageAgentIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
    <path
      d="M4.91667 11.5833C5.75 12.1389 6.58333 12.4167 7.41667 12.4167C8.66667 12.4167 9.08333 12.1392 9.91667 11.5833M4.91667 4.08333L4.08333 0.75M9.91667 4.08333L10.75 0.75M4.91667 8.25V7.41667M9.91667 8.25V7.41667M2.41667 2.41667H12.4167C12.8587 2.41667 13.2826 2.59226 13.5952 2.90482C13.9077 3.21738 14.0833 3.64131 14.0833 4.08333V14.0833C14.0833 14.5254 13.9077 14.9493 13.5952 15.2618C13.2826 15.5744 12.8587 15.75 12.4167 15.75H2.41667C1.97464 15.75 1.55072 15.5744 1.23816 15.2618C0.925595 14.9493 0.75 14.5254 0.75 14.0833V4.08333C0.75 3.64131 0.925595 3.21738 1.23816 2.90482C1.55072 2.59226 1.97464 2.41667 2.41667 2.41667Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FocusModeIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    width={size || 15}
    height={size || 15}
    viewBox={`0 0 ${size || 15} ${size || 15}`}
    fill="none"
    {...rest}>
    <path
      d="M0.75 4.08333H14.0833M0.75 2.41667C0.75 1.97464 0.925595 1.55072 1.23816 1.23816C1.55072 0.925595 1.97464 0.75 2.41667 0.75H12.4167C12.8587 0.75 13.2826 0.925595 13.5952 1.23816C13.9077 1.55072 14.0833 1.97464 14.0833 2.41667V12.4167C14.0833 12.8587 13.9077 13.2826 13.5952 13.5952C13.2826 13.9077 12.8587 14.0833 12.4167 14.0833H2.41667C1.97464 14.0833 1.55072 13.9077 1.23816 13.5952C0.925595 13.2826 0.75 12.8587 0.75 12.4167V2.41667Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const NotificationIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    width={size || 15}
    height={size || 17}
    viewBox={`0 0 ${size || 15} ${size || 17}`}
    fill="none"
    {...rest}>
    <path
      d="M4.91667 12.4167V13.25C4.91667 13.913 5.18006 14.5489 5.6489 15.0178C6.11774 15.4866 6.75363 15.75 7.41667 15.75C8.07971 15.75 8.71559 15.4866 9.18443 15.0178C9.65327 14.5489 9.91667 13.913 9.91667 13.25V12.4167M5.75 2.41667C5.75 1.97464 5.92559 1.55072 6.23816 1.23816C6.55072 0.925595 6.97464 0.75 7.41667 0.75C7.85869 0.75 8.28262 0.925595 8.59518 1.23816C8.90774 1.55072 9.08333 1.97464 9.08333 2.41667C10.0403 2.86919 10.8562 3.57361 11.4434 4.45442C12.0306 5.33523 12.367 6.35923 12.4167 7.41667V9.91667C12.4794 10.4348 12.6629 10.9309 12.9523 11.3651C13.2418 11.7993 13.6292 12.1595 14.0833 12.4167H0.75C1.20412 12.1595 1.59151 11.7993 1.88099 11.3651C2.17047 10.9309 2.35395 10.4348 2.41667 9.91667V7.41667C2.4663 6.35923 2.80275 5.33523 3.38996 4.45442C3.97717 3.57361 4.79299 2.86919 5.75 2.41667Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="11" cy="3" r="3" fill="#EB5C37" />
  </svg>
)

export const ExitFocusIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M0.75 4.08333H14.0833M9.08333 10.75L5.75 7.41667M5.75 10.75L9.08333 7.41667M0.75 2.41667C0.75 1.97464 0.925595 1.55072 1.23816 1.23816C1.55072 0.925595 1.97464 0.75 2.41667 0.75H12.4167C12.8587 0.75 13.2826 0.925595 13.5952 1.23816C13.9077 1.55072 14.0833 1.97464 14.0833 2.41667V12.4167C14.0833 12.8587 13.9077 13.2826 13.5952 13.5952C13.2826 13.9077 12.8587 14.0833 12.4167 14.0833H2.41667C1.97464 14.0833 1.55072 13.9077 1.23816 13.5952C0.925595 13.2826 0.75 12.8587 0.75 12.4167V2.41667Z"
      stroke={color || 'var(--icon-muted)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const InvalidFileIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#E3E3E3"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28552 0V5.86141H14.9582L9.28552 0Z"
      fill="white"
    />
    <path
      d="M9.97925 10L4.97925 15M4.97925 10L9.97925 15"
      stroke="#878295"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TxtFileIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.60369 0H9.29034L14.9575 5.90705V17.3963C14.9575 18.8356 13.7931 20 12.3588 20H2.60369C1.16441 20 4.11296e-10 18.8356 4.11296e-10 17.3963V2.60369C-2.52695e-05 1.16441 1.16439 0 2.60369 0Z"
      fill="#251D36"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.2854 0V5.86207H14.9576L9.2854 0Z"
      fill="white"
    />
    <path
      d="M3.77813 14.6019V11.7584H2.73865V10.9688H5.74216V11.7584H4.70768V14.6019H3.77813ZM9.12047 14.6019H8.14596L7.48129 13.4875L6.81661 14.6019H5.8371L6.99153 12.6629L5.98205 10.9688H6.95656L7.48129 11.8483L8.00104 10.9688H8.98055L7.97107 12.6679L9.12047 14.6019ZM10.2499 14.6019V11.7584H9.21541V10.9688H12.2189V11.7584H11.1794V14.6019H10.2499Z"
      fill="white"
    />
  </svg>
)

export const XlsxFileIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59853 0H9.29196L14.9562 5.91241V17.3942C14.9562 18.8321 13.7956 20 12.3577 20H2.59853C1.16788 20 4.10068e-10 18.8321 4.10068e-10 17.3942V2.59853C-2.52695e-05 1.16788 1.16788 0 2.59853 0Z"
      fill="#00733B"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28467 0V5.86131H14.9562L9.28467 0Z"
      fill="white"
    />
    <path
      d="M6.21901 14.5621H5.24822L4.58399 13.4454L3.91975 14.5621H2.94165L4.09495 12.6205L3.08036 10.9344H4.05843L4.58397 11.8103L5.10221 10.9344H6.0803L5.07299 12.6278L6.21901 14.5621ZM6.56208 14.5621V10.9344H7.48908V13.7738H9.06572V14.5621H6.56208V14.5621ZM10.5986 14.6059C10.2336 14.6059 9.91244 14.4891 9.63508 14.2629C9.36499 14.0439 9.21173 13.7665 9.18982 13.4381L9.98545 13.2045C10.0074 13.3797 10.0803 13.533 10.2044 13.6497C10.3358 13.7665 10.4818 13.8249 10.6424 13.8249C10.7738 13.8249 10.8833 13.7957 10.9708 13.7373C11.0511 13.6789 11.0949 13.5987 11.0949 13.5038C11.0949 13.4235 11.0584 13.3578 10.9927 13.2994C10.927 13.2483 10.8394 13.2045 10.7373 13.168C10.6351 13.1315 10.511 13.095 10.3869 13.0658C10.2555 13.0293 10.1241 12.9855 10 12.9271C9.86865 12.876 9.75185 12.8103 9.64966 12.7301C9.54016 12.657 9.45988 12.5476 9.39418 12.4089C9.32848 12.2775 9.29199 12.1169 9.29199 11.9344C9.29199 11.6352 9.41606 11.387 9.67154 11.1899C9.92702 10.9855 10.2336 10.8906 10.5912 10.8906C10.9489 10.8906 11.2628 10.9782 11.5255 11.1461C11.7883 11.3213 11.9562 11.5476 12.0219 11.8249L11.1898 12.1753C11.1533 12.022 11.0803 11.8979 10.9781 11.803C10.8759 11.7155 10.7445 11.6644 10.5912 11.6644C10.4744 11.6644 10.3869 11.6936 10.3139 11.7374C10.2482 11.7812 10.219 11.8469 10.219 11.9271C10.219 12.0002 10.2628 12.0658 10.3504 12.1169C10.438 12.1607 10.5548 12.1972 10.6861 12.2191C10.8175 12.241 10.9635 12.2775 11.1168 12.3286C11.2774 12.387 11.4161 12.4454 11.5547 12.5257C11.6861 12.5987 11.7956 12.7228 11.8832 12.8834C11.9781 13.0513 12.0219 13.2483 12.0219 13.4746C12.0219 13.8104 11.8905 14.0878 11.6277 14.2921C11.3649 14.4965 11.0219 14.6059 10.5986 14.6059Z"
      fill="white"
    />
  </svg>
)

export const DocxFileIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none">
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#0263D1"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28552 0V5.86141H14.9582L9.28552 0Z"
      fill="white"
    />
    <path
      d="M2.41577 14.2705V10.9596H3.5886C3.82316 10.9596 4.04156 10.9947 4.24377 11.0594C4.44598 11.1268 4.62932 11.2239 4.7938 11.3533C4.95826 11.4827 5.08769 11.6553 5.18205 11.8709C5.27641 12.0866 5.32495 12.3347 5.32495 12.6151C5.32495 12.8955 5.27641 13.1435 5.18205 13.3592C5.08769 13.5749 4.95826 13.7474 4.7938 13.8768C4.62934 14.0062 4.44598 14.1033 4.24377 14.1707C4.04156 14.2354 3.82318 14.2705 3.5886 14.2705H2.41577ZM3.24349 13.5506H3.48883C3.62095 13.5506 3.74497 13.5345 3.8555 13.5048C3.96874 13.4724 4.07118 13.4212 4.16824 13.3538C4.2653 13.2864 4.34079 13.1893 4.39471 13.0626C4.45134 12.9386 4.47828 12.7876 4.47828 12.6151C4.47828 12.4425 4.45132 12.2915 4.39471 12.1648C4.34079 12.0408 4.2653 11.9437 4.16824 11.8763C4.07118 11.8062 3.96874 11.7577 3.8555 11.7253C3.74497 11.6957 3.62095 11.6795 3.48883 11.6795H3.24349V13.5506ZM7.33356 14.3082C6.83478 14.3082 6.42227 14.1465 6.09604 13.8256C5.7698 13.5048 5.60802 13.1004 5.60802 12.6151C5.60802 12.1298 5.7698 11.7254 6.09604 11.4045C6.42227 11.0837 6.83478 10.9219 7.33356 10.9219C7.82425 10.9219 8.23137 11.0837 8.55761 11.4045C8.88114 11.7254 9.04291 12.1298 9.04291 12.6151C9.04291 13.1004 8.88114 13.5048 8.55761 13.8256C8.23137 14.1465 7.82425 14.3082 7.33356 14.3082ZM6.69726 13.3134C6.86172 13.4967 7.07201 13.5884 7.32815 13.5884C7.58428 13.5884 7.79188 13.4967 7.95636 13.3134C8.12082 13.1273 8.2017 12.8955 8.2017 12.6151C8.2017 12.3347 8.12082 12.1028 7.95636 11.9168C7.7919 11.7334 7.58428 11.6417 7.32815 11.6417C7.07201 11.6417 6.86172 11.7334 6.69726 11.9168C6.5328 12.1028 6.44921 12.3347 6.44921 12.6151C6.44921 12.8955 6.5328 13.1273 6.69726 13.3134ZM11.0111 14.3082C10.5285 14.3082 10.1267 14.1573 9.80862 13.8607C9.48777 13.5614 9.32872 13.1462 9.32872 12.6151C9.32872 12.0866 9.4905 11.6714 9.81403 11.3721C10.1403 11.0729 10.5366 10.9219 11.0111 10.9219C11.4398 10.9219 11.7903 11.027 12.068 11.24C12.343 11.4503 12.5021 11.7307 12.5425 12.0812L11.7067 12.2511C11.6717 12.0677 11.5881 11.9195 11.4587 11.8089C11.3293 11.6983 11.1783 11.6417 11.0057 11.6417C10.7684 11.6417 10.5716 11.7253 10.4125 11.8952C10.2535 12.0677 10.1726 12.305 10.1726 12.615C10.1726 12.9251 10.2535 13.1624 10.4098 13.3322C10.5689 13.5048 10.7657 13.5884 11.0057 13.5884C11.1782 13.5884 11.3265 13.5398 11.4479 13.4428C11.5692 13.3457 11.6447 13.2163 11.677 13.0545L12.5317 13.2487C12.4535 13.583 12.281 13.8418 12.0113 14.0278C11.7444 14.2139 11.4101 14.3082 11.0111 14.3082Z"
      fill="white"
    />
  </svg>
)

export const CsvFileIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.60465 0H9.29386L14.9598 5.9112V17.3953C14.9598 18.833 13.7928 20 12.3552 20H2.60465C1.16702 20 0 18.833 0 17.3953V2.60465C0 1.16702 1.16702 0 2.60465 0Z"
      fill="#00733B"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.2854 0V5.86045H14.9598L9.2854 0Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.40588 14.6729H7.06127V15.6793H4.40588V14.6729ZM7.89003 9.53125H10.5539V10.5291H7.89003V9.53125ZM4.40588 9.53125H7.06127V10.5291H4.40588V9.53125ZM7.89003 11.2226H10.5539V12.2289H7.89003V11.2226ZM4.40588 11.2226H7.06127V12.2289H4.40588V11.2226ZM7.89003 12.9816H10.5539V13.9879H7.89003V12.9816ZM4.40588 12.9816H7.06127V13.9879H4.40588V12.9816ZM7.89003 14.6729H10.5539V15.6793H7.89003V14.6729Z"
      fill="white"
    />
  </svg>
)

export const PdfFileIcon: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.60369 0H9.29034L14.9575 5.90705V17.3963C14.9575 18.8356 13.7931 20 12.3588 20H2.60369C1.16441 20 4.11296e-10 18.8356 4.11296e-10 17.3963V2.60369C-2.52695e-05 1.16441 1.16439 0 2.60369 0Z"
      fill="#E5252A"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.2854 0V5.86207H14.9576L9.2854 0Z"
      fill="white"
    />
    <path
      d="M2.89355 14.9227V11.2695H4.44778C4.83259 11.2695 5.13745 11.3745 5.36733 11.5894C5.59721 11.7993 5.71216 12.0841 5.71216 12.4389C5.71216 12.7938 5.59721 13.0786 5.36733 13.2885C5.13745 13.5034 4.83259 13.6084 4.44778 13.6084H3.82809V14.9227H2.89355ZM3.82809 12.8138H4.34284C4.48276 12.8138 4.59271 12.7838 4.66768 12.7138C4.74263 12.6489 4.78263 12.5589 4.78263 12.439C4.78263 12.319 4.74266 12.2291 4.66768 12.1641C4.59273 12.0941 4.48278 12.0642 4.34284 12.0642H3.82809V12.8138ZM6.09695 14.9227V11.2695H7.3913C7.64617 11.2695 7.88606 11.3045 8.11094 11.3795C8.33582 11.4544 8.54073 11.5594 8.72063 11.7043C8.90055 11.8442 9.04547 12.0341 9.15042 12.274C9.25036 12.5139 9.30535 12.7888 9.30535 13.0986C9.30535 13.4035 9.25039 13.6783 9.15042 13.9182C9.04547 14.1581 8.90055 14.348 8.72063 14.4879C8.54071 14.6328 8.33582 14.7378 8.11094 14.8128C7.88606 14.8877 7.64617 14.9227 7.3913 14.9227H6.09695ZM7.01149 14.1281H7.28135C7.42628 14.1281 7.56122 14.1131 7.68615 14.0781C7.80608 14.0432 7.92104 13.9882 8.03098 13.9132C8.13593 13.8383 8.22089 13.7333 8.28085 13.5934C8.34082 13.4535 8.37082 13.2885 8.37082 13.0986C8.37082 12.9037 8.34082 12.7388 8.28085 12.5989C8.22089 12.459 8.13593 12.354 8.03098 12.279C7.92104 12.2041 7.80611 12.1491 7.68615 12.1141C7.56122 12.0792 7.42628 12.0641 7.28135 12.0641H7.01149V14.1281ZM9.77512 14.9227V11.2695H12.3738V12.0641H10.7096V12.6488H12.039V13.4385H10.7096V14.9227H9.77512Z"
      fill="white"
    />
  </svg>
)
